/* Schema types (enums/inputs) only. Operations live in src/client/gql (client-preset). Run `pnpm run generate`. */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date, represented as a 'yyyy-mm-dd' string */
  Date: { input: any; output: any };
  /** A date and time, represented as an ISO-8601 string */
  DateTime: { input: any; output: any };
};

export type AccountAccessMutationResponse = {
  __typename?: "AccountAccessMutationResponse";
  users: Array<MinimalUser>;
};

export type Application = {
  __typename?: "Application";
  accessGrantedOrganizations: Array<Organization>;
  accessGrantedOrganizationsConnection: ApplicationAccessGrantedOrganizationsConnection;
  accessGrantedProfiles: Array<Profile>;
  accessGrantedProfilesConnection: ApplicationAccessGrantedProfilesConnection;
  clientId: Scalars["ID"]["output"];
  licensedOrganizations: Array<Organization>;
  licensedOrganizationsConnection: ApplicationLicensedOrganizationsConnection;
  name: Scalars["String"]["output"];
  uri?: Maybe<Scalars["String"]["output"]>;
  uuid: Scalars["ID"]["output"];
};

export type ApplicationAccessGrantedOrganizationsArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ApplicationAccessGrantedOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsConnectionSort>>;
  where?: InputMaybe<ApplicationAccessGrantedOrganizationsConnectionWhere>;
};

export type ApplicationAccessGrantedProfilesArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type ApplicationAccessGrantedProfilesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<ApplicationAccessGrantedProfilesConnectionSort>>;
  where?: InputMaybe<ApplicationAccessGrantedProfilesConnectionWhere>;
};

export type ApplicationLicensedOrganizationsArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ApplicationLicensedOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<ApplicationLicensedOrganizationsConnectionSort>>;
  where?: InputMaybe<ApplicationLicensedOrganizationsConnectionWhere>;
};

export type ApplicationAccessGrantedOrganizationsAggregateInput = {
  AND?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsAggregateInput>>;
  NOT?: InputMaybe<ApplicationAccessGrantedOrganizationsAggregateInput>;
  OR?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<ApplicationAccessGrantedOrganizationsNodeAggregationWhereInput>;
};

export type ApplicationAccessGrantedOrganizationsConnectFieldInput = {
  connect?: InputMaybe<Array<OrganizationConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ApplicationAccessGrantedOrganizationsConnection = {
  __typename?: "ApplicationAccessGrantedOrganizationsConnection";
  edges: Array<ApplicationAccessGrantedOrganizationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ApplicationAccessGrantedOrganizationsConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type ApplicationAccessGrantedOrganizationsConnectionWhere = {
  AND?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsConnectionWhere>>;
  NOT?: InputMaybe<ApplicationAccessGrantedOrganizationsConnectionWhere>;
  OR?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ApplicationAccessGrantedOrganizationsCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type ApplicationAccessGrantedOrganizationsDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ApplicationAccessGrantedOrganizationsConnectionWhere>;
};

export type ApplicationAccessGrantedOrganizationsDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ApplicationAccessGrantedOrganizationsConnectionWhere>;
};

export type ApplicationAccessGrantedOrganizationsFieldInput = {
  connect?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsConnectFieldInput>>;
  create?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsCreateFieldInput>>;
};

export type ApplicationAccessGrantedOrganizationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ApplicationAccessGrantedOrganizationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ApplicationAccessGrantedOrganizationsRelationship = {
  __typename?: "ApplicationAccessGrantedOrganizationsRelationship";
  cursor: Scalars["String"]["output"];
  node: Organization;
};

export type ApplicationAccessGrantedOrganizationsUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ApplicationAccessGrantedOrganizationsUpdateFieldInput = {
  connect?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsConnectFieldInput>>;
  create?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsCreateFieldInput>>;
  delete?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ApplicationAccessGrantedOrganizationsDisconnectFieldInput>>;
  update?: InputMaybe<ApplicationAccessGrantedOrganizationsUpdateConnectionInput>;
  where?: InputMaybe<ApplicationAccessGrantedOrganizationsConnectionWhere>;
};

export type ApplicationAccessGrantedProfilesAggregateInput = {
  AND?: InputMaybe<Array<ApplicationAccessGrantedProfilesAggregateInput>>;
  NOT?: InputMaybe<ApplicationAccessGrantedProfilesAggregateInput>;
  OR?: InputMaybe<Array<ApplicationAccessGrantedProfilesAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<ApplicationAccessGrantedProfilesNodeAggregationWhereInput>;
};

export type ApplicationAccessGrantedProfilesConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type ApplicationAccessGrantedProfilesConnection = {
  __typename?: "ApplicationAccessGrantedProfilesConnection";
  edges: Array<ApplicationAccessGrantedProfilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ApplicationAccessGrantedProfilesConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type ApplicationAccessGrantedProfilesConnectionWhere = {
  AND?: InputMaybe<Array<ApplicationAccessGrantedProfilesConnectionWhere>>;
  NOT?: InputMaybe<ApplicationAccessGrantedProfilesConnectionWhere>;
  OR?: InputMaybe<Array<ApplicationAccessGrantedProfilesConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type ApplicationAccessGrantedProfilesCreateFieldInput = {
  node: ProfileCreateInput;
};

export type ApplicationAccessGrantedProfilesDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ApplicationAccessGrantedProfilesConnectionWhere>;
};

export type ApplicationAccessGrantedProfilesDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<ApplicationAccessGrantedProfilesConnectionWhere>;
};

export type ApplicationAccessGrantedProfilesFieldInput = {
  connect?: InputMaybe<Array<ApplicationAccessGrantedProfilesConnectFieldInput>>;
  create?: InputMaybe<Array<ApplicationAccessGrantedProfilesCreateFieldInput>>;
};

export type ApplicationAccessGrantedProfilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ApplicationAccessGrantedProfilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ApplicationAccessGrantedProfilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ApplicationAccessGrantedProfilesNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosAccepted_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ApplicationAccessGrantedProfilesRelationship = {
  __typename?: "ApplicationAccessGrantedProfilesRelationship";
  cursor: Scalars["String"]["output"];
  node: Profile;
};

export type ApplicationAccessGrantedProfilesUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type ApplicationAccessGrantedProfilesUpdateFieldInput = {
  connect?: InputMaybe<Array<ApplicationAccessGrantedProfilesConnectFieldInput>>;
  create?: InputMaybe<Array<ApplicationAccessGrantedProfilesCreateFieldInput>>;
  delete?: InputMaybe<Array<ApplicationAccessGrantedProfilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ApplicationAccessGrantedProfilesDisconnectFieldInput>>;
  update?: InputMaybe<ApplicationAccessGrantedProfilesUpdateConnectionInput>;
  where?: InputMaybe<ApplicationAccessGrantedProfilesConnectionWhere>;
};

export type ApplicationAggregateSelection = {
  __typename?: "ApplicationAggregateSelection";
  clientId: IdAggregateSelection;
  count: Scalars["Int"]["output"];
  name: StringAggregateSelection;
  uri: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ApplicationCreateInput = {
  accessGrantedOrganizations?: InputMaybe<ApplicationAccessGrantedOrganizationsFieldInput>;
  accessGrantedProfiles?: InputMaybe<ApplicationAccessGrantedProfilesFieldInput>;
  clientId: Scalars["ID"]["input"];
  licensedOrganizations?: InputMaybe<ApplicationLicensedOrganizationsFieldInput>;
  name: Scalars["String"]["input"];
  uri?: InputMaybe<Scalars["String"]["input"]>;
};

export type ApplicationDeleteInput = {
  accessGrantedOrganizations?: InputMaybe<
    Array<ApplicationAccessGrantedOrganizationsDeleteFieldInput>
  >;
  accessGrantedProfiles?: InputMaybe<Array<ApplicationAccessGrantedProfilesDeleteFieldInput>>;
  licensedOrganizations?: InputMaybe<Array<ApplicationLicensedOrganizationsDeleteFieldInput>>;
};

export type ApplicationEdge = {
  __typename?: "ApplicationEdge";
  cursor: Scalars["String"]["output"];
  node: Application;
};

export type ApplicationLicensedOrganizationsAggregateInput = {
  AND?: InputMaybe<Array<ApplicationLicensedOrganizationsAggregateInput>>;
  NOT?: InputMaybe<ApplicationLicensedOrganizationsAggregateInput>;
  OR?: InputMaybe<Array<ApplicationLicensedOrganizationsAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  edge?: InputMaybe<LicensePropertiesAggregationWhereInput>;
  node?: InputMaybe<ApplicationLicensedOrganizationsNodeAggregationWhereInput>;
};

export type ApplicationLicensedOrganizationsConnectFieldInput = {
  connect?: InputMaybe<Array<OrganizationConnectInput>>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ApplicationLicensedOrganizationsConnection = {
  __typename?: "ApplicationLicensedOrganizationsConnection";
  edges: Array<ApplicationLicensedOrganizationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ApplicationLicensedOrganizationsConnectionSort = {
  edge?: InputMaybe<LicensePropertiesSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type ApplicationLicensedOrganizationsConnectionWhere = {
  AND?: InputMaybe<Array<ApplicationLicensedOrganizationsConnectionWhere>>;
  NOT?: InputMaybe<ApplicationLicensedOrganizationsConnectionWhere>;
  OR?: InputMaybe<Array<ApplicationLicensedOrganizationsConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ApplicationLicensedOrganizationsCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationCreateInput;
};

export type ApplicationLicensedOrganizationsDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ApplicationLicensedOrganizationsConnectionWhere>;
};

export type ApplicationLicensedOrganizationsDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ApplicationLicensedOrganizationsConnectionWhere>;
};

export type ApplicationLicensedOrganizationsFieldInput = {
  connect?: InputMaybe<Array<ApplicationLicensedOrganizationsConnectFieldInput>>;
  create?: InputMaybe<Array<ApplicationLicensedOrganizationsCreateFieldInput>>;
};

export type ApplicationLicensedOrganizationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ApplicationLicensedOrganizationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ApplicationLicensedOrganizationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ApplicationLicensedOrganizationsNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ApplicationLicensedOrganizationsRelationship = {
  __typename?: "ApplicationLicensedOrganizationsRelationship";
  cursor: Scalars["String"]["output"];
  node: Organization;
  properties: LicenseProperties;
};

export type ApplicationLicensedOrganizationsUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ApplicationLicensedOrganizationsUpdateFieldInput = {
  connect?: InputMaybe<Array<ApplicationLicensedOrganizationsConnectFieldInput>>;
  create?: InputMaybe<Array<ApplicationLicensedOrganizationsCreateFieldInput>>;
  delete?: InputMaybe<Array<ApplicationLicensedOrganizationsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ApplicationLicensedOrganizationsDisconnectFieldInput>>;
  update?: InputMaybe<ApplicationLicensedOrganizationsUpdateConnectionInput>;
  where?: InputMaybe<ApplicationLicensedOrganizationsConnectionWhere>;
};

export type ApplicationOptions = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Specify one or more ApplicationSort objects to sort Applications by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ApplicationSort>>;
};

/** Fields to sort Applications by. The order in which sorts are applied is not guaranteed when specifying many fields in one ApplicationSort object. */
export type ApplicationSort = {
  clientId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  uri?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type ApplicationUpdateInput = {
  accessGrantedOrganizations?: InputMaybe<
    Array<ApplicationAccessGrantedOrganizationsUpdateFieldInput>
  >;
  accessGrantedProfiles?: InputMaybe<Array<ApplicationAccessGrantedProfilesUpdateFieldInput>>;
  clientId?: InputMaybe<Scalars["ID"]["input"]>;
  licensedOrganizations?: InputMaybe<Array<ApplicationLicensedOrganizationsUpdateFieldInput>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  uri?: InputMaybe<Scalars["String"]["input"]>;
};

export type ApplicationWhere = {
  AND?: InputMaybe<Array<ApplicationWhere>>;
  NOT?: InputMaybe<ApplicationWhere>;
  OR?: InputMaybe<Array<ApplicationWhere>>;
  /** @deprecated Use `accessGrantedOrganizations_SOME` instead. */
  accessGrantedOrganizations?: InputMaybe<OrganizationWhere>;
  accessGrantedOrganizationsAggregate?: InputMaybe<ApplicationAccessGrantedOrganizationsAggregateInput>;
  /** @deprecated Use `accessGrantedOrganizationsConnection_SOME` instead. */
  accessGrantedOrganizationsConnection?: InputMaybe<ApplicationAccessGrantedOrganizationsConnectionWhere>;
  /** Return Applications where all of the related ApplicationAccessGrantedOrganizationsConnections match this filter */
  accessGrantedOrganizationsConnection_ALL?: InputMaybe<ApplicationAccessGrantedOrganizationsConnectionWhere>;
  /** Return Applications where none of the related ApplicationAccessGrantedOrganizationsConnections match this filter */
  accessGrantedOrganizationsConnection_NONE?: InputMaybe<ApplicationAccessGrantedOrganizationsConnectionWhere>;
  /** @deprecated Use `accessGrantedOrganizationsConnection_NONE` instead. */
  accessGrantedOrganizationsConnection_NOT?: InputMaybe<ApplicationAccessGrantedOrganizationsConnectionWhere>;
  /** Return Applications where one of the related ApplicationAccessGrantedOrganizationsConnections match this filter */
  accessGrantedOrganizationsConnection_SINGLE?: InputMaybe<ApplicationAccessGrantedOrganizationsConnectionWhere>;
  /** Return Applications where some of the related ApplicationAccessGrantedOrganizationsConnections match this filter */
  accessGrantedOrganizationsConnection_SOME?: InputMaybe<ApplicationAccessGrantedOrganizationsConnectionWhere>;
  /** Return Applications where all of the related Organizations match this filter */
  accessGrantedOrganizations_ALL?: InputMaybe<OrganizationWhere>;
  /** Return Applications where none of the related Organizations match this filter */
  accessGrantedOrganizations_NONE?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `accessGrantedOrganizations_NONE` instead. */
  accessGrantedOrganizations_NOT?: InputMaybe<OrganizationWhere>;
  /** Return Applications where one of the related Organizations match this filter */
  accessGrantedOrganizations_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return Applications where some of the related Organizations match this filter */
  accessGrantedOrganizations_SOME?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `accessGrantedProfiles_SOME` instead. */
  accessGrantedProfiles?: InputMaybe<ProfileWhere>;
  accessGrantedProfilesAggregate?: InputMaybe<ApplicationAccessGrantedProfilesAggregateInput>;
  /** @deprecated Use `accessGrantedProfilesConnection_SOME` instead. */
  accessGrantedProfilesConnection?: InputMaybe<ApplicationAccessGrantedProfilesConnectionWhere>;
  /** Return Applications where all of the related ApplicationAccessGrantedProfilesConnections match this filter */
  accessGrantedProfilesConnection_ALL?: InputMaybe<ApplicationAccessGrantedProfilesConnectionWhere>;
  /** Return Applications where none of the related ApplicationAccessGrantedProfilesConnections match this filter */
  accessGrantedProfilesConnection_NONE?: InputMaybe<ApplicationAccessGrantedProfilesConnectionWhere>;
  /** @deprecated Use `accessGrantedProfilesConnection_NONE` instead. */
  accessGrantedProfilesConnection_NOT?: InputMaybe<ApplicationAccessGrantedProfilesConnectionWhere>;
  /** Return Applications where one of the related ApplicationAccessGrantedProfilesConnections match this filter */
  accessGrantedProfilesConnection_SINGLE?: InputMaybe<ApplicationAccessGrantedProfilesConnectionWhere>;
  /** Return Applications where some of the related ApplicationAccessGrantedProfilesConnections match this filter */
  accessGrantedProfilesConnection_SOME?: InputMaybe<ApplicationAccessGrantedProfilesConnectionWhere>;
  /** Return Applications where all of the related Profiles match this filter */
  accessGrantedProfiles_ALL?: InputMaybe<ProfileWhere>;
  /** Return Applications where none of the related Profiles match this filter */
  accessGrantedProfiles_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `accessGrantedProfiles_NONE` instead. */
  accessGrantedProfiles_NOT?: InputMaybe<ProfileWhere>;
  /** Return Applications where one of the related Profiles match this filter */
  accessGrantedProfiles_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return Applications where some of the related Profiles match this filter */
  accessGrantedProfiles_SOME?: InputMaybe<ProfileWhere>;
  clientId?: InputMaybe<Scalars["ID"]["input"]>;
  clientId_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  clientId_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  clientId_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  clientId_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Use `licensedOrganizations_SOME` instead. */
  licensedOrganizations?: InputMaybe<OrganizationWhere>;
  licensedOrganizationsAggregate?: InputMaybe<ApplicationLicensedOrganizationsAggregateInput>;
  /** @deprecated Use `licensedOrganizationsConnection_SOME` instead. */
  licensedOrganizationsConnection?: InputMaybe<ApplicationLicensedOrganizationsConnectionWhere>;
  /** Return Applications where all of the related ApplicationLicensedOrganizationsConnections match this filter */
  licensedOrganizationsConnection_ALL?: InputMaybe<ApplicationLicensedOrganizationsConnectionWhere>;
  /** Return Applications where none of the related ApplicationLicensedOrganizationsConnections match this filter */
  licensedOrganizationsConnection_NONE?: InputMaybe<ApplicationLicensedOrganizationsConnectionWhere>;
  /** @deprecated Use `licensedOrganizationsConnection_NONE` instead. */
  licensedOrganizationsConnection_NOT?: InputMaybe<ApplicationLicensedOrganizationsConnectionWhere>;
  /** Return Applications where one of the related ApplicationLicensedOrganizationsConnections match this filter */
  licensedOrganizationsConnection_SINGLE?: InputMaybe<ApplicationLicensedOrganizationsConnectionWhere>;
  /** Return Applications where some of the related ApplicationLicensedOrganizationsConnections match this filter */
  licensedOrganizationsConnection_SOME?: InputMaybe<ApplicationLicensedOrganizationsConnectionWhere>;
  /** Return Applications where all of the related Organizations match this filter */
  licensedOrganizations_ALL?: InputMaybe<OrganizationWhere>;
  /** Return Applications where none of the related Organizations match this filter */
  licensedOrganizations_NONE?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `licensedOrganizations_NONE` instead. */
  licensedOrganizations_NOT?: InputMaybe<OrganizationWhere>;
  /** Return Applications where one of the related Organizations match this filter */
  licensedOrganizations_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return Applications where some of the related Organizations match this filter */
  licensedOrganizations_SOME?: InputMaybe<OrganizationWhere>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  name_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  name_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  uri?: InputMaybe<Scalars["String"]["input"]>;
  uri_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  uri_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  uri_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uri_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uri_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uri_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uri_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uri_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  uri_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  uuid?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ApplicationsConnection = {
  __typename?: "ApplicationsConnection";
  edges: Array<ApplicationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** Used internally by pim-auth-server, not to be exposed! */
export type AuditEvent = {
  __typename?: "AuditEvent";
  action: Scalars["String"]["output"];
  actorId?: Maybe<Scalars["String"]["output"]>;
  actorType?: Maybe<Scalars["String"]["output"]>;
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /**
   * Login interaction the event belongs to (oidc-provider cid). A successful
   * step with a loginCid but no sessionUid is an unfinished login.
   */
  loginCid?: Maybe<Scalars["String"]["output"]>;
  metadata?: Maybe<Scalars["String"]["output"]>;
  occurredAt: Scalars["DateTime"]["output"];
  /**
   * Session the event belongs to (oidc-provider session uid) — groups an
   * account's activity into sessions, as the auth-server's Kontoaktivität does.
   */
  sessionUid?: Maybe<Scalars["String"]["output"]>;
  source: Scalars["String"]["output"];
  targetId?: Maybe<Scalars["String"]["output"]>;
  targetType?: Maybe<Scalars["String"]["output"]>;
  tenantId?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<User>;
  userConnection: AuditEventUserConnection;
};

/** Used internally by pim-auth-server, not to be exposed! */
export type AuditEventUserArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};

/** Used internally by pim-auth-server, not to be exposed! */
export type AuditEventUserConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<AuditEventUserConnectionSort>>;
  where?: InputMaybe<AuditEventUserConnectionWhere>;
};

export type AuditEventUserConnection = {
  __typename?: "AuditEventUserConnection";
  edges: Array<AuditEventUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type AuditEventUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AuditEventUserConnectionWhere = {
  AND?: InputMaybe<Array<AuditEventUserConnectionWhere>>;
  NOT?: InputMaybe<AuditEventUserConnectionWhere>;
  OR?: InputMaybe<Array<AuditEventUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<UserWhere>;
};

export type AuditEventUserRelationship = {
  __typename?: "AuditEventUserRelationship";
  cursor: Scalars["String"]["output"];
  node: User;
};

export type AuthClient = {
  __typename?: "AuthClient";
  clientId: Scalars["ID"]["output"];
  clientName?: Maybe<Scalars["String"]["output"]>;
  clientSecret?: Maybe<Scalars["String"]["output"]>;
  grantTypes: Array<Scalars["String"]["output"]>;
  idTokenSignedResponseAlg?: Maybe<Scalars["String"]["output"]>;
  logoUri?: Maybe<Scalars["String"]["output"]>;
  policyUri?: Maybe<Scalars["String"]["output"]>;
  postLogoutRedirectUris?: Maybe<Array<Scalars["String"]["output"]>>;
  redirectUris?: Maybe<Array<Scalars["String"]["output"]>>;
  responseTypes: Array<Scalars["String"]["output"]>;
  scope?: Maybe<Scalars["String"]["output"]>;
  tksExtensionConsentOptional?: Maybe<Scalars["Boolean"]["output"]>;
  tksExtensionLicenseOptional?: Maybe<Scalars["Boolean"]["output"]>;
  tksExtensionPkceOptional?: Maybe<Scalars["Boolean"]["output"]>;
  tokenEndpointAuthMethod: Scalars["String"]["output"];
  tosUri?: Maybe<Scalars["String"]["output"]>;
};

export type AuthClientCreateInput = {
  clientId: Scalars["ID"]["input"];
  clientName?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  grantTypes: Array<Scalars["String"]["input"]>;
  idTokenSignedResponseAlg?: InputMaybe<Scalars["String"]["input"]>;
  logoUri?: InputMaybe<Scalars["String"]["input"]>;
  policyUri?: InputMaybe<Scalars["String"]["input"]>;
  postLogoutRedirectUris?: InputMaybe<Array<Scalars["String"]["input"]>>;
  redirectUris?: InputMaybe<Array<Scalars["String"]["input"]>>;
  responseTypes: Array<Scalars["String"]["input"]>;
  scope?: InputMaybe<Scalars["String"]["input"]>;
  tksExtensionConsentOptional?: InputMaybe<Scalars["Boolean"]["input"]>;
  tksExtensionLicenseOptional?: InputMaybe<Scalars["Boolean"]["input"]>;
  tksExtensionPkceOptional?: InputMaybe<Scalars["Boolean"]["input"]>;
  tokenEndpointAuthMethod: Scalars["String"]["input"];
  tosUri?: InputMaybe<Scalars["String"]["input"]>;
};

export type AuthClientUpdateInput = {
  clientName?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  grantTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  idTokenSignedResponseAlg?: InputMaybe<Scalars["String"]["input"]>;
  logoUri?: InputMaybe<Scalars["String"]["input"]>;
  policyUri?: InputMaybe<Scalars["String"]["input"]>;
  postLogoutRedirectUris?: InputMaybe<Array<Scalars["String"]["input"]>>;
  redirectUris?: InputMaybe<Array<Scalars["String"]["input"]>>;
  responseTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  scope?: InputMaybe<Scalars["String"]["input"]>;
  tksExtensionConsentOptional?: InputMaybe<Scalars["Boolean"]["input"]>;
  tksExtensionLicenseOptional?: InputMaybe<Scalars["Boolean"]["input"]>;
  tksExtensionPkceOptional?: InputMaybe<Scalars["Boolean"]["input"]>;
  tokenEndpointAuthMethod?: InputMaybe<Scalars["String"]["input"]>;
  tosUri?: InputMaybe<Scalars["String"]["input"]>;
};

export type AuthClientWhere = {
  clientId?: InputMaybe<Scalars["ID"]["input"]>;
  clientName?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * The edge properties for the following fields:
 * * Organization.collaboratesWith
 */
export type CollaborationProperties = {
  __typename?: "CollaborationProperties";
  sourceOrganization?: Maybe<Scalars["String"]["output"]>;
  status: CollaborationStatus;
};

export type CollaborationPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<CollaborationPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<CollaborationPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<CollaborationPropertiesAggregationWhereInput>>;
  sourceOrganization_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  sourceOrganization_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  sourceOrganization_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  sourceOrganization_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  sourceOrganization_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  sourceOrganization_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  sourceOrganization_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  sourceOrganization_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  sourceOrganization_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  sourceOrganization_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  sourceOrganization_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  sourceOrganization_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  sourceOrganization_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  sourceOrganization_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  sourceOrganization_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CollaborationPropertiesCreateInput = {
  sourceOrganization?: InputMaybe<Scalars["String"]["input"]>;
  status: CollaborationStatus;
};

export type CollaborationPropertiesSort = {
  sourceOrganization?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type CollaborationPropertiesUpdateInput = {
  sourceOrganization?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<CollaborationStatus>;
};

export type CollaborationPropertiesWhere = {
  AND?: InputMaybe<Array<CollaborationPropertiesWhere>>;
  NOT?: InputMaybe<CollaborationPropertiesWhere>;
  OR?: InputMaybe<Array<CollaborationPropertiesWhere>>;
  sourceOrganization?: InputMaybe<Scalars["String"]["input"]>;
  sourceOrganization_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  sourceOrganization_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  sourceOrganization_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sourceOrganization_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sourceOrganization_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sourceOrganization_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sourceOrganization_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sourceOrganization_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  sourceOrganization_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<CollaborationStatus>;
  status_IN?: InputMaybe<Array<CollaborationStatus>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT?: InputMaybe<CollaborationStatus>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_IN?: InputMaybe<Array<CollaborationStatus>>;
};

export enum CollaborationStatus {
  Collaboration = "COLLABORATION",
  CollaborationCancelled = "COLLABORATION_CANCELLED",
  NoCollaboration = "NO_COLLABORATION",
  NoCollaborationPossible = "NO_COLLABORATION_POSSIBLE",
  Pending = "PENDING",
}

export type CreateApplicationsMutationResponse = {
  __typename?: "CreateApplicationsMutationResponse";
  applications: Array<Application>;
  info: CreateInfo;
};

export type CreateAuthClientsMutationResponse = {
  __typename?: "CreateAuthClientsMutationResponse";
  authClients: Array<AuthClient>;
};

export type CreateFederatedClientsMutationResponse = {
  __typename?: "CreateFederatedClientsMutationResponse";
  federatedClients: Array<FederatedClient>;
  info: CreateInfo;
};

export type CreateGroupsMutationResponse = {
  __typename?: "CreateGroupsMutationResponse";
  groups: Array<Group>;
  info: CreateInfo;
};

/** Information about the number of nodes and relationships created during a create mutation */
export type CreateInfo = {
  __typename?: "CreateInfo";
  nodesCreated: Scalars["Int"]["output"];
  relationshipsCreated: Scalars["Int"]["output"];
};

export type CreateOrganizationsMutationResponse = {
  __typename?: "CreateOrganizationsMutationResponse";
  info: CreateInfo;
  organizations: Array<Organization>;
};

export type CreateProfileSharesMutationResponse = {
  __typename?: "CreateProfileSharesMutationResponse";
  info: CreateInfo;
  profileShares: Array<ProfileShare>;
};

export type CreateProfilesFromProfileSharesMutationResponse = {
  __typename?: "CreateProfilesFromProfileSharesMutationResponse";
  profiles: Array<MinimalProfile>;
};

export type CreateProfilesMutationResponse = {
  __typename?: "CreateProfilesMutationResponse";
  info: CreateInfo;
  profiles: Array<Profile>;
};

export type CreatePropertiesMutationResponse = {
  __typename?: "CreatePropertiesMutationResponse";
  info: CreateInfo;
  properties: Array<Property>;
};

export type CreateUsersMutationResponse = {
  __typename?: "CreateUsersMutationResponse";
  info: CreateInfo;
  users: Array<User>;
};

export type CustomDeleteInfo = {
  __typename?: "CustomDeleteInfo";
  nodesDeleted: Scalars["Int"]["output"];
};

export type DateTimeAggregateSelection = {
  __typename?: "DateTimeAggregateSelection";
  max?: Maybe<Scalars["DateTime"]["output"]>;
  min?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Information about the number of nodes and relationships deleted during a delete mutation */
export type DeleteInfo = {
  __typename?: "DeleteInfo";
  nodesDeleted: Scalars["Int"]["output"];
  relationshipsDeleted: Scalars["Int"]["output"];
};

export type FederatedClient = {
  __typename?: "FederatedClient";
  clientId?: Maybe<Scalars["String"]["output"]>;
  clientSecret?: Maybe<Scalars["String"]["output"]>;
  customIdClaims?: Maybe<Array<Scalars["String"]["output"]>>;
  issuer: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  responseTypes: Array<Scalars["String"]["output"]>;
  uuid: Scalars["ID"]["output"];
};

export type FederatedClientAggregateSelection = {
  __typename?: "FederatedClientAggregateSelection";
  clientId: StringAggregateSelection;
  clientSecret: StringAggregateSelection;
  count: Scalars["Int"]["output"];
  issuer: StringAggregateSelection;
  label: StringAggregateSelection;
  name: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type FederatedClientConnectWhere = {
  node: FederatedClientWhere;
};

export type FederatedClientCreateInput = {
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  customIdClaims?: InputMaybe<Array<Scalars["String"]["input"]>>;
  issuer: Scalars["String"]["input"];
  label: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  responseTypes: Array<Scalars["String"]["input"]>;
};

export type FederatedClientEdge = {
  __typename?: "FederatedClientEdge";
  cursor: Scalars["String"]["output"];
  node: FederatedClient;
};

export type FederatedClientOptions = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Specify one or more FederatedClientSort objects to sort FederatedClients by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FederatedClientSort>>;
};

/**
 * The edge properties for the following fields:
 * * User.federatedClient
 */
export type FederatedClientProperties = {
  __typename?: "FederatedClientProperties";
  birthdate?: Maybe<Scalars["String"]["output"]>;
  customId?: Maybe<Array<Scalars["String"]["output"]>>;
  email: Scalars["String"]["output"];
  emailVerified: Scalars["Boolean"]["output"];
  familyName?: Maybe<Scalars["String"]["output"]>;
  gender?: Maybe<Scalars["String"]["output"]>;
  givenName?: Maybe<Scalars["String"]["output"]>;
  locale?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  picture?: Maybe<Scalars["String"]["output"]>;
  preferred_username?: Maybe<Scalars["String"]["output"]>;
  sub?: Maybe<Scalars["String"]["output"]>;
};

export type FederatedClientPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<FederatedClientPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<FederatedClientPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<FederatedClientPropertiesAggregationWhereInput>>;
  birthdate_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  birthdate_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  birthdate_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  birthdate_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  birthdate_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  birthdate_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  birthdate_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  birthdate_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  birthdate_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  birthdate_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  birthdate_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  birthdate_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  birthdate_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  birthdate_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  birthdate_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  familyName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  familyName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  familyName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  familyName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  familyName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  familyName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  familyName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  familyName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  familyName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  familyName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  familyName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  familyName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  familyName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  familyName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  familyName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  givenName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  givenName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  givenName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  givenName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  givenName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  givenName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  givenName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  givenName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  givenName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  givenName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  givenName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  givenName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  givenName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  givenName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  givenName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  picture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  picture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  picture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  picture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  picture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  picture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  picture_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  picture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  picture_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  picture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  picture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  picture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  picture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  picture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  picture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferred_username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  preferred_username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  preferred_username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  preferred_username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  preferred_username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  preferred_username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  preferred_username_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  preferred_username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferred_username_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  preferred_username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferred_username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  preferred_username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  preferred_username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferred_username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  preferred_username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  sub_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  sub_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  sub_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  sub_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  sub_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  sub_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  sub_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  sub_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  sub_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  sub_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  sub_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  sub_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  sub_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  sub_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  sub_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type FederatedClientPropertiesCreateInput = {
  birthdate?: InputMaybe<Scalars["String"]["input"]>;
  customId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  email: Scalars["String"]["input"];
  emailVerified: Scalars["Boolean"]["input"];
  familyName?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  picture?: InputMaybe<Scalars["String"]["input"]>;
  preferred_username?: InputMaybe<Scalars["String"]["input"]>;
  sub?: InputMaybe<Scalars["String"]["input"]>;
};

export type FederatedClientPropertiesSort = {
  birthdate?: InputMaybe<SortDirection>;
  customId?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  emailVerified?: InputMaybe<SortDirection>;
  familyName?: InputMaybe<SortDirection>;
  gender?: InputMaybe<SortDirection>;
  givenName?: InputMaybe<SortDirection>;
  locale?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  picture?: InputMaybe<SortDirection>;
  preferred_username?: InputMaybe<SortDirection>;
  sub?: InputMaybe<SortDirection>;
};

export type FederatedClientPropertiesUpdateInput = {
  birthdate?: InputMaybe<Scalars["String"]["input"]>;
  customId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  customId_POP?: InputMaybe<Scalars["Int"]["input"]>;
  customId_PUSH?: InputMaybe<Array<Scalars["String"]["input"]>>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  familyName?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  picture?: InputMaybe<Scalars["String"]["input"]>;
  preferred_username?: InputMaybe<Scalars["String"]["input"]>;
  sub?: InputMaybe<Scalars["String"]["input"]>;
};

export type FederatedClientPropertiesWhere = {
  AND?: InputMaybe<Array<FederatedClientPropertiesWhere>>;
  NOT?: InputMaybe<FederatedClientPropertiesWhere>;
  OR?: InputMaybe<Array<FederatedClientPropertiesWhere>>;
  birthdate?: InputMaybe<Scalars["String"]["input"]>;
  birthdate_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  birthdate_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  birthdate_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthdate_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthdate_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthdate_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthdate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthdate_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  birthdate_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  customId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  customId_INCLUDES?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  customId_NOT?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  customId_NOT_INCLUDES?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailVerified_NOT?: InputMaybe<Scalars["Boolean"]["input"]>;
  email_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  email_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  email_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  email_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  familyName?: InputMaybe<Scalars["String"]["input"]>;
  familyName_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  familyName_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  familyName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  familyName_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  familyName_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  familyName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  familyName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  familyName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  familyName_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<Scalars["String"]["input"]>;
  gender_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  gender_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  gender_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  gender_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  givenName_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  givenName_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  givenName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  givenName_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  givenName_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  givenName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  givenName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  givenName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  givenName_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  locale_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  locale_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  locale_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  locale_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  name_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  name_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  picture?: InputMaybe<Scalars["String"]["input"]>;
  picture_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  picture_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  picture_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  picture_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  picture_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  picture_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  picture_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  picture_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  picture_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  preferred_username?: InputMaybe<Scalars["String"]["input"]>;
  preferred_username_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  preferred_username_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  preferred_username_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferred_username_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferred_username_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferred_username_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferred_username_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferred_username_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  preferred_username_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  sub?: InputMaybe<Scalars["String"]["input"]>;
  sub_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  sub_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  sub_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sub_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sub_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sub_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sub_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sub_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  sub_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
};

/** Fields to sort FederatedClients by. The order in which sorts are applied is not guaranteed when specifying many fields in one FederatedClientSort object. */
export type FederatedClientSort = {
  clientId?: InputMaybe<SortDirection>;
  clientSecret?: InputMaybe<SortDirection>;
  issuer?: InputMaybe<SortDirection>;
  label?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type FederatedClientUpdateInput = {
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  customIdClaims?: InputMaybe<Array<Scalars["String"]["input"]>>;
  customIdClaims_POP?: InputMaybe<Scalars["Int"]["input"]>;
  customIdClaims_PUSH?: InputMaybe<Array<Scalars["String"]["input"]>>;
  issuer?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  responseTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  responseTypes_POP?: InputMaybe<Scalars["Int"]["input"]>;
  responseTypes_PUSH?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type FederatedClientWhere = {
  AND?: InputMaybe<Array<FederatedClientWhere>>;
  NOT?: InputMaybe<FederatedClientWhere>;
  OR?: InputMaybe<Array<FederatedClientWhere>>;
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  clientId_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  clientId_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  clientId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  clientId_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientSecret_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientSecret_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientSecret_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientSecret_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientSecret_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  customIdClaims?: InputMaybe<Array<Scalars["String"]["input"]>>;
  customIdClaims_INCLUDES?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  customIdClaims_NOT?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  customIdClaims_NOT_INCLUDES?: InputMaybe<Scalars["String"]["input"]>;
  issuer?: InputMaybe<Scalars["String"]["input"]>;
  issuer_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  issuer_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  issuer_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  issuer_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  issuer_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  issuer_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  issuer_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  issuer_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  issuer_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  label_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  label_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  label_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  label_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  label_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  label_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  label_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  label_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  label_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  name_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  name_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  responseTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  responseTypes_INCLUDES?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  responseTypes_NOT?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  responseTypes_NOT_INCLUDES?: InputMaybe<Scalars["String"]["input"]>;
  uuid?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
};

export type FederatedClientsConnection = {
  __typename?: "FederatedClientsConnection";
  edges: Array<FederatedClientEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type GlobalSubject = {
  __typename?: "GlobalSubject";
  country: Scalars["String"]["output"];
  states: Array<Scalars["String"]["output"]>;
  subject: Scalars["String"]["output"];
};

export type GlobalSubjectsWhere = {
  country?: InputMaybe<Scalars["String"]["input"]>;
  states_INCLUDES?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
};

export type Group = {
  __typename?: "Group";
  incomingRoles: Array<RoleTarget>;
  incomingRolesConnection: GroupIncomingRolesConnection;
  name: Scalars["String"]["output"];
  organization: Organization;
  organizationConnection: GroupOrganizationConnection;
  profiles: Array<Profile>;
  profilesConnection: GroupProfilesConnection;
  properties: Array<Property>;
  propertiesConnection: GroupPropertiesConnection;
  publicVisible?: Maybe<Scalars["Boolean"]["output"]>;
  uuid: Scalars["ID"]["output"];
};

export type GroupIncomingRolesArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<RoleTargetWhere>;
};

export type GroupIncomingRolesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<GroupIncomingRolesConnectionSort>>;
  where?: InputMaybe<GroupIncomingRolesConnectionWhere>;
};

export type GroupOrganizationArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type GroupOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<GroupOrganizationConnectionSort>>;
  where?: InputMaybe<GroupOrganizationConnectionWhere>;
};

export type GroupProfilesArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type GroupProfilesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<GroupProfilesConnectionSort>>;
  where?: InputMaybe<GroupProfilesConnectionWhere>;
};

export type GroupPropertiesArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<PropertyOptions>;
  where?: InputMaybe<PropertyWhere>;
};

export type GroupPropertiesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<GroupPropertiesConnectionSort>>;
  where?: InputMaybe<GroupPropertiesConnectionWhere>;
};

export type GroupAggregateSelection = {
  __typename?: "GroupAggregateSelection";
  count: Scalars["Int"]["output"];
  name: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type GroupConnectInput = {
  incomingRoles?: InputMaybe<GroupIncomingRolesConnectInput>;
  organization?: InputMaybe<GroupOrganizationConnectFieldInput>;
  profiles?: InputMaybe<Array<GroupProfilesConnectFieldInput>>;
  properties?: InputMaybe<Array<GroupPropertiesConnectFieldInput>>;
};

export type GroupConnectWhere = {
  node: GroupWhere;
};

export type GroupCreateInput = {
  incomingRoles?: InputMaybe<GroupIncomingRolesCreateInput>;
  name: Scalars["String"]["input"];
  organization?: InputMaybe<GroupOrganizationFieldInput>;
  profiles?: InputMaybe<GroupProfilesFieldInput>;
  properties?: InputMaybe<GroupPropertiesFieldInput>;
  publicVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GroupDeleteInput = {
  incomingRoles?: InputMaybe<GroupIncomingRolesDeleteInput>;
  organization?: InputMaybe<GroupOrganizationDeleteFieldInput>;
  profiles?: InputMaybe<Array<GroupProfilesDeleteFieldInput>>;
  properties?: InputMaybe<Array<GroupPropertiesDeleteFieldInput>>;
};

export type GroupDisconnectInput = {
  incomingRoles?: InputMaybe<GroupIncomingRolesDisconnectInput>;
  organization?: InputMaybe<GroupOrganizationDisconnectFieldInput>;
  profiles?: InputMaybe<Array<GroupProfilesDisconnectFieldInput>>;
  properties?: InputMaybe<Array<GroupPropertiesDisconnectFieldInput>>;
};

export type GroupEdge = {
  __typename?: "GroupEdge";
  cursor: Scalars["String"]["output"];
  node: Group;
};

export type GroupIncomingRolesConnectInput = {
  Group?: InputMaybe<Array<GroupIncomingRolesGroupConnectFieldInput>>;
  Organization?: InputMaybe<Array<GroupIncomingRolesOrganizationConnectFieldInput>>;
  Profile?: InputMaybe<Array<GroupIncomingRolesProfileConnectFieldInput>>;
  User?: InputMaybe<Array<GroupIncomingRolesUserConnectFieldInput>>;
};

export type GroupIncomingRolesConnection = {
  __typename?: "GroupIncomingRolesConnection";
  edges: Array<GroupIncomingRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type GroupIncomingRolesConnectionSort = {
  edge?: InputMaybe<RoleNamesSort>;
};

export type GroupIncomingRolesConnectionWhere = {
  Group?: InputMaybe<GroupIncomingRolesGroupConnectionWhere>;
  Organization?: InputMaybe<GroupIncomingRolesOrganizationConnectionWhere>;
  Profile?: InputMaybe<GroupIncomingRolesProfileConnectionWhere>;
  User?: InputMaybe<GroupIncomingRolesUserConnectionWhere>;
};

export type GroupIncomingRolesCreateInput = {
  Group?: InputMaybe<GroupIncomingRolesGroupFieldInput>;
  Organization?: InputMaybe<GroupIncomingRolesOrganizationFieldInput>;
  Profile?: InputMaybe<GroupIncomingRolesProfileFieldInput>;
  User?: InputMaybe<GroupIncomingRolesUserFieldInput>;
};

export type GroupIncomingRolesDeleteInput = {
  Group?: InputMaybe<Array<GroupIncomingRolesGroupDeleteFieldInput>>;
  Organization?: InputMaybe<Array<GroupIncomingRolesOrganizationDeleteFieldInput>>;
  Profile?: InputMaybe<Array<GroupIncomingRolesProfileDeleteFieldInput>>;
  User?: InputMaybe<Array<GroupIncomingRolesUserDeleteFieldInput>>;
};

export type GroupIncomingRolesDisconnectInput = {
  Group?: InputMaybe<Array<GroupIncomingRolesGroupDisconnectFieldInput>>;
  Organization?: InputMaybe<Array<GroupIncomingRolesOrganizationDisconnectFieldInput>>;
  Profile?: InputMaybe<Array<GroupIncomingRolesProfileDisconnectFieldInput>>;
  User?: InputMaybe<Array<GroupIncomingRolesUserDisconnectFieldInput>>;
};

export type GroupIncomingRolesGroupConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<GroupConnectWhere>;
};

export type GroupIncomingRolesGroupConnectionWhere = {
  AND?: InputMaybe<Array<GroupIncomingRolesGroupConnectionWhere>>;
  NOT?: InputMaybe<GroupIncomingRolesGroupConnectionWhere>;
  OR?: InputMaybe<Array<GroupIncomingRolesGroupConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type GroupIncomingRolesGroupCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: GroupCreateInput;
};

export type GroupIncomingRolesGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<GroupIncomingRolesGroupConnectionWhere>;
};

export type GroupIncomingRolesGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<GroupIncomingRolesGroupConnectionWhere>;
};

export type GroupIncomingRolesGroupFieldInput = {
  connect?: InputMaybe<Array<GroupIncomingRolesGroupConnectFieldInput>>;
  create?: InputMaybe<Array<GroupIncomingRolesGroupCreateFieldInput>>;
};

export type GroupIncomingRolesGroupUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<GroupUpdateInput>;
};

export type GroupIncomingRolesGroupUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupIncomingRolesGroupConnectFieldInput>>;
  create?: InputMaybe<Array<GroupIncomingRolesGroupCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupIncomingRolesGroupDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupIncomingRolesGroupDisconnectFieldInput>>;
  update?: InputMaybe<GroupIncomingRolesGroupUpdateConnectionInput>;
  where?: InputMaybe<GroupIncomingRolesGroupConnectionWhere>;
};

export type GroupIncomingRolesOrganizationConnectFieldInput = {
  connect?: InputMaybe<Array<OrganizationConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type GroupIncomingRolesOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<GroupIncomingRolesOrganizationConnectionWhere>>;
  NOT?: InputMaybe<GroupIncomingRolesOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<GroupIncomingRolesOrganizationConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type GroupIncomingRolesOrganizationCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: OrganizationCreateInput;
};

export type GroupIncomingRolesOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<GroupIncomingRolesOrganizationConnectionWhere>;
};

export type GroupIncomingRolesOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<GroupIncomingRolesOrganizationConnectionWhere>;
};

export type GroupIncomingRolesOrganizationFieldInput = {
  connect?: InputMaybe<Array<GroupIncomingRolesOrganizationConnectFieldInput>>;
  create?: InputMaybe<Array<GroupIncomingRolesOrganizationCreateFieldInput>>;
};

export type GroupIncomingRolesOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type GroupIncomingRolesOrganizationUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupIncomingRolesOrganizationConnectFieldInput>>;
  create?: InputMaybe<Array<GroupIncomingRolesOrganizationCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupIncomingRolesOrganizationDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupIncomingRolesOrganizationDisconnectFieldInput>>;
  update?: InputMaybe<GroupIncomingRolesOrganizationUpdateConnectionInput>;
  where?: InputMaybe<GroupIncomingRolesOrganizationConnectionWhere>;
};

export type GroupIncomingRolesProfileConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<ProfileConnectWhere>;
};

export type GroupIncomingRolesProfileConnectionWhere = {
  AND?: InputMaybe<Array<GroupIncomingRolesProfileConnectionWhere>>;
  NOT?: InputMaybe<GroupIncomingRolesProfileConnectionWhere>;
  OR?: InputMaybe<Array<GroupIncomingRolesProfileConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type GroupIncomingRolesProfileCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: ProfileCreateInput;
};

export type GroupIncomingRolesProfileDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<GroupIncomingRolesProfileConnectionWhere>;
};

export type GroupIncomingRolesProfileDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<GroupIncomingRolesProfileConnectionWhere>;
};

export type GroupIncomingRolesProfileFieldInput = {
  connect?: InputMaybe<Array<GroupIncomingRolesProfileConnectFieldInput>>;
  create?: InputMaybe<Array<GroupIncomingRolesProfileCreateFieldInput>>;
};

export type GroupIncomingRolesProfileUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type GroupIncomingRolesProfileUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupIncomingRolesProfileConnectFieldInput>>;
  create?: InputMaybe<Array<GroupIncomingRolesProfileCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupIncomingRolesProfileDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupIncomingRolesProfileDisconnectFieldInput>>;
  update?: InputMaybe<GroupIncomingRolesProfileUpdateConnectionInput>;
  where?: InputMaybe<GroupIncomingRolesProfileConnectionWhere>;
};

export type GroupIncomingRolesRelationship = {
  __typename?: "GroupIncomingRolesRelationship";
  cursor: Scalars["String"]["output"];
  node: RoleTarget;
  properties: RoleNames;
};

export type GroupIncomingRolesUpdateInput = {
  Group?: InputMaybe<Array<GroupIncomingRolesGroupUpdateFieldInput>>;
  Organization?: InputMaybe<Array<GroupIncomingRolesOrganizationUpdateFieldInput>>;
  Profile?: InputMaybe<Array<GroupIncomingRolesProfileUpdateFieldInput>>;
  User?: InputMaybe<Array<GroupIncomingRolesUserUpdateFieldInput>>;
};

export type GroupIncomingRolesUserConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<UserConnectWhere>;
};

export type GroupIncomingRolesUserConnectionWhere = {
  AND?: InputMaybe<Array<GroupIncomingRolesUserConnectionWhere>>;
  NOT?: InputMaybe<GroupIncomingRolesUserConnectionWhere>;
  OR?: InputMaybe<Array<GroupIncomingRolesUserConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<UserWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<UserWhere>;
};

export type GroupIncomingRolesUserCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: UserCreateInput;
};

export type GroupIncomingRolesUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<GroupIncomingRolesUserConnectionWhere>;
};

export type GroupIncomingRolesUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<GroupIncomingRolesUserConnectionWhere>;
};

export type GroupIncomingRolesUserFieldInput = {
  connect?: InputMaybe<Array<GroupIncomingRolesUserConnectFieldInput>>;
  create?: InputMaybe<Array<GroupIncomingRolesUserCreateFieldInput>>;
};

export type GroupIncomingRolesUserUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type GroupIncomingRolesUserUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupIncomingRolesUserConnectFieldInput>>;
  create?: InputMaybe<Array<GroupIncomingRolesUserCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupIncomingRolesUserDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupIncomingRolesUserDisconnectFieldInput>>;
  update?: InputMaybe<GroupIncomingRolesUserUpdateConnectionInput>;
  where?: InputMaybe<GroupIncomingRolesUserConnectionWhere>;
};

export type GroupOptions = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Specify one or more GroupSort objects to sort Groups by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<GroupSort>>;
};

export type GroupOrganizationAggregateInput = {
  AND?: InputMaybe<Array<GroupOrganizationAggregateInput>>;
  NOT?: InputMaybe<GroupOrganizationAggregateInput>;
  OR?: InputMaybe<Array<GroupOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<GroupOrganizationNodeAggregationWhereInput>;
};

export type GroupOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type GroupOrganizationConnection = {
  __typename?: "GroupOrganizationConnection";
  edges: Array<GroupOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type GroupOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type GroupOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<GroupOrganizationConnectionWhere>>;
  NOT?: InputMaybe<GroupOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<GroupOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type GroupOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type GroupOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<GroupOrganizationConnectionWhere>;
};

export type GroupOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<GroupOrganizationConnectionWhere>;
};

export type GroupOrganizationFieldInput = {
  connect?: InputMaybe<GroupOrganizationConnectFieldInput>;
  create?: InputMaybe<GroupOrganizationCreateFieldInput>;
};

export type GroupOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupOrganizationNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GroupOrganizationRelationship = {
  __typename?: "GroupOrganizationRelationship";
  cursor: Scalars["String"]["output"];
  node: Organization;
};

export type GroupOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type GroupOrganizationUpdateFieldInput = {
  connect?: InputMaybe<GroupOrganizationConnectFieldInput>;
  create?: InputMaybe<GroupOrganizationCreateFieldInput>;
  delete?: InputMaybe<GroupOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<GroupOrganizationDisconnectFieldInput>;
  update?: InputMaybe<GroupOrganizationUpdateConnectionInput>;
  where?: InputMaybe<GroupOrganizationConnectionWhere>;
};

export type GroupProfilesAggregateInput = {
  AND?: InputMaybe<Array<GroupProfilesAggregateInput>>;
  NOT?: InputMaybe<GroupProfilesAggregateInput>;
  OR?: InputMaybe<Array<GroupProfilesAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<GroupProfilesNodeAggregationWhereInput>;
};

export type GroupProfilesConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type GroupProfilesConnection = {
  __typename?: "GroupProfilesConnection";
  edges: Array<GroupProfilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type GroupProfilesConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type GroupProfilesConnectionWhere = {
  AND?: InputMaybe<Array<GroupProfilesConnectionWhere>>;
  NOT?: InputMaybe<GroupProfilesConnectionWhere>;
  OR?: InputMaybe<Array<GroupProfilesConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type GroupProfilesCreateFieldInput = {
  node: ProfileCreateInput;
};

export type GroupProfilesDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<GroupProfilesConnectionWhere>;
};

export type GroupProfilesDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<GroupProfilesConnectionWhere>;
};

export type GroupProfilesFieldInput = {
  connect?: InputMaybe<Array<GroupProfilesConnectFieldInput>>;
  create?: InputMaybe<Array<GroupProfilesCreateFieldInput>>;
};

export type GroupProfilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupProfilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupProfilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupProfilesNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosAccepted_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GroupProfilesRelationship = {
  __typename?: "GroupProfilesRelationship";
  cursor: Scalars["String"]["output"];
  node: Profile;
};

export type GroupProfilesUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type GroupProfilesUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupProfilesConnectFieldInput>>;
  create?: InputMaybe<Array<GroupProfilesCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupProfilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupProfilesDisconnectFieldInput>>;
  update?: InputMaybe<GroupProfilesUpdateConnectionInput>;
  where?: InputMaybe<GroupProfilesConnectionWhere>;
};

export type GroupPropertiesAggregateInput = {
  AND?: InputMaybe<Array<GroupPropertiesAggregateInput>>;
  NOT?: InputMaybe<GroupPropertiesAggregateInput>;
  OR?: InputMaybe<Array<GroupPropertiesAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  edge?: InputMaybe<PropertiesScopeAggregationWhereInput>;
  node?: InputMaybe<GroupPropertiesNodeAggregationWhereInput>;
};

export type GroupPropertiesConnectFieldInput = {
  connect?: InputMaybe<Array<PropertyConnectInput>>;
  edge: PropertiesScopeCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<PropertyConnectWhere>;
};

export type GroupPropertiesConnection = {
  __typename?: "GroupPropertiesConnection";
  edges: Array<GroupPropertiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type GroupPropertiesConnectionSort = {
  edge?: InputMaybe<PropertiesScopeSort>;
  node?: InputMaybe<PropertySort>;
};

export type GroupPropertiesConnectionWhere = {
  AND?: InputMaybe<Array<GroupPropertiesConnectionWhere>>;
  NOT?: InputMaybe<GroupPropertiesConnectionWhere>;
  OR?: InputMaybe<Array<GroupPropertiesConnectionWhere>>;
  edge?: InputMaybe<PropertiesScopeWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PropertiesScopeWhere>;
  node?: InputMaybe<PropertyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PropertyWhere>;
};

export type GroupPropertiesCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: PropertyCreateInput;
};

export type GroupPropertiesDeleteFieldInput = {
  delete?: InputMaybe<PropertyDeleteInput>;
  where?: InputMaybe<GroupPropertiesConnectionWhere>;
};

export type GroupPropertiesDisconnectFieldInput = {
  disconnect?: InputMaybe<PropertyDisconnectInput>;
  where?: InputMaybe<GroupPropertiesConnectionWhere>;
};

export type GroupPropertiesFieldInput = {
  connect?: InputMaybe<Array<GroupPropertiesConnectFieldInput>>;
  create?: InputMaybe<Array<GroupPropertiesCreateFieldInput>>;
};

export type GroupPropertiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupPropertiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupPropertiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupPropertiesNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  value_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GroupPropertiesRelationship = {
  __typename?: "GroupPropertiesRelationship";
  cursor: Scalars["String"]["output"];
  node: Property;
  properties: PropertiesScope;
};

export type GroupPropertiesUpdateConnectionInput = {
  edge?: InputMaybe<PropertiesScopeUpdateInput>;
  node?: InputMaybe<PropertyUpdateInput>;
};

export type GroupPropertiesUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupPropertiesConnectFieldInput>>;
  create?: InputMaybe<Array<GroupPropertiesCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupPropertiesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupPropertiesDisconnectFieldInput>>;
  update?: InputMaybe<GroupPropertiesUpdateConnectionInput>;
  where?: InputMaybe<GroupPropertiesConnectionWhere>;
};

/** Fields to sort Groups by. The order in which sorts are applied is not guaranteed when specifying many fields in one GroupSort object. */
export type GroupSort = {
  name?: InputMaybe<SortDirection>;
  publicVisible?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type GroupUpdateInput = {
  incomingRoles?: InputMaybe<GroupIncomingRolesUpdateInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<GroupOrganizationUpdateFieldInput>;
  profiles?: InputMaybe<Array<GroupProfilesUpdateFieldInput>>;
  properties?: InputMaybe<Array<GroupPropertiesUpdateFieldInput>>;
  publicVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GroupWhere = {
  AND?: InputMaybe<Array<GroupWhere>>;
  NOT?: InputMaybe<GroupWhere>;
  OR?: InputMaybe<Array<GroupWhere>>;
  /** @deprecated Use `incomingRoles_SOME` instead. */
  incomingRoles?: InputMaybe<RoleTargetWhere>;
  /** @deprecated Use `incomingRolesConnection_SOME` instead. */
  incomingRolesConnection?: InputMaybe<GroupIncomingRolesConnectionWhere>;
  /** Return Groups where all of the related GroupIncomingRolesConnections match this filter */
  incomingRolesConnection_ALL?: InputMaybe<GroupIncomingRolesConnectionWhere>;
  /** Return Groups where none of the related GroupIncomingRolesConnections match this filter */
  incomingRolesConnection_NONE?: InputMaybe<GroupIncomingRolesConnectionWhere>;
  /** @deprecated Use `incomingRolesConnection_NONE` instead. */
  incomingRolesConnection_NOT?: InputMaybe<GroupIncomingRolesConnectionWhere>;
  /** Return Groups where one of the related GroupIncomingRolesConnections match this filter */
  incomingRolesConnection_SINGLE?: InputMaybe<GroupIncomingRolesConnectionWhere>;
  /** Return Groups where some of the related GroupIncomingRolesConnections match this filter */
  incomingRolesConnection_SOME?: InputMaybe<GroupIncomingRolesConnectionWhere>;
  /** Return Groups where all of the related RoleTargets match this filter */
  incomingRoles_ALL?: InputMaybe<RoleTargetWhere>;
  /** Return Groups where none of the related RoleTargets match this filter */
  incomingRoles_NONE?: InputMaybe<RoleTargetWhere>;
  /** @deprecated Use `incomingRoles_NONE` instead. */
  incomingRoles_NOT?: InputMaybe<RoleTargetWhere>;
  /** Return Groups where one of the related RoleTargets match this filter */
  incomingRoles_SINGLE?: InputMaybe<RoleTargetWhere>;
  /** Return Groups where some of the related RoleTargets match this filter */
  incomingRoles_SOME?: InputMaybe<RoleTargetWhere>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  name_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  name_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<GroupOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<GroupOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<GroupOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `profiles_SOME` instead. */
  profiles?: InputMaybe<ProfileWhere>;
  profilesAggregate?: InputMaybe<GroupProfilesAggregateInput>;
  /** @deprecated Use `profilesConnection_SOME` instead. */
  profilesConnection?: InputMaybe<GroupProfilesConnectionWhere>;
  /** Return Groups where all of the related GroupProfilesConnections match this filter */
  profilesConnection_ALL?: InputMaybe<GroupProfilesConnectionWhere>;
  /** Return Groups where none of the related GroupProfilesConnections match this filter */
  profilesConnection_NONE?: InputMaybe<GroupProfilesConnectionWhere>;
  /** @deprecated Use `profilesConnection_NONE` instead. */
  profilesConnection_NOT?: InputMaybe<GroupProfilesConnectionWhere>;
  /** Return Groups where one of the related GroupProfilesConnections match this filter */
  profilesConnection_SINGLE?: InputMaybe<GroupProfilesConnectionWhere>;
  /** Return Groups where some of the related GroupProfilesConnections match this filter */
  profilesConnection_SOME?: InputMaybe<GroupProfilesConnectionWhere>;
  /** Return Groups where all of the related Profiles match this filter */
  profiles_ALL?: InputMaybe<ProfileWhere>;
  /** Return Groups where none of the related Profiles match this filter */
  profiles_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `profiles_NONE` instead. */
  profiles_NOT?: InputMaybe<ProfileWhere>;
  /** Return Groups where one of the related Profiles match this filter */
  profiles_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return Groups where some of the related Profiles match this filter */
  profiles_SOME?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `properties_SOME` instead. */
  properties?: InputMaybe<PropertyWhere>;
  propertiesAggregate?: InputMaybe<GroupPropertiesAggregateInput>;
  /** @deprecated Use `propertiesConnection_SOME` instead. */
  propertiesConnection?: InputMaybe<GroupPropertiesConnectionWhere>;
  /** Return Groups where all of the related GroupPropertiesConnections match this filter */
  propertiesConnection_ALL?: InputMaybe<GroupPropertiesConnectionWhere>;
  /** Return Groups where none of the related GroupPropertiesConnections match this filter */
  propertiesConnection_NONE?: InputMaybe<GroupPropertiesConnectionWhere>;
  /** @deprecated Use `propertiesConnection_NONE` instead. */
  propertiesConnection_NOT?: InputMaybe<GroupPropertiesConnectionWhere>;
  /** Return Groups where one of the related GroupPropertiesConnections match this filter */
  propertiesConnection_SINGLE?: InputMaybe<GroupPropertiesConnectionWhere>;
  /** Return Groups where some of the related GroupPropertiesConnections match this filter */
  propertiesConnection_SOME?: InputMaybe<GroupPropertiesConnectionWhere>;
  /** Return Groups where all of the related Properties match this filter */
  properties_ALL?: InputMaybe<PropertyWhere>;
  /** Return Groups where none of the related Properties match this filter */
  properties_NONE?: InputMaybe<PropertyWhere>;
  /** @deprecated Use `properties_NONE` instead. */
  properties_NOT?: InputMaybe<PropertyWhere>;
  /** Return Groups where one of the related Properties match this filter */
  properties_SINGLE?: InputMaybe<PropertyWhere>;
  /** Return Groups where some of the related Properties match this filter */
  properties_SOME?: InputMaybe<PropertyWhere>;
  publicVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicVisible_NOT?: InputMaybe<Scalars["Boolean"]["input"]>;
  uuid?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
};

export type GroupsConnection = {
  __typename?: "GroupsConnection";
  edges: Array<GroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type IdAggregateSelection = {
  __typename?: "IDAggregateSelection";
  longest?: Maybe<Scalars["ID"]["output"]>;
  shortest?: Maybe<Scalars["ID"]["output"]>;
};

/**
 * The edge properties for the following fields:
 * * Organization.licensedApplications
 * * Application.licensedOrganizations
 */
export type LicenseProperties = {
  __typename?: "LicenseProperties";
  /** Optional. (string) list of booked/licensed modules */
  licensedModules?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Optional. If not set, the license is always valid in the future. */
  notAfter?: Maybe<Scalars["DateTime"]["output"]>;
  /** Optional. If not set, the license is always valid in the past. */
  notBefore?: Maybe<Scalars["DateTime"]["output"]>;
  /** Optional. Reference to the corresponding contract in TecArt */
  tecartContractId?: Maybe<Scalars["String"]["output"]>;
};

export type LicensePropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<LicensePropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<LicensePropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<LicensePropertiesAggregationWhereInput>>;
  notAfter_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tecartContractId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContractId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContractId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContractId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContractId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContractId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContractId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContractId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContractId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContractId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContractId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContractId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContractId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContractId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContractId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type LicensePropertiesCreateInput = {
  licensedModules?: InputMaybe<Array<Scalars["String"]["input"]>>;
  notAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
  tecartContractId?: InputMaybe<Scalars["String"]["input"]>;
};

export type LicensePropertiesSort = {
  licensedModules?: InputMaybe<SortDirection>;
  notAfter?: InputMaybe<SortDirection>;
  notBefore?: InputMaybe<SortDirection>;
  tecartContractId?: InputMaybe<SortDirection>;
};

export type LicensePropertiesUpdateInput = {
  licensedModules?: InputMaybe<Array<Scalars["String"]["input"]>>;
  licensedModules_POP?: InputMaybe<Scalars["Int"]["input"]>;
  licensedModules_PUSH?: InputMaybe<Array<Scalars["String"]["input"]>>;
  notAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
  tecartContractId?: InputMaybe<Scalars["String"]["input"]>;
};

export type LicensePropertiesWhere = {
  AND?: InputMaybe<Array<LicensePropertiesWhere>>;
  NOT?: InputMaybe<LicensePropertiesWhere>;
  OR?: InputMaybe<Array<LicensePropertiesWhere>>;
  licensedModules?: InputMaybe<Array<Scalars["String"]["input"]>>;
  licensedModules_INCLUDES?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licensedModules_NOT?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licensedModules_NOT_INCLUDES?: InputMaybe<Scalars["String"]["input"]>;
  notAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  notAfter_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  notAfter_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notAfter_NOT?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notAfter_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  notBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  notBefore_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBefore_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notBefore_NOT?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notBefore_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  tecartContractId?: InputMaybe<Scalars["String"]["input"]>;
  tecartContractId_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  tecartContractId_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tecartContractId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContractId_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContractId_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContractId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContractId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContractId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tecartContractId_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
};

export type MinimalOrganization = {
  __typename?: "MinimalOrganization";
  collaborationAdmins: Array<MinimalProfile>;
  collaborationSourceOrganization?: Maybe<Scalars["String"]["output"]>;
  collaborationStatus?: Maybe<CollaborationStatus>;
  groupAdmins: Array<MinimalProfile>;
  name?: Maybe<Scalars["String"]["output"]>;
  uuid: Scalars["ID"]["output"];
};

export type MinimalProfile = {
  __typename?: "MinimalProfile";
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  uuid: Scalars["ID"]["output"];
};

export type MinimalProfileShare = {
  __typename?: "MinimalProfileShare";
  organization: MinimalOrganization;
  profile: MinimalProfile;
  sharedWithOrganization: MinimalOrganization;
  uuid: Scalars["ID"]["output"];
};

export type MinimalProfileShareEdge = {
  __typename?: "MinimalProfileShareEdge";
  cursor: Scalars["String"]["output"];
  node: MinimalProfileShare;
};

export type MinimalProfileShareOptions = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Specify one or more MinimalProfileShareSort objects to sort MinimalProfileShares by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MinimalProfileShareSort>>;
};

/** Fields to sort MinimalProfileShares by. The order in which sorts are applied is not guaranteed when specifying many fields in one MinimalProfileShareSort object. */
export type MinimalProfileShareSort = {
  uuid?: InputMaybe<SortDirection>;
};

export type MinimalProfileShareWhere = {
  AND?: InputMaybe<Array<MinimalProfileShareWhere>>;
  NOT?: InputMaybe<MinimalProfileShareWhere>;
  OR?: InputMaybe<Array<MinimalProfileShareWhere>>;
  uuid?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MinimalProfileSharesConnection = {
  __typename?: "MinimalProfileSharesConnection";
  edges: Array<MinimalProfileShareEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type MinimalUser = {
  __typename?: "MinimalUser";
  uuid: Scalars["ID"]["output"];
};

export type Mutation = {
  __typename?: "Mutation";
  createApplications: CreateApplicationsMutationResponse;
  createAuthClients: CreateAuthClientsMutationResponse;
  createFederatedClients: CreateFederatedClientsMutationResponse;
  createGroups: CreateGroupsMutationResponse;
  createOrganizations: CreateOrganizationsMutationResponse;
  createProfileShares: CreateProfileSharesMutationResponse;
  createProfiles: CreateProfilesMutationResponse;
  createProfilesFromProfileShares: CreateProfilesFromProfileSharesMutationResponse;
  createProperties: CreatePropertiesMutationResponse;
  createUsers: CreateUsersMutationResponse;
  deleteApplications: DeleteInfo;
  deleteAuthClients: CustomDeleteInfo;
  deleteFederatedClients: DeleteInfo;
  deleteGroups: DeleteInfo;
  deleteOrganizations: DeleteInfo;
  deleteProfileShares: DeleteInfo;
  deleteProfiles: DeleteInfo;
  deleteProperties: DeleteInfo;
  deleteUsers: DeleteInfo;
  /** merge n profiles into one. if forcePrimary is given this profile will be used as new primary. otherwise we will decide from eg users/roles etc */
  mergeProfiles?: Maybe<Profile>;
  /** Replace any existing properties with given subject and scope by the given properties. */
  replaceGroupProperties: ReplacePropertiesMutationResponse;
  /** Replace any existing properties with given subject and scope by the given properties. */
  replaceOrganizationProperties: ReplacePropertiesMutationResponse;
  /** Replace any existing properties with given subject and scope by the given properties. */
  replaceProfileProperties: ReplacePropertiesMutationResponse;
  /** Replace any existing properties with given subject and scope by the given properties. */
  replaceUserProperties: ReplacePropertiesMutationResponse;
  /**
   * Revoke an open invitation completely (token and expiry). Omni-admin only.
   * Clearing only the expiry via updateUsers leaves a token that never expires.
   */
  revokeInvitation: AccountAccessMutationResponse;
  /** Revoke an open password reset completely (token and expiry). Omni-admin only. */
  revokePasswordReset: AccountAccessMutationResponse;
  /** Set a single property, replacing any existing with same subject, scope and name, or add a new one. */
  setGroupProperty: SetPropertyMutationResponse;
  /**
   * Toggle "login only via the linked parent account". Omni-admin only. Setting
   * it to true also revokes an open invitation and an open password reset: an
   * account without its own login has no link it could redeem.
   */
  setImpersonateOnly: AccountAccessMutationResponse;
  /** Set a single property, replacing any existing with same subject, scope and name, or add a new one. */
  setOrganizationProperty: SetPropertyMutationResponse;
  /** Set a single property, replacing any existing with same subject, scope and name, or add a new one. */
  setProfileProperty: SetPropertyMutationResponse;
  /** Set a single property, replacing any existing with same subject, scope and name, or add a new one. */
  setUserProperty: SetPropertyMutationResponse;
  /** Unset the property with given subject, scope and name. */
  unsetGroupProperty: UnsetPropertyMutationResponse;
  /** Unset the property with given subject, scope and name. */
  unsetOrganizationProperty: UnsetPropertyMutationResponse;
  /** Unset the property with given subject, scope and name. */
  unsetProfileProperty: UnsetPropertyMutationResponse;
  /** Unset the property with given subject, scope and name. */
  unsetUserProperty: UnsetPropertyMutationResponse;
  updateApplications: UpdateApplicationsMutationResponse;
  updateAuthClients: UpdateAuthClientsMutationResponse;
  updateFederatedClients: UpdateFederatedClientsMutationResponse;
  updateGroups: UpdateGroupsMutationResponse;
  updateOrganizations: UpdateOrganizationsMutationResponse;
  updatePasswords: UpdatePasswordsMutationResponse;
  updateProfileShares: UpdateProfileSharesMutationResponse;
  updateProfiles: UpdateProfilesMutationResponse;
  updateProperties: UpdatePropertiesMutationResponse;
  updateUsers: UpdateUsersMutationResponse;
};

export type MutationCreateApplicationsArgs = {
  input: Array<ApplicationCreateInput>;
};

export type MutationCreateAuthClientsArgs = {
  input: Array<AuthClientCreateInput>;
};

export type MutationCreateFederatedClientsArgs = {
  input: Array<FederatedClientCreateInput>;
};

export type MutationCreateGroupsArgs = {
  input: Array<GroupCreateInput>;
};

export type MutationCreateOrganizationsArgs = {
  input: Array<OrganizationCreateInput>;
};

export type MutationCreateProfileSharesArgs = {
  input: Array<ProfileShareCreateInput>;
};

export type MutationCreateProfilesArgs = {
  input: Array<ProfileCreateInput>;
};

export type MutationCreateProfilesFromProfileSharesArgs = {
  where?: InputMaybe<ProfileShareWhere>;
};

export type MutationCreatePropertiesArgs = {
  input: Array<PropertyCreateInput>;
};

export type MutationCreateUsersArgs = {
  input: Array<UserCreateInput>;
};

export type MutationDeleteApplicationsArgs = {
  delete?: InputMaybe<ApplicationDeleteInput>;
  where?: InputMaybe<ApplicationWhere>;
};

export type MutationDeleteAuthClientsArgs = {
  where: AuthClientWhere;
};

export type MutationDeleteFederatedClientsArgs = {
  where?: InputMaybe<FederatedClientWhere>;
};

export type MutationDeleteGroupsArgs = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<GroupWhere>;
};

export type MutationDeleteOrganizationsArgs = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<OrganizationWhere>;
};

export type MutationDeleteProfileSharesArgs = {
  delete?: InputMaybe<ProfileShareDeleteInput>;
  where?: InputMaybe<ProfileShareWhere>;
};

export type MutationDeleteProfilesArgs = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ProfileWhere>;
};

export type MutationDeletePropertiesArgs = {
  delete?: InputMaybe<PropertyDeleteInput>;
  where?: InputMaybe<PropertyWhere>;
};

export type MutationDeleteUsersArgs = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<UserWhere>;
};

export type MutationMergeProfilesArgs = {
  forcePrimary?: InputMaybe<Scalars["ID"]["input"]>;
  profiles: Array<Scalars["ID"]["input"]>;
};

export type MutationReplaceGroupPropertiesArgs = {
  groupUuid: Scalars["ID"]["input"];
  input: Array<PropertyDataCreateInput>;
  scope: Scalars["String"]["input"];
};

export type MutationReplaceOrganizationPropertiesArgs = {
  input: Array<PropertyDataCreateInput>;
  organizationUuid: Scalars["ID"]["input"];
  scope: Scalars["String"]["input"];
};

export type MutationReplaceProfilePropertiesArgs = {
  input: Array<PropertyDataCreateInput>;
  profileUuid: Scalars["ID"]["input"];
  scope: Scalars["String"]["input"];
};

export type MutationReplaceUserPropertiesArgs = {
  input: Array<PropertyDataCreateInput>;
  scope: Scalars["String"]["input"];
  userUuid: Scalars["ID"]["input"];
};

export type MutationRevokeInvitationArgs = {
  userUuid: Scalars["ID"]["input"];
};

export type MutationRevokePasswordResetArgs = {
  userUuid: Scalars["ID"]["input"];
};

export type MutationSetGroupPropertyArgs = {
  groupUuid: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  scope: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type MutationSetImpersonateOnlyArgs = {
  impersonateOnly: Scalars["Boolean"]["input"];
  userUuid: Scalars["ID"]["input"];
};

export type MutationSetOrganizationPropertyArgs = {
  name: Scalars["String"]["input"];
  organizationUuid: Scalars["ID"]["input"];
  scope: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type MutationSetProfilePropertyArgs = {
  name: Scalars["String"]["input"];
  profileUuid: Scalars["ID"]["input"];
  scope: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type MutationSetUserPropertyArgs = {
  name: Scalars["String"]["input"];
  scope: Scalars["String"]["input"];
  userUuid: Scalars["ID"]["input"];
  value: Scalars["String"]["input"];
};

export type MutationUnsetGroupPropertyArgs = {
  groupUuid: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  scope: Scalars["String"]["input"];
};

export type MutationUnsetOrganizationPropertyArgs = {
  name: Scalars["String"]["input"];
  organizationUuid: Scalars["ID"]["input"];
  scope: Scalars["String"]["input"];
};

export type MutationUnsetProfilePropertyArgs = {
  name: Scalars["String"]["input"];
  profileUuid: Scalars["ID"]["input"];
  scope: Scalars["String"]["input"];
};

export type MutationUnsetUserPropertyArgs = {
  name: Scalars["String"]["input"];
  scope: Scalars["String"]["input"];
  userUuid: Scalars["ID"]["input"];
};

export type MutationUpdateApplicationsArgs = {
  update?: InputMaybe<ApplicationUpdateInput>;
  where?: InputMaybe<ApplicationWhere>;
};

export type MutationUpdateAuthClientsArgs = {
  update: AuthClientUpdateInput;
  where: AuthClientWhere;
};

export type MutationUpdateFederatedClientsArgs = {
  update?: InputMaybe<FederatedClientUpdateInput>;
  where?: InputMaybe<FederatedClientWhere>;
};

export type MutationUpdateGroupsArgs = {
  update?: InputMaybe<GroupUpdateInput>;
  where?: InputMaybe<GroupWhere>;
};

export type MutationUpdateOrganizationsArgs = {
  update?: InputMaybe<OrganizationUpdateInput>;
  where?: InputMaybe<OrganizationWhere>;
};

export type MutationUpdatePasswordsArgs = {
  update: PasswordUpdateInput;
  where: PasswordWhere;
};

export type MutationUpdateProfileSharesArgs = {
  update?: InputMaybe<ProfileShareUpdateInput>;
  where?: InputMaybe<ProfileShareWhere>;
};

export type MutationUpdateProfilesArgs = {
  update?: InputMaybe<ProfileUpdateInput>;
  where?: InputMaybe<ProfileWhere>;
};

export type MutationUpdatePropertiesArgs = {
  update?: InputMaybe<PropertyUpdateInput>;
  where?: InputMaybe<PropertyWhere>;
};

export type MutationUpdateUsersArgs = {
  update?: InputMaybe<UserUpdateInput>;
  where?: InputMaybe<UserWhere>;
};

export type Organization = {
  __typename?: "Organization";
  address1?: Maybe<Scalars["String"]["output"]>;
  address2?: Maybe<Scalars["String"]["output"]>;
  address3?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  collaboratesWith: Array<Organization>;
  collaboratesWithConnection: OrganizationCollaboratesWithConnection;
  country?: Maybe<Scalars["String"]["output"]>;
  federatedClient: Array<FederatedClient>;
  federatedClientConnection: OrganizationFederatedClientConnection;
  groups: Array<Group>;
  groupsConnection: OrganizationGroupsConnection;
  imprintHtml?: Maybe<Scalars["String"]["output"]>;
  incomingRoles: Array<RoleTarget>;
  incomingRolesConnection: OrganizationIncomingRolesConnection;
  licensedApplications: Array<Application>;
  licensedApplicationsConnection: OrganizationLicensedApplicationsConnection;
  locale: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  privacyHtml?: Maybe<Scalars["String"]["output"]>;
  profiles: Array<Profile>;
  profilesConnection: OrganizationProfilesConnection;
  properties: Array<Property>;
  propertiesConnection: OrganizationPropertiesConnection;
  region?: Maybe<Scalars["String"]["output"]>;
  shadowProfileGroups: Array<Group>;
  shadowProfileGroupsConnection: OrganizationShadowProfileGroupsConnection;
  shadowsProfilesTo: Array<Organization>;
  shadowsProfilesToConnection: OrganizationShadowsProfilesToConnection;
  /** Number of member profiles holding the STUDENT role in this organization. */
  studentCount?: Maybe<Scalars["Int"]["output"]>;
  tecartContactId?: Maybe<Scalars["String"]["output"]>;
  timezone: Scalars["String"]["output"];
  tosHtml?: Maybe<Scalars["String"]["output"]>;
  tosVersion?: Maybe<Scalars["String"]["output"]>;
  uuid: Scalars["ID"]["output"];
  zipCode?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationCollaboratesWithArgs = {
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type OrganizationCollaboratesWithConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<OrganizationCollaboratesWithConnectionSort>>;
  where?: InputMaybe<OrganizationCollaboratesWithConnectionWhere>;
};

export type OrganizationFederatedClientArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<FederatedClientOptions>;
  where?: InputMaybe<FederatedClientWhere>;
};

export type OrganizationFederatedClientConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<OrganizationFederatedClientConnectionSort>>;
  where?: InputMaybe<OrganizationFederatedClientConnectionWhere>;
};

export type OrganizationGroupsArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type OrganizationGroupsConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<OrganizationGroupsConnectionSort>>;
  where?: InputMaybe<OrganizationGroupsConnectionWhere>;
};

export type OrganizationIncomingRolesArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<RoleTargetWhere>;
};

export type OrganizationIncomingRolesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<OrganizationIncomingRolesConnectionSort>>;
  where?: InputMaybe<OrganizationIncomingRolesConnectionWhere>;
};

export type OrganizationLicensedApplicationsArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<ApplicationOptions>;
  where?: InputMaybe<ApplicationWhere>;
};

export type OrganizationLicensedApplicationsConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<OrganizationLicensedApplicationsConnectionSort>>;
  where?: InputMaybe<OrganizationLicensedApplicationsConnectionWhere>;
};

export type OrganizationProfilesArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type OrganizationProfilesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<OrganizationProfilesConnectionSort>>;
  where?: InputMaybe<OrganizationProfilesConnectionWhere>;
};

export type OrganizationPropertiesArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<PropertyOptions>;
  where?: InputMaybe<PropertyWhere>;
};

export type OrganizationPropertiesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<OrganizationPropertiesConnectionSort>>;
  where?: InputMaybe<OrganizationPropertiesConnectionWhere>;
};

export type OrganizationShadowProfileGroupsArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type OrganizationShadowProfileGroupsConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<OrganizationShadowProfileGroupsConnectionSort>>;
  where?: InputMaybe<OrganizationShadowProfileGroupsConnectionWhere>;
};

export type OrganizationShadowsProfilesToArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type OrganizationShadowsProfilesToConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<OrganizationShadowsProfilesToConnectionSort>>;
  where?: InputMaybe<OrganizationShadowsProfilesToConnectionWhere>;
};

export type OrganizationAggregateSelection = {
  __typename?: "OrganizationAggregateSelection";
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  city: StringAggregateSelection;
  count: Scalars["Int"]["output"];
  country: StringAggregateSelection;
  imprintHtml: StringAggregateSelection;
  locale: StringAggregateSelection;
  name: StringAggregateSelection;
  privacyHtml: StringAggregateSelection;
  region: StringAggregateSelection;
  tecartContactId: StringAggregateSelection;
  timezone: StringAggregateSelection;
  tosHtml: StringAggregateSelection;
  tosVersion: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zipCode: StringAggregateSelection;
};

export type OrganizationCollaboratesWithAggregateInput = {
  AND?: InputMaybe<Array<OrganizationCollaboratesWithAggregateInput>>;
  NOT?: InputMaybe<OrganizationCollaboratesWithAggregateInput>;
  OR?: InputMaybe<Array<OrganizationCollaboratesWithAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  edge?: InputMaybe<CollaborationPropertiesAggregationWhereInput>;
  node?: InputMaybe<OrganizationCollaboratesWithNodeAggregationWhereInput>;
};

export type OrganizationCollaboratesWithConnectFieldInput = {
  connect?: InputMaybe<Array<OrganizationConnectInput>>;
  edge: CollaborationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type OrganizationCollaboratesWithConnection = {
  __typename?: "OrganizationCollaboratesWithConnection";
  edges: Array<OrganizationCollaboratesWithRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type OrganizationCollaboratesWithConnectionSort = {
  edge?: InputMaybe<CollaborationPropertiesSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type OrganizationCollaboratesWithConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationCollaboratesWithConnectionWhere>>;
  NOT?: InputMaybe<OrganizationCollaboratesWithConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationCollaboratesWithConnectionWhere>>;
  edge?: InputMaybe<CollaborationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<CollaborationPropertiesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type OrganizationCollaboratesWithCreateFieldInput = {
  edge: CollaborationPropertiesCreateInput;
  node: OrganizationCreateInput;
};

export type OrganizationCollaboratesWithDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<OrganizationCollaboratesWithConnectionWhere>;
};

export type OrganizationCollaboratesWithDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<OrganizationCollaboratesWithConnectionWhere>;
};

export type OrganizationCollaboratesWithFieldInput = {
  connect?: InputMaybe<Array<OrganizationCollaboratesWithConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationCollaboratesWithCreateFieldInput>>;
};

export type OrganizationCollaboratesWithNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationCollaboratesWithNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationCollaboratesWithNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationCollaboratesWithNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationCollaboratesWithRelationship = {
  __typename?: "OrganizationCollaboratesWithRelationship";
  cursor: Scalars["String"]["output"];
  node: Organization;
  properties: CollaborationProperties;
};

export type OrganizationCollaboratesWithUpdateConnectionInput = {
  edge?: InputMaybe<CollaborationPropertiesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type OrganizationCollaboratesWithUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationCollaboratesWithConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationCollaboratesWithCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationCollaboratesWithDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationCollaboratesWithDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationCollaboratesWithUpdateConnectionInput>;
  where?: InputMaybe<OrganizationCollaboratesWithConnectionWhere>;
};

export type OrganizationConnectInput = {
  collaboratesWith?: InputMaybe<Array<OrganizationCollaboratesWithConnectFieldInput>>;
  federatedClient?: InputMaybe<Array<OrganizationFederatedClientConnectFieldInput>>;
  groups?: InputMaybe<Array<OrganizationGroupsConnectFieldInput>>;
  incomingRoles?: InputMaybe<OrganizationIncomingRolesConnectInput>;
  profiles?: InputMaybe<Array<OrganizationProfilesConnectFieldInput>>;
  properties?: InputMaybe<Array<OrganizationPropertiesConnectFieldInput>>;
  shadowProfileGroups?: InputMaybe<Array<OrganizationShadowProfileGroupsConnectFieldInput>>;
  shadowsProfilesTo?: InputMaybe<Array<OrganizationShadowsProfilesToConnectFieldInput>>;
};

export type OrganizationConnectWhere = {
  node: OrganizationWhere;
};

export type OrganizationCreateInput = {
  address1?: InputMaybe<Scalars["String"]["input"]>;
  address2?: InputMaybe<Scalars["String"]["input"]>;
  address3?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  collaboratesWith?: InputMaybe<OrganizationCollaboratesWithFieldInput>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  federatedClient?: InputMaybe<OrganizationFederatedClientFieldInput>;
  groups?: InputMaybe<OrganizationGroupsFieldInput>;
  imprintHtml?: InputMaybe<Scalars["String"]["input"]>;
  incomingRoles?: InputMaybe<OrganizationIncomingRolesCreateInput>;
  locale: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  privacyHtml?: InputMaybe<Scalars["String"]["input"]>;
  profiles?: InputMaybe<OrganizationProfilesFieldInput>;
  properties?: InputMaybe<OrganizationPropertiesFieldInput>;
  region?: InputMaybe<Scalars["String"]["input"]>;
  shadowProfileGroups?: InputMaybe<OrganizationShadowProfileGroupsFieldInput>;
  shadowsProfilesTo?: InputMaybe<OrganizationShadowsProfilesToFieldInput>;
  tecartContactId?: InputMaybe<Scalars["String"]["input"]>;
  timezone: Scalars["String"]["input"];
  tosHtml?: InputMaybe<Scalars["String"]["input"]>;
  tosVersion?: InputMaybe<Scalars["String"]["input"]>;
  zipCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationDeleteInput = {
  collaboratesWith?: InputMaybe<Array<OrganizationCollaboratesWithDeleteFieldInput>>;
  federatedClient?: InputMaybe<Array<OrganizationFederatedClientDeleteFieldInput>>;
  groups?: InputMaybe<Array<OrganizationGroupsDeleteFieldInput>>;
  incomingRoles?: InputMaybe<OrganizationIncomingRolesDeleteInput>;
  profiles?: InputMaybe<Array<OrganizationProfilesDeleteFieldInput>>;
  properties?: InputMaybe<Array<OrganizationPropertiesDeleteFieldInput>>;
  shadowProfileGroups?: InputMaybe<Array<OrganizationShadowProfileGroupsDeleteFieldInput>>;
  shadowsProfilesTo?: InputMaybe<Array<OrganizationShadowsProfilesToDeleteFieldInput>>;
};

export type OrganizationDisconnectInput = {
  collaboratesWith?: InputMaybe<Array<OrganizationCollaboratesWithDisconnectFieldInput>>;
  federatedClient?: InputMaybe<Array<OrganizationFederatedClientDisconnectFieldInput>>;
  groups?: InputMaybe<Array<OrganizationGroupsDisconnectFieldInput>>;
  incomingRoles?: InputMaybe<OrganizationIncomingRolesDisconnectInput>;
  profiles?: InputMaybe<Array<OrganizationProfilesDisconnectFieldInput>>;
  properties?: InputMaybe<Array<OrganizationPropertiesDisconnectFieldInput>>;
  shadowProfileGroups?: InputMaybe<Array<OrganizationShadowProfileGroupsDisconnectFieldInput>>;
  shadowsProfilesTo?: InputMaybe<Array<OrganizationShadowsProfilesToDisconnectFieldInput>>;
};

export type OrganizationEdge = {
  __typename?: "OrganizationEdge";
  cursor: Scalars["String"]["output"];
  node: Organization;
};

export type OrganizationFederatedClientAggregateInput = {
  AND?: InputMaybe<Array<OrganizationFederatedClientAggregateInput>>;
  NOT?: InputMaybe<OrganizationFederatedClientAggregateInput>;
  OR?: InputMaybe<Array<OrganizationFederatedClientAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<OrganizationFederatedClientNodeAggregationWhereInput>;
};

export type OrganizationFederatedClientConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<FederatedClientConnectWhere>;
};

export type OrganizationFederatedClientConnection = {
  __typename?: "OrganizationFederatedClientConnection";
  edges: Array<OrganizationFederatedClientRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type OrganizationFederatedClientConnectionSort = {
  node?: InputMaybe<FederatedClientSort>;
};

export type OrganizationFederatedClientConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationFederatedClientConnectionWhere>>;
  NOT?: InputMaybe<OrganizationFederatedClientConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationFederatedClientConnectionWhere>>;
  node?: InputMaybe<FederatedClientWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<FederatedClientWhere>;
};

export type OrganizationFederatedClientCreateFieldInput = {
  node: FederatedClientCreateInput;
};

export type OrganizationFederatedClientDeleteFieldInput = {
  where?: InputMaybe<OrganizationFederatedClientConnectionWhere>;
};

export type OrganizationFederatedClientDisconnectFieldInput = {
  where?: InputMaybe<OrganizationFederatedClientConnectionWhere>;
};

export type OrganizationFederatedClientFieldInput = {
  connect?: InputMaybe<Array<OrganizationFederatedClientConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationFederatedClientCreateFieldInput>>;
};

export type OrganizationFederatedClientNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationFederatedClientNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationFederatedClientNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationFederatedClientNodeAggregationWhereInput>>;
  clientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  clientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  clientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  clientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  clientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  clientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  clientSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  clientSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  clientSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  clientSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  clientSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  issuer_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  issuer_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  issuer_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  issuer_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  issuer_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationFederatedClientRelationship = {
  __typename?: "OrganizationFederatedClientRelationship";
  cursor: Scalars["String"]["output"];
  node: FederatedClient;
};

export type OrganizationFederatedClientUpdateConnectionInput = {
  node?: InputMaybe<FederatedClientUpdateInput>;
};

export type OrganizationFederatedClientUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationFederatedClientConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationFederatedClientCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationFederatedClientDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationFederatedClientDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationFederatedClientUpdateConnectionInput>;
  where?: InputMaybe<OrganizationFederatedClientConnectionWhere>;
};

export type OrganizationGroupsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationGroupsAggregateInput>>;
  NOT?: InputMaybe<OrganizationGroupsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationGroupsAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<OrganizationGroupsNodeAggregationWhereInput>;
};

export type OrganizationGroupsConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<GroupConnectWhere>;
};

export type OrganizationGroupsConnection = {
  __typename?: "OrganizationGroupsConnection";
  edges: Array<OrganizationGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type OrganizationGroupsConnectionSort = {
  node?: InputMaybe<GroupSort>;
};

export type OrganizationGroupsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationGroupsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationGroupsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationGroupsConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type OrganizationGroupsCreateFieldInput = {
  node: GroupCreateInput;
};

export type OrganizationGroupsDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<OrganizationGroupsConnectionWhere>;
};

export type OrganizationGroupsDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<OrganizationGroupsConnectionWhere>;
};

export type OrganizationGroupsFieldInput = {
  connect?: InputMaybe<Array<OrganizationGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationGroupsCreateFieldInput>>;
};

export type OrganizationGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationGroupsNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationGroupsRelationship = {
  __typename?: "OrganizationGroupsRelationship";
  cursor: Scalars["String"]["output"];
  node: Group;
};

export type OrganizationGroupsUpdateConnectionInput = {
  node?: InputMaybe<GroupUpdateInput>;
};

export type OrganizationGroupsUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationGroupsCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationGroupsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationGroupsDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationGroupsUpdateConnectionInput>;
  where?: InputMaybe<OrganizationGroupsConnectionWhere>;
};

export type OrganizationIncomingRolesConnectInput = {
  Group?: InputMaybe<Array<OrganizationIncomingRolesGroupConnectFieldInput>>;
  Organization?: InputMaybe<Array<OrganizationIncomingRolesOrganizationConnectFieldInput>>;
  Profile?: InputMaybe<Array<OrganizationIncomingRolesProfileConnectFieldInput>>;
  User?: InputMaybe<Array<OrganizationIncomingRolesUserConnectFieldInput>>;
};

export type OrganizationIncomingRolesConnection = {
  __typename?: "OrganizationIncomingRolesConnection";
  edges: Array<OrganizationIncomingRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type OrganizationIncomingRolesConnectionSort = {
  edge?: InputMaybe<RoleNamesSort>;
};

export type OrganizationIncomingRolesConnectionWhere = {
  Group?: InputMaybe<OrganizationIncomingRolesGroupConnectionWhere>;
  Organization?: InputMaybe<OrganizationIncomingRolesOrganizationConnectionWhere>;
  Profile?: InputMaybe<OrganizationIncomingRolesProfileConnectionWhere>;
  User?: InputMaybe<OrganizationIncomingRolesUserConnectionWhere>;
};

export type OrganizationIncomingRolesCreateInput = {
  Group?: InputMaybe<OrganizationIncomingRolesGroupFieldInput>;
  Organization?: InputMaybe<OrganizationIncomingRolesOrganizationFieldInput>;
  Profile?: InputMaybe<OrganizationIncomingRolesProfileFieldInput>;
  User?: InputMaybe<OrganizationIncomingRolesUserFieldInput>;
};

export type OrganizationIncomingRolesDeleteInput = {
  Group?: InputMaybe<Array<OrganizationIncomingRolesGroupDeleteFieldInput>>;
  Organization?: InputMaybe<Array<OrganizationIncomingRolesOrganizationDeleteFieldInput>>;
  Profile?: InputMaybe<Array<OrganizationIncomingRolesProfileDeleteFieldInput>>;
  User?: InputMaybe<Array<OrganizationIncomingRolesUserDeleteFieldInput>>;
};

export type OrganizationIncomingRolesDisconnectInput = {
  Group?: InputMaybe<Array<OrganizationIncomingRolesGroupDisconnectFieldInput>>;
  Organization?: InputMaybe<Array<OrganizationIncomingRolesOrganizationDisconnectFieldInput>>;
  Profile?: InputMaybe<Array<OrganizationIncomingRolesProfileDisconnectFieldInput>>;
  User?: InputMaybe<Array<OrganizationIncomingRolesUserDisconnectFieldInput>>;
};

export type OrganizationIncomingRolesGroupConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<GroupConnectWhere>;
};

export type OrganizationIncomingRolesGroupConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationIncomingRolesGroupConnectionWhere>>;
  NOT?: InputMaybe<OrganizationIncomingRolesGroupConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationIncomingRolesGroupConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type OrganizationIncomingRolesGroupCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: GroupCreateInput;
};

export type OrganizationIncomingRolesGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<OrganizationIncomingRolesGroupConnectionWhere>;
};

export type OrganizationIncomingRolesGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<OrganizationIncomingRolesGroupConnectionWhere>;
};

export type OrganizationIncomingRolesGroupFieldInput = {
  connect?: InputMaybe<Array<OrganizationIncomingRolesGroupConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationIncomingRolesGroupCreateFieldInput>>;
};

export type OrganizationIncomingRolesGroupUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<GroupUpdateInput>;
};

export type OrganizationIncomingRolesGroupUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationIncomingRolesGroupConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationIncomingRolesGroupCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationIncomingRolesGroupDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationIncomingRolesGroupDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationIncomingRolesGroupUpdateConnectionInput>;
  where?: InputMaybe<OrganizationIncomingRolesGroupConnectionWhere>;
};

export type OrganizationIncomingRolesOrganizationConnectFieldInput = {
  connect?: InputMaybe<Array<OrganizationConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type OrganizationIncomingRolesOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationIncomingRolesOrganizationConnectionWhere>>;
  NOT?: InputMaybe<OrganizationIncomingRolesOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationIncomingRolesOrganizationConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type OrganizationIncomingRolesOrganizationCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: OrganizationCreateInput;
};

export type OrganizationIncomingRolesOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<OrganizationIncomingRolesOrganizationConnectionWhere>;
};

export type OrganizationIncomingRolesOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<OrganizationIncomingRolesOrganizationConnectionWhere>;
};

export type OrganizationIncomingRolesOrganizationFieldInput = {
  connect?: InputMaybe<Array<OrganizationIncomingRolesOrganizationConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationIncomingRolesOrganizationCreateFieldInput>>;
};

export type OrganizationIncomingRolesOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type OrganizationIncomingRolesOrganizationUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationIncomingRolesOrganizationConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationIncomingRolesOrganizationCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationIncomingRolesOrganizationDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationIncomingRolesOrganizationDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationIncomingRolesOrganizationUpdateConnectionInput>;
  where?: InputMaybe<OrganizationIncomingRolesOrganizationConnectionWhere>;
};

export type OrganizationIncomingRolesProfileConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<ProfileConnectWhere>;
};

export type OrganizationIncomingRolesProfileConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationIncomingRolesProfileConnectionWhere>>;
  NOT?: InputMaybe<OrganizationIncomingRolesProfileConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationIncomingRolesProfileConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type OrganizationIncomingRolesProfileCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: ProfileCreateInput;
};

export type OrganizationIncomingRolesProfileDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<OrganizationIncomingRolesProfileConnectionWhere>;
};

export type OrganizationIncomingRolesProfileDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<OrganizationIncomingRolesProfileConnectionWhere>;
};

export type OrganizationIncomingRolesProfileFieldInput = {
  connect?: InputMaybe<Array<OrganizationIncomingRolesProfileConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationIncomingRolesProfileCreateFieldInput>>;
};

export type OrganizationIncomingRolesProfileUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type OrganizationIncomingRolesProfileUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationIncomingRolesProfileConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationIncomingRolesProfileCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationIncomingRolesProfileDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationIncomingRolesProfileDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationIncomingRolesProfileUpdateConnectionInput>;
  where?: InputMaybe<OrganizationIncomingRolesProfileConnectionWhere>;
};

export type OrganizationIncomingRolesRelationship = {
  __typename?: "OrganizationIncomingRolesRelationship";
  cursor: Scalars["String"]["output"];
  node: RoleTarget;
  properties: RoleNames;
};

export type OrganizationIncomingRolesUpdateInput = {
  Group?: InputMaybe<Array<OrganizationIncomingRolesGroupUpdateFieldInput>>;
  Organization?: InputMaybe<Array<OrganizationIncomingRolesOrganizationUpdateFieldInput>>;
  Profile?: InputMaybe<Array<OrganizationIncomingRolesProfileUpdateFieldInput>>;
  User?: InputMaybe<Array<OrganizationIncomingRolesUserUpdateFieldInput>>;
};

export type OrganizationIncomingRolesUserConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<UserConnectWhere>;
};

export type OrganizationIncomingRolesUserConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationIncomingRolesUserConnectionWhere>>;
  NOT?: InputMaybe<OrganizationIncomingRolesUserConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationIncomingRolesUserConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<UserWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<UserWhere>;
};

export type OrganizationIncomingRolesUserCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: UserCreateInput;
};

export type OrganizationIncomingRolesUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<OrganizationIncomingRolesUserConnectionWhere>;
};

export type OrganizationIncomingRolesUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<OrganizationIncomingRolesUserConnectionWhere>;
};

export type OrganizationIncomingRolesUserFieldInput = {
  connect?: InputMaybe<Array<OrganizationIncomingRolesUserConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationIncomingRolesUserCreateFieldInput>>;
};

export type OrganizationIncomingRolesUserUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type OrganizationIncomingRolesUserUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationIncomingRolesUserConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationIncomingRolesUserCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationIncomingRolesUserDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationIncomingRolesUserDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationIncomingRolesUserUpdateConnectionInput>;
  where?: InputMaybe<OrganizationIncomingRolesUserConnectionWhere>;
};

export type OrganizationLicensedApplicationsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationLicensedApplicationsAggregateInput>>;
  NOT?: InputMaybe<OrganizationLicensedApplicationsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationLicensedApplicationsAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  edge?: InputMaybe<LicensePropertiesAggregationWhereInput>;
  node?: InputMaybe<OrganizationLicensedApplicationsNodeAggregationWhereInput>;
};

export type OrganizationLicensedApplicationsConnection = {
  __typename?: "OrganizationLicensedApplicationsConnection";
  edges: Array<OrganizationLicensedApplicationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type OrganizationLicensedApplicationsConnectionSort = {
  edge?: InputMaybe<LicensePropertiesSort>;
  node?: InputMaybe<ApplicationSort>;
};

export type OrganizationLicensedApplicationsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationLicensedApplicationsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationLicensedApplicationsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationLicensedApplicationsConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<ApplicationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ApplicationWhere>;
};

export type OrganizationLicensedApplicationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationLicensedApplicationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationLicensedApplicationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationLicensedApplicationsNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  uri_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  uri_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  uri_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  uri_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  uri_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  uri_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  uri_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  uri_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  uri_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  uri_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  uri_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  uri_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  uri_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  uri_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  uri_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationLicensedApplicationsRelationship = {
  __typename?: "OrganizationLicensedApplicationsRelationship";
  cursor: Scalars["String"]["output"];
  node: Application;
  properties: LicenseProperties;
};

export type OrganizationOptions = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Specify one or more OrganizationSort objects to sort Organizations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OrganizationSort>>;
};

export type OrganizationProfilesAggregateInput = {
  AND?: InputMaybe<Array<OrganizationProfilesAggregateInput>>;
  NOT?: InputMaybe<OrganizationProfilesAggregateInput>;
  OR?: InputMaybe<Array<OrganizationProfilesAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<OrganizationProfilesNodeAggregationWhereInput>;
};

export type OrganizationProfilesConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type OrganizationProfilesConnection = {
  __typename?: "OrganizationProfilesConnection";
  edges: Array<OrganizationProfilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type OrganizationProfilesConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type OrganizationProfilesConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationProfilesConnectionWhere>>;
  NOT?: InputMaybe<OrganizationProfilesConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationProfilesConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type OrganizationProfilesCreateFieldInput = {
  node: ProfileCreateInput;
};

export type OrganizationProfilesDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<OrganizationProfilesConnectionWhere>;
};

export type OrganizationProfilesDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<OrganizationProfilesConnectionWhere>;
};

export type OrganizationProfilesFieldInput = {
  connect?: InputMaybe<Array<OrganizationProfilesConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationProfilesCreateFieldInput>>;
};

export type OrganizationProfilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationProfilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationProfilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationProfilesNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosAccepted_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationProfilesRelationship = {
  __typename?: "OrganizationProfilesRelationship";
  cursor: Scalars["String"]["output"];
  node: Profile;
};

export type OrganizationProfilesUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type OrganizationProfilesUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationProfilesConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationProfilesCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationProfilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationProfilesDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationProfilesUpdateConnectionInput>;
  where?: InputMaybe<OrganizationProfilesConnectionWhere>;
};

export type OrganizationPropertiesAggregateInput = {
  AND?: InputMaybe<Array<OrganizationPropertiesAggregateInput>>;
  NOT?: InputMaybe<OrganizationPropertiesAggregateInput>;
  OR?: InputMaybe<Array<OrganizationPropertiesAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  edge?: InputMaybe<PropertiesScopeAggregationWhereInput>;
  node?: InputMaybe<OrganizationPropertiesNodeAggregationWhereInput>;
};

export type OrganizationPropertiesConnectFieldInput = {
  connect?: InputMaybe<Array<PropertyConnectInput>>;
  edge: PropertiesScopeCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<PropertyConnectWhere>;
};

export type OrganizationPropertiesConnection = {
  __typename?: "OrganizationPropertiesConnection";
  edges: Array<OrganizationPropertiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type OrganizationPropertiesConnectionSort = {
  edge?: InputMaybe<PropertiesScopeSort>;
  node?: InputMaybe<PropertySort>;
};

export type OrganizationPropertiesConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationPropertiesConnectionWhere>>;
  NOT?: InputMaybe<OrganizationPropertiesConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationPropertiesConnectionWhere>>;
  edge?: InputMaybe<PropertiesScopeWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PropertiesScopeWhere>;
  node?: InputMaybe<PropertyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PropertyWhere>;
};

export type OrganizationPropertiesCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: PropertyCreateInput;
};

export type OrganizationPropertiesDeleteFieldInput = {
  delete?: InputMaybe<PropertyDeleteInput>;
  where?: InputMaybe<OrganizationPropertiesConnectionWhere>;
};

export type OrganizationPropertiesDisconnectFieldInput = {
  disconnect?: InputMaybe<PropertyDisconnectInput>;
  where?: InputMaybe<OrganizationPropertiesConnectionWhere>;
};

export type OrganizationPropertiesFieldInput = {
  connect?: InputMaybe<Array<OrganizationPropertiesConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationPropertiesCreateFieldInput>>;
};

export type OrganizationPropertiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationPropertiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationPropertiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationPropertiesNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  value_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationPropertiesRelationship = {
  __typename?: "OrganizationPropertiesRelationship";
  cursor: Scalars["String"]["output"];
  node: Property;
  properties: PropertiesScope;
};

export type OrganizationPropertiesUpdateConnectionInput = {
  edge?: InputMaybe<PropertiesScopeUpdateInput>;
  node?: InputMaybe<PropertyUpdateInput>;
};

export type OrganizationPropertiesUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationPropertiesConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationPropertiesCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationPropertiesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationPropertiesDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationPropertiesUpdateConnectionInput>;
  where?: InputMaybe<OrganizationPropertiesConnectionWhere>;
};

export type OrganizationShadowProfileGroupsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationShadowProfileGroupsAggregateInput>>;
  NOT?: InputMaybe<OrganizationShadowProfileGroupsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationShadowProfileGroupsAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  edge?: InputMaybe<ShadowRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<OrganizationShadowProfileGroupsNodeAggregationWhereInput>;
};

export type OrganizationShadowProfileGroupsConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  edge: ShadowRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<GroupConnectWhere>;
};

export type OrganizationShadowProfileGroupsConnection = {
  __typename?: "OrganizationShadowProfileGroupsConnection";
  edges: Array<OrganizationShadowProfileGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type OrganizationShadowProfileGroupsConnectionSort = {
  edge?: InputMaybe<ShadowRelationPropertiesSort>;
  node?: InputMaybe<GroupSort>;
};

export type OrganizationShadowProfileGroupsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationShadowProfileGroupsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationShadowProfileGroupsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationShadowProfileGroupsConnectionWhere>>;
  edge?: InputMaybe<ShadowRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<ShadowRelationPropertiesWhere>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type OrganizationShadowProfileGroupsCreateFieldInput = {
  edge: ShadowRelationPropertiesCreateInput;
  node: GroupCreateInput;
};

export type OrganizationShadowProfileGroupsDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<OrganizationShadowProfileGroupsConnectionWhere>;
};

export type OrganizationShadowProfileGroupsDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<OrganizationShadowProfileGroupsConnectionWhere>;
};

export type OrganizationShadowProfileGroupsFieldInput = {
  connect?: InputMaybe<Array<OrganizationShadowProfileGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationShadowProfileGroupsCreateFieldInput>>;
};

export type OrganizationShadowProfileGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationShadowProfileGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationShadowProfileGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationShadowProfileGroupsNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationShadowProfileGroupsRelationship = {
  __typename?: "OrganizationShadowProfileGroupsRelationship";
  cursor: Scalars["String"]["output"];
  node: Group;
  properties: ShadowRelationProperties;
};

export type OrganizationShadowProfileGroupsUpdateConnectionInput = {
  edge?: InputMaybe<ShadowRelationPropertiesUpdateInput>;
  node?: InputMaybe<GroupUpdateInput>;
};

export type OrganizationShadowProfileGroupsUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationShadowProfileGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationShadowProfileGroupsCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationShadowProfileGroupsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationShadowProfileGroupsDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationShadowProfileGroupsUpdateConnectionInput>;
  where?: InputMaybe<OrganizationShadowProfileGroupsConnectionWhere>;
};

export type OrganizationShadowsProfilesToAggregateInput = {
  AND?: InputMaybe<Array<OrganizationShadowsProfilesToAggregateInput>>;
  NOT?: InputMaybe<OrganizationShadowsProfilesToAggregateInput>;
  OR?: InputMaybe<Array<OrganizationShadowsProfilesToAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  edge?: InputMaybe<ShadowRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<OrganizationShadowsProfilesToNodeAggregationWhereInput>;
};

export type OrganizationShadowsProfilesToConnectFieldInput = {
  connect?: InputMaybe<Array<OrganizationConnectInput>>;
  edge: ShadowRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type OrganizationShadowsProfilesToConnection = {
  __typename?: "OrganizationShadowsProfilesToConnection";
  edges: Array<OrganizationShadowsProfilesToRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type OrganizationShadowsProfilesToConnectionSort = {
  edge?: InputMaybe<ShadowRelationPropertiesSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type OrganizationShadowsProfilesToConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationShadowsProfilesToConnectionWhere>>;
  NOT?: InputMaybe<OrganizationShadowsProfilesToConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationShadowsProfilesToConnectionWhere>>;
  edge?: InputMaybe<ShadowRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<ShadowRelationPropertiesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type OrganizationShadowsProfilesToCreateFieldInput = {
  edge: ShadowRelationPropertiesCreateInput;
  node: OrganizationCreateInput;
};

export type OrganizationShadowsProfilesToDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<OrganizationShadowsProfilesToConnectionWhere>;
};

export type OrganizationShadowsProfilesToDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<OrganizationShadowsProfilesToConnectionWhere>;
};

export type OrganizationShadowsProfilesToFieldInput = {
  connect?: InputMaybe<Array<OrganizationShadowsProfilesToConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationShadowsProfilesToCreateFieldInput>>;
};

export type OrganizationShadowsProfilesToNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationShadowsProfilesToNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationShadowsProfilesToNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationShadowsProfilesToNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationShadowsProfilesToRelationship = {
  __typename?: "OrganizationShadowsProfilesToRelationship";
  cursor: Scalars["String"]["output"];
  node: Organization;
  properties: ShadowRelationProperties;
};

export type OrganizationShadowsProfilesToUpdateConnectionInput = {
  edge?: InputMaybe<ShadowRelationPropertiesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type OrganizationShadowsProfilesToUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationShadowsProfilesToConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationShadowsProfilesToCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationShadowsProfilesToDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationShadowsProfilesToDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationShadowsProfilesToUpdateConnectionInput>;
  where?: InputMaybe<OrganizationShadowsProfilesToConnectionWhere>;
};

/** Fields to sort Organizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one OrganizationSort object. */
export type OrganizationSort = {
  address1?: InputMaybe<SortDirection>;
  address2?: InputMaybe<SortDirection>;
  address3?: InputMaybe<SortDirection>;
  city?: InputMaybe<SortDirection>;
  country?: InputMaybe<SortDirection>;
  imprintHtml?: InputMaybe<SortDirection>;
  locale?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  privacyHtml?: InputMaybe<SortDirection>;
  region?: InputMaybe<SortDirection>;
  studentCount?: InputMaybe<SortDirection>;
  tecartContactId?: InputMaybe<SortDirection>;
  timezone?: InputMaybe<SortDirection>;
  tosHtml?: InputMaybe<SortDirection>;
  tosVersion?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  zipCode?: InputMaybe<SortDirection>;
};

export type OrganizationUpdateInput = {
  address1?: InputMaybe<Scalars["String"]["input"]>;
  address2?: InputMaybe<Scalars["String"]["input"]>;
  address3?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  collaboratesWith?: InputMaybe<Array<OrganizationCollaboratesWithUpdateFieldInput>>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  federatedClient?: InputMaybe<Array<OrganizationFederatedClientUpdateFieldInput>>;
  groups?: InputMaybe<Array<OrganizationGroupsUpdateFieldInput>>;
  imprintHtml?: InputMaybe<Scalars["String"]["input"]>;
  incomingRoles?: InputMaybe<OrganizationIncomingRolesUpdateInput>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  privacyHtml?: InputMaybe<Scalars["String"]["input"]>;
  profiles?: InputMaybe<Array<OrganizationProfilesUpdateFieldInput>>;
  properties?: InputMaybe<Array<OrganizationPropertiesUpdateFieldInput>>;
  region?: InputMaybe<Scalars["String"]["input"]>;
  shadowProfileGroups?: InputMaybe<Array<OrganizationShadowProfileGroupsUpdateFieldInput>>;
  shadowsProfilesTo?: InputMaybe<Array<OrganizationShadowsProfilesToUpdateFieldInput>>;
  tecartContactId?: InputMaybe<Scalars["String"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  tosHtml?: InputMaybe<Scalars["String"]["input"]>;
  tosVersion?: InputMaybe<Scalars["String"]["input"]>;
  zipCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationWhere = {
  AND?: InputMaybe<Array<OrganizationWhere>>;
  NOT?: InputMaybe<OrganizationWhere>;
  OR?: InputMaybe<Array<OrganizationWhere>>;
  address1?: InputMaybe<Scalars["String"]["input"]>;
  address1_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  address1_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  address1_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  address1_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  address2?: InputMaybe<Scalars["String"]["input"]>;
  address2_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  address2_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  address2_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  address2_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  address3?: InputMaybe<Scalars["String"]["input"]>;
  address3_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  address3_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  address3_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  address3_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  city_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  city_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  city_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  city_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Use `collaboratesWith_SOME` instead. */
  collaboratesWith?: InputMaybe<OrganizationWhere>;
  collaboratesWithAggregate?: InputMaybe<OrganizationCollaboratesWithAggregateInput>;
  /** @deprecated Use `collaboratesWithConnection_SOME` instead. */
  collaboratesWithConnection?: InputMaybe<OrganizationCollaboratesWithConnectionWhere>;
  /** Return Organizations where all of the related OrganizationCollaboratesWithConnections match this filter */
  collaboratesWithConnection_ALL?: InputMaybe<OrganizationCollaboratesWithConnectionWhere>;
  /** Return Organizations where none of the related OrganizationCollaboratesWithConnections match this filter */
  collaboratesWithConnection_NONE?: InputMaybe<OrganizationCollaboratesWithConnectionWhere>;
  /** @deprecated Use `collaboratesWithConnection_NONE` instead. */
  collaboratesWithConnection_NOT?: InputMaybe<OrganizationCollaboratesWithConnectionWhere>;
  /** Return Organizations where one of the related OrganizationCollaboratesWithConnections match this filter */
  collaboratesWithConnection_SINGLE?: InputMaybe<OrganizationCollaboratesWithConnectionWhere>;
  /** Return Organizations where some of the related OrganizationCollaboratesWithConnections match this filter */
  collaboratesWithConnection_SOME?: InputMaybe<OrganizationCollaboratesWithConnectionWhere>;
  /** Return Organizations where all of the related Organizations match this filter */
  collaboratesWith_ALL?: InputMaybe<OrganizationWhere>;
  /** Return Organizations where none of the related Organizations match this filter */
  collaboratesWith_NONE?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `collaboratesWith_NONE` instead. */
  collaboratesWith_NOT?: InputMaybe<OrganizationWhere>;
  /** Return Organizations where one of the related Organizations match this filter */
  collaboratesWith_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return Organizations where some of the related Organizations match this filter */
  collaboratesWith_SOME?: InputMaybe<OrganizationWhere>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  country_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  country_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  country_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  country_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Use `federatedClient_SOME` instead. */
  federatedClient?: InputMaybe<FederatedClientWhere>;
  federatedClientAggregate?: InputMaybe<OrganizationFederatedClientAggregateInput>;
  /** @deprecated Use `federatedClientConnection_SOME` instead. */
  federatedClientConnection?: InputMaybe<OrganizationFederatedClientConnectionWhere>;
  /** Return Organizations where all of the related OrganizationFederatedClientConnections match this filter */
  federatedClientConnection_ALL?: InputMaybe<OrganizationFederatedClientConnectionWhere>;
  /** Return Organizations where none of the related OrganizationFederatedClientConnections match this filter */
  federatedClientConnection_NONE?: InputMaybe<OrganizationFederatedClientConnectionWhere>;
  /** @deprecated Use `federatedClientConnection_NONE` instead. */
  federatedClientConnection_NOT?: InputMaybe<OrganizationFederatedClientConnectionWhere>;
  /** Return Organizations where one of the related OrganizationFederatedClientConnections match this filter */
  federatedClientConnection_SINGLE?: InputMaybe<OrganizationFederatedClientConnectionWhere>;
  /** Return Organizations where some of the related OrganizationFederatedClientConnections match this filter */
  federatedClientConnection_SOME?: InputMaybe<OrganizationFederatedClientConnectionWhere>;
  /** Return Organizations where all of the related FederatedClients match this filter */
  federatedClient_ALL?: InputMaybe<FederatedClientWhere>;
  /** Return Organizations where none of the related FederatedClients match this filter */
  federatedClient_NONE?: InputMaybe<FederatedClientWhere>;
  /** @deprecated Use `federatedClient_NONE` instead. */
  federatedClient_NOT?: InputMaybe<FederatedClientWhere>;
  /** Return Organizations where one of the related FederatedClients match this filter */
  federatedClient_SINGLE?: InputMaybe<FederatedClientWhere>;
  /** Return Organizations where some of the related FederatedClients match this filter */
  federatedClient_SOME?: InputMaybe<FederatedClientWhere>;
  /** @deprecated Use `groups_SOME` instead. */
  groups?: InputMaybe<GroupWhere>;
  groupsAggregate?: InputMaybe<OrganizationGroupsAggregateInput>;
  /** @deprecated Use `groupsConnection_SOME` instead. */
  groupsConnection?: InputMaybe<OrganizationGroupsConnectionWhere>;
  /** Return Organizations where all of the related OrganizationGroupsConnections match this filter */
  groupsConnection_ALL?: InputMaybe<OrganizationGroupsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationGroupsConnections match this filter */
  groupsConnection_NONE?: InputMaybe<OrganizationGroupsConnectionWhere>;
  /** @deprecated Use `groupsConnection_NONE` instead. */
  groupsConnection_NOT?: InputMaybe<OrganizationGroupsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationGroupsConnections match this filter */
  groupsConnection_SINGLE?: InputMaybe<OrganizationGroupsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationGroupsConnections match this filter */
  groupsConnection_SOME?: InputMaybe<OrganizationGroupsConnectionWhere>;
  /** Return Organizations where all of the related Groups match this filter */
  groups_ALL?: InputMaybe<GroupWhere>;
  /** Return Organizations where none of the related Groups match this filter */
  groups_NONE?: InputMaybe<GroupWhere>;
  /** @deprecated Use `groups_NONE` instead. */
  groups_NOT?: InputMaybe<GroupWhere>;
  /** Return Organizations where one of the related Groups match this filter */
  groups_SINGLE?: InputMaybe<GroupWhere>;
  /** Return Organizations where some of the related Groups match this filter */
  groups_SOME?: InputMaybe<GroupWhere>;
  imprintHtml?: InputMaybe<Scalars["String"]["input"]>;
  imprintHtml_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  imprintHtml_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  imprintHtml_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  imprintHtml_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  imprintHtml_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  imprintHtml_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  imprintHtml_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  imprintHtml_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  imprintHtml_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Use `incomingRoles_SOME` instead. */
  incomingRoles?: InputMaybe<RoleTargetWhere>;
  /** @deprecated Use `incomingRolesConnection_SOME` instead. */
  incomingRolesConnection?: InputMaybe<OrganizationIncomingRolesConnectionWhere>;
  /** Return Organizations where all of the related OrganizationIncomingRolesConnections match this filter */
  incomingRolesConnection_ALL?: InputMaybe<OrganizationIncomingRolesConnectionWhere>;
  /** Return Organizations where none of the related OrganizationIncomingRolesConnections match this filter */
  incomingRolesConnection_NONE?: InputMaybe<OrganizationIncomingRolesConnectionWhere>;
  /** @deprecated Use `incomingRolesConnection_NONE` instead. */
  incomingRolesConnection_NOT?: InputMaybe<OrganizationIncomingRolesConnectionWhere>;
  /** Return Organizations where one of the related OrganizationIncomingRolesConnections match this filter */
  incomingRolesConnection_SINGLE?: InputMaybe<OrganizationIncomingRolesConnectionWhere>;
  /** Return Organizations where some of the related OrganizationIncomingRolesConnections match this filter */
  incomingRolesConnection_SOME?: InputMaybe<OrganizationIncomingRolesConnectionWhere>;
  /** Return Organizations where all of the related RoleTargets match this filter */
  incomingRoles_ALL?: InputMaybe<RoleTargetWhere>;
  /** Return Organizations where none of the related RoleTargets match this filter */
  incomingRoles_NONE?: InputMaybe<RoleTargetWhere>;
  /** @deprecated Use `incomingRoles_NONE` instead. */
  incomingRoles_NOT?: InputMaybe<RoleTargetWhere>;
  /** Return Organizations where one of the related RoleTargets match this filter */
  incomingRoles_SINGLE?: InputMaybe<RoleTargetWhere>;
  /** Return Organizations where some of the related RoleTargets match this filter */
  incomingRoles_SOME?: InputMaybe<RoleTargetWhere>;
  /** @deprecated Use `licensedApplications_SOME` instead. */
  licensedApplications?: InputMaybe<ApplicationWhere>;
  licensedApplicationsAggregate?: InputMaybe<OrganizationLicensedApplicationsAggregateInput>;
  /** @deprecated Use `licensedApplicationsConnection_SOME` instead. */
  licensedApplicationsConnection?: InputMaybe<OrganizationLicensedApplicationsConnectionWhere>;
  /** Return Organizations where all of the related OrganizationLicensedApplicationsConnections match this filter */
  licensedApplicationsConnection_ALL?: InputMaybe<OrganizationLicensedApplicationsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationLicensedApplicationsConnections match this filter */
  licensedApplicationsConnection_NONE?: InputMaybe<OrganizationLicensedApplicationsConnectionWhere>;
  /** @deprecated Use `licensedApplicationsConnection_NONE` instead. */
  licensedApplicationsConnection_NOT?: InputMaybe<OrganizationLicensedApplicationsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationLicensedApplicationsConnections match this filter */
  licensedApplicationsConnection_SINGLE?: InputMaybe<OrganizationLicensedApplicationsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationLicensedApplicationsConnections match this filter */
  licensedApplicationsConnection_SOME?: InputMaybe<OrganizationLicensedApplicationsConnectionWhere>;
  /** Return Organizations where all of the related Applications match this filter */
  licensedApplications_ALL?: InputMaybe<ApplicationWhere>;
  /** Return Organizations where none of the related Applications match this filter */
  licensedApplications_NONE?: InputMaybe<ApplicationWhere>;
  /** @deprecated Use `licensedApplications_NONE` instead. */
  licensedApplications_NOT?: InputMaybe<ApplicationWhere>;
  /** Return Organizations where one of the related Applications match this filter */
  licensedApplications_SINGLE?: InputMaybe<ApplicationWhere>;
  /** Return Organizations where some of the related Applications match this filter */
  licensedApplications_SOME?: InputMaybe<ApplicationWhere>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  locale_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  locale_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  locale_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  locale_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  name_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  name_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  privacyHtml?: InputMaybe<Scalars["String"]["input"]>;
  privacyHtml_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  privacyHtml_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  privacyHtml_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacyHtml_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacyHtml_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacyHtml_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacyHtml_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacyHtml_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  privacyHtml_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Use `profiles_SOME` instead. */
  profiles?: InputMaybe<ProfileWhere>;
  profilesAggregate?: InputMaybe<OrganizationProfilesAggregateInput>;
  /** @deprecated Use `profilesConnection_SOME` instead. */
  profilesConnection?: InputMaybe<OrganizationProfilesConnectionWhere>;
  /** Return Organizations where all of the related OrganizationProfilesConnections match this filter */
  profilesConnection_ALL?: InputMaybe<OrganizationProfilesConnectionWhere>;
  /** Return Organizations where none of the related OrganizationProfilesConnections match this filter */
  profilesConnection_NONE?: InputMaybe<OrganizationProfilesConnectionWhere>;
  /** @deprecated Use `profilesConnection_NONE` instead. */
  profilesConnection_NOT?: InputMaybe<OrganizationProfilesConnectionWhere>;
  /** Return Organizations where one of the related OrganizationProfilesConnections match this filter */
  profilesConnection_SINGLE?: InputMaybe<OrganizationProfilesConnectionWhere>;
  /** Return Organizations where some of the related OrganizationProfilesConnections match this filter */
  profilesConnection_SOME?: InputMaybe<OrganizationProfilesConnectionWhere>;
  /** Return Organizations where all of the related Profiles match this filter */
  profiles_ALL?: InputMaybe<ProfileWhere>;
  /** Return Organizations where none of the related Profiles match this filter */
  profiles_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `profiles_NONE` instead. */
  profiles_NOT?: InputMaybe<ProfileWhere>;
  /** Return Organizations where one of the related Profiles match this filter */
  profiles_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return Organizations where some of the related Profiles match this filter */
  profiles_SOME?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `properties_SOME` instead. */
  properties?: InputMaybe<PropertyWhere>;
  propertiesAggregate?: InputMaybe<OrganizationPropertiesAggregateInput>;
  /** @deprecated Use `propertiesConnection_SOME` instead. */
  propertiesConnection?: InputMaybe<OrganizationPropertiesConnectionWhere>;
  /** Return Organizations where all of the related OrganizationPropertiesConnections match this filter */
  propertiesConnection_ALL?: InputMaybe<OrganizationPropertiesConnectionWhere>;
  /** Return Organizations where none of the related OrganizationPropertiesConnections match this filter */
  propertiesConnection_NONE?: InputMaybe<OrganizationPropertiesConnectionWhere>;
  /** @deprecated Use `propertiesConnection_NONE` instead. */
  propertiesConnection_NOT?: InputMaybe<OrganizationPropertiesConnectionWhere>;
  /** Return Organizations where one of the related OrganizationPropertiesConnections match this filter */
  propertiesConnection_SINGLE?: InputMaybe<OrganizationPropertiesConnectionWhere>;
  /** Return Organizations where some of the related OrganizationPropertiesConnections match this filter */
  propertiesConnection_SOME?: InputMaybe<OrganizationPropertiesConnectionWhere>;
  /** Return Organizations where all of the related Properties match this filter */
  properties_ALL?: InputMaybe<PropertyWhere>;
  /** Return Organizations where none of the related Properties match this filter */
  properties_NONE?: InputMaybe<PropertyWhere>;
  /** @deprecated Use `properties_NONE` instead. */
  properties_NOT?: InputMaybe<PropertyWhere>;
  /** Return Organizations where one of the related Properties match this filter */
  properties_SINGLE?: InputMaybe<PropertyWhere>;
  /** Return Organizations where some of the related Properties match this filter */
  properties_SOME?: InputMaybe<PropertyWhere>;
  region?: InputMaybe<Scalars["String"]["input"]>;
  region_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  region_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  region_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  region_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  region_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  region_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  region_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  region_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  region_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Use `shadowProfileGroups_SOME` instead. */
  shadowProfileGroups?: InputMaybe<GroupWhere>;
  shadowProfileGroupsAggregate?: InputMaybe<OrganizationShadowProfileGroupsAggregateInput>;
  /** @deprecated Use `shadowProfileGroupsConnection_SOME` instead. */
  shadowProfileGroupsConnection?: InputMaybe<OrganizationShadowProfileGroupsConnectionWhere>;
  /** Return Organizations where all of the related OrganizationShadowProfileGroupsConnections match this filter */
  shadowProfileGroupsConnection_ALL?: InputMaybe<OrganizationShadowProfileGroupsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationShadowProfileGroupsConnections match this filter */
  shadowProfileGroupsConnection_NONE?: InputMaybe<OrganizationShadowProfileGroupsConnectionWhere>;
  /** @deprecated Use `shadowProfileGroupsConnection_NONE` instead. */
  shadowProfileGroupsConnection_NOT?: InputMaybe<OrganizationShadowProfileGroupsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationShadowProfileGroupsConnections match this filter */
  shadowProfileGroupsConnection_SINGLE?: InputMaybe<OrganizationShadowProfileGroupsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationShadowProfileGroupsConnections match this filter */
  shadowProfileGroupsConnection_SOME?: InputMaybe<OrganizationShadowProfileGroupsConnectionWhere>;
  /** Return Organizations where all of the related Groups match this filter */
  shadowProfileGroups_ALL?: InputMaybe<GroupWhere>;
  /** Return Organizations where none of the related Groups match this filter */
  shadowProfileGroups_NONE?: InputMaybe<GroupWhere>;
  /** @deprecated Use `shadowProfileGroups_NONE` instead. */
  shadowProfileGroups_NOT?: InputMaybe<GroupWhere>;
  /** Return Organizations where one of the related Groups match this filter */
  shadowProfileGroups_SINGLE?: InputMaybe<GroupWhere>;
  /** Return Organizations where some of the related Groups match this filter */
  shadowProfileGroups_SOME?: InputMaybe<GroupWhere>;
  /** @deprecated Use `shadowsProfilesTo_SOME` instead. */
  shadowsProfilesTo?: InputMaybe<OrganizationWhere>;
  shadowsProfilesToAggregate?: InputMaybe<OrganizationShadowsProfilesToAggregateInput>;
  /** @deprecated Use `shadowsProfilesToConnection_SOME` instead. */
  shadowsProfilesToConnection?: InputMaybe<OrganizationShadowsProfilesToConnectionWhere>;
  /** Return Organizations where all of the related OrganizationShadowsProfilesToConnections match this filter */
  shadowsProfilesToConnection_ALL?: InputMaybe<OrganizationShadowsProfilesToConnectionWhere>;
  /** Return Organizations where none of the related OrganizationShadowsProfilesToConnections match this filter */
  shadowsProfilesToConnection_NONE?: InputMaybe<OrganizationShadowsProfilesToConnectionWhere>;
  /** @deprecated Use `shadowsProfilesToConnection_NONE` instead. */
  shadowsProfilesToConnection_NOT?: InputMaybe<OrganizationShadowsProfilesToConnectionWhere>;
  /** Return Organizations where one of the related OrganizationShadowsProfilesToConnections match this filter */
  shadowsProfilesToConnection_SINGLE?: InputMaybe<OrganizationShadowsProfilesToConnectionWhere>;
  /** Return Organizations where some of the related OrganizationShadowsProfilesToConnections match this filter */
  shadowsProfilesToConnection_SOME?: InputMaybe<OrganizationShadowsProfilesToConnectionWhere>;
  /** Return Organizations where all of the related Organizations match this filter */
  shadowsProfilesTo_ALL?: InputMaybe<OrganizationWhere>;
  /** Return Organizations where none of the related Organizations match this filter */
  shadowsProfilesTo_NONE?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `shadowsProfilesTo_NONE` instead. */
  shadowsProfilesTo_NOT?: InputMaybe<OrganizationWhere>;
  /** Return Organizations where one of the related Organizations match this filter */
  shadowsProfilesTo_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return Organizations where some of the related Organizations match this filter */
  shadowsProfilesTo_SOME?: InputMaybe<OrganizationWhere>;
  studentCount?: InputMaybe<Scalars["Int"]["input"]>;
  studentCount_GT?: InputMaybe<Scalars["Int"]["input"]>;
  studentCount_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  studentCount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  studentCount_LT?: InputMaybe<Scalars["Int"]["input"]>;
  studentCount_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  studentCount_NOT?: InputMaybe<Scalars["Int"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  studentCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  tecartContactId?: InputMaybe<Scalars["String"]["input"]>;
  tecartContactId_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  tecartContactId_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tecartContactId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContactId_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContactId_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContactId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContactId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContactId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tecartContactId_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  timezone_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  timezone_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  timezone_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  timezone_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tosHtml?: InputMaybe<Scalars["String"]["input"]>;
  tosHtml_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  tosHtml_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tosHtml_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosHtml_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosHtml_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosHtml_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosHtml_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosHtml_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tosHtml_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tosVersion?: InputMaybe<Scalars["String"]["input"]>;
  tosVersion_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  tosVersion_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tosVersion_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tosVersion_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  uuid?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  zipCode?: InputMaybe<Scalars["String"]["input"]>;
  zipCode_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  zipCode_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  zipCode_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  zipCode_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationWithCollaboratingOrganizations = {
  __typename?: "OrganizationWithCollaboratingOrganizations";
  collaboratesWith: Array<MinimalOrganization>;
  name?: Maybe<Scalars["String"]["output"]>;
  uuid: Scalars["ID"]["output"];
};

export type OrganizationsConnection = {
  __typename?: "OrganizationsConnection";
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** Pagination information (Relay) */
export type PageInfo = {
  __typename?: "PageInfo";
  endCursor?: Maybe<Scalars["String"]["output"]>;
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PasswordUpdateInput = {
  newPassword: Scalars["String"]["input"];
  oldPassword?: InputMaybe<Scalars["String"]["input"]>;
};

export type PasswordWhere = {
  uuid: Scalars["ID"]["input"];
};

export type Profile = {
  __typename?: "Profile";
  birthday?: Maybe<Scalars["Date"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  displayNameShort?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName: Scalars["String"]["output"];
  firstNames?: Maybe<Scalars["String"]["output"]>;
  fullName: Scalars["String"]["output"];
  /**
   * Applications this profile can actually sign in to — the same rule
   * pim-auth-server applies at login: the organization holds a currently valid
   * licence, and access is granted either to the organization or to the profile.
   * (The previous UNION statement left `this` unbound in its second branch and
   * returned every organization-wide grant in the graph.)
   */
  grantedApplications: Array<Application>;
  groups: Array<Group>;
  groupsConnection: ProfileGroupsConnection;
  incomingRoles: Array<RoleTarget>;
  incomingRolesConnection: ProfileIncomingRolesConnection;
  lastName: Scalars["String"]["output"];
  listName?: Maybe<Scalars["String"]["output"]>;
  organization: Organization;
  organizationConnection: ProfileOrganizationConnection;
  prefixName?: Maybe<Scalars["String"]["output"]>;
  properties: Array<Property>;
  propertiesConnection: ProfilePropertiesConnection;
  roles: Array<RoleTarget>;
  rolesConnection: ProfileRolesConnection;
  salutation?: Maybe<Scalars["String"]["output"]>;
  selectName?: Maybe<Scalars["String"]["output"]>;
  shortName?: Maybe<Scalars["String"]["output"]>;
  tecartPersonId?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  tosAccepted?: Maybe<Scalars["DateTime"]["output"]>;
  tosVersion?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<User>;
  userConnection: ProfileUserConnection;
  uuid: Scalars["ID"]["output"];
};

export type ProfileGroupsArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type ProfileGroupsConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<ProfileGroupsConnectionSort>>;
  where?: InputMaybe<ProfileGroupsConnectionWhere>;
};

export type ProfileIncomingRolesArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<RoleTargetWhere>;
};

export type ProfileIncomingRolesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<ProfileIncomingRolesConnectionSort>>;
  where?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
};

export type ProfileOrganizationArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ProfileOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<ProfileOrganizationConnectionSort>>;
  where?: InputMaybe<ProfileOrganizationConnectionWhere>;
};

export type ProfilePropertiesArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<PropertyOptions>;
  where?: InputMaybe<PropertyWhere>;
};

export type ProfilePropertiesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<ProfilePropertiesConnectionSort>>;
  where?: InputMaybe<ProfilePropertiesConnectionWhere>;
};

export type ProfileRolesArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<RoleTargetWhere>;
};

export type ProfileRolesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<ProfileRolesConnectionSort>>;
  where?: InputMaybe<ProfileRolesConnectionWhere>;
};

export type ProfileUserArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};

export type ProfileUserConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<ProfileUserConnectionSort>>;
  where?: InputMaybe<ProfileUserConnectionWhere>;
};

export type ProfileAggregateSelection = {
  __typename?: "ProfileAggregateSelection";
  count: Scalars["Int"]["output"];
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  tecartPersonId: StringAggregateSelection;
  title: StringAggregateSelection;
  tosAccepted: DateTimeAggregateSelection;
  tosVersion: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ProfileConnectInput = {
  groups?: InputMaybe<Array<ProfileGroupsConnectFieldInput>>;
  incomingRoles?: InputMaybe<ProfileIncomingRolesConnectInput>;
  organization?: InputMaybe<ProfileOrganizationConnectFieldInput>;
  properties?: InputMaybe<Array<ProfilePropertiesConnectFieldInput>>;
  roles?: InputMaybe<ProfileRolesConnectInput>;
  user?: InputMaybe<ProfileUserConnectFieldInput>;
};

export type ProfileConnectWhere = {
  node: ProfileWhere;
};

export type ProfileCreateInput = {
  birthday?: InputMaybe<Scalars["Date"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  firstNames?: InputMaybe<Scalars["String"]["input"]>;
  groups?: InputMaybe<ProfileGroupsFieldInput>;
  incomingRoles?: InputMaybe<ProfileIncomingRolesCreateInput>;
  lastName: Scalars["String"]["input"];
  organization?: InputMaybe<ProfileOrganizationFieldInput>;
  prefixName?: InputMaybe<Scalars["String"]["input"]>;
  properties?: InputMaybe<ProfilePropertiesFieldInput>;
  roles?: InputMaybe<ProfileRolesCreateInput>;
  salutation?: InputMaybe<Scalars["String"]["input"]>;
  shortName?: InputMaybe<Scalars["String"]["input"]>;
  tecartPersonId?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  tosAccepted?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosVersion?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<ProfileUserFieldInput>;
};

export type ProfileDeleteInput = {
  groups?: InputMaybe<Array<ProfileGroupsDeleteFieldInput>>;
  incomingRoles?: InputMaybe<ProfileIncomingRolesDeleteInput>;
  organization?: InputMaybe<ProfileOrganizationDeleteFieldInput>;
  properties?: InputMaybe<Array<ProfilePropertiesDeleteFieldInput>>;
  roles?: InputMaybe<ProfileRolesDeleteInput>;
  user?: InputMaybe<ProfileUserDeleteFieldInput>;
};

export type ProfileDisconnectInput = {
  groups?: InputMaybe<Array<ProfileGroupsDisconnectFieldInput>>;
  incomingRoles?: InputMaybe<ProfileIncomingRolesDisconnectInput>;
  organization?: InputMaybe<ProfileOrganizationDisconnectFieldInput>;
  properties?: InputMaybe<Array<ProfilePropertiesDisconnectFieldInput>>;
  roles?: InputMaybe<ProfileRolesDisconnectInput>;
  user?: InputMaybe<ProfileUserDisconnectFieldInput>;
};

export type ProfileEdge = {
  __typename?: "ProfileEdge";
  cursor: Scalars["String"]["output"];
  node: Profile;
};

export type ProfileGroupsAggregateInput = {
  AND?: InputMaybe<Array<ProfileGroupsAggregateInput>>;
  NOT?: InputMaybe<ProfileGroupsAggregateInput>;
  OR?: InputMaybe<Array<ProfileGroupsAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<ProfileGroupsNodeAggregationWhereInput>;
};

export type ProfileGroupsConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<GroupConnectWhere>;
};

export type ProfileGroupsConnection = {
  __typename?: "ProfileGroupsConnection";
  edges: Array<ProfileGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ProfileGroupsConnectionSort = {
  node?: InputMaybe<GroupSort>;
};

export type ProfileGroupsConnectionWhere = {
  AND?: InputMaybe<Array<ProfileGroupsConnectionWhere>>;
  NOT?: InputMaybe<ProfileGroupsConnectionWhere>;
  OR?: InputMaybe<Array<ProfileGroupsConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type ProfileGroupsCreateFieldInput = {
  node: GroupCreateInput;
};

export type ProfileGroupsDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<ProfileGroupsConnectionWhere>;
};

export type ProfileGroupsDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<ProfileGroupsConnectionWhere>;
};

export type ProfileGroupsFieldInput = {
  connect?: InputMaybe<Array<ProfileGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileGroupsCreateFieldInput>>;
};

export type ProfileGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileGroupsNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ProfileGroupsRelationship = {
  __typename?: "ProfileGroupsRelationship";
  cursor: Scalars["String"]["output"];
  node: Group;
};

export type ProfileGroupsUpdateConnectionInput = {
  node?: InputMaybe<GroupUpdateInput>;
};

export type ProfileGroupsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileGroupsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileGroupsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileGroupsDisconnectFieldInput>>;
  update?: InputMaybe<ProfileGroupsUpdateConnectionInput>;
  where?: InputMaybe<ProfileGroupsConnectionWhere>;
};

export type ProfileIncomingRolesConnectInput = {
  Group?: InputMaybe<Array<ProfileIncomingRolesGroupConnectFieldInput>>;
  Organization?: InputMaybe<Array<ProfileIncomingRolesOrganizationConnectFieldInput>>;
  Profile?: InputMaybe<Array<ProfileIncomingRolesProfileConnectFieldInput>>;
  User?: InputMaybe<Array<ProfileIncomingRolesUserConnectFieldInput>>;
};

export type ProfileIncomingRolesConnection = {
  __typename?: "ProfileIncomingRolesConnection";
  edges: Array<ProfileIncomingRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ProfileIncomingRolesConnectionSort = {
  edge?: InputMaybe<RoleNamesSort>;
};

export type ProfileIncomingRolesConnectionWhere = {
  Group?: InputMaybe<ProfileIncomingRolesGroupConnectionWhere>;
  Organization?: InputMaybe<ProfileIncomingRolesOrganizationConnectionWhere>;
  Profile?: InputMaybe<ProfileIncomingRolesProfileConnectionWhere>;
  User?: InputMaybe<ProfileIncomingRolesUserConnectionWhere>;
};

export type ProfileIncomingRolesCreateInput = {
  Group?: InputMaybe<ProfileIncomingRolesGroupFieldInput>;
  Organization?: InputMaybe<ProfileIncomingRolesOrganizationFieldInput>;
  Profile?: InputMaybe<ProfileIncomingRolesProfileFieldInput>;
  User?: InputMaybe<ProfileIncomingRolesUserFieldInput>;
};

export type ProfileIncomingRolesDeleteInput = {
  Group?: InputMaybe<Array<ProfileIncomingRolesGroupDeleteFieldInput>>;
  Organization?: InputMaybe<Array<ProfileIncomingRolesOrganizationDeleteFieldInput>>;
  Profile?: InputMaybe<Array<ProfileIncomingRolesProfileDeleteFieldInput>>;
  User?: InputMaybe<Array<ProfileIncomingRolesUserDeleteFieldInput>>;
};

export type ProfileIncomingRolesDisconnectInput = {
  Group?: InputMaybe<Array<ProfileIncomingRolesGroupDisconnectFieldInput>>;
  Organization?: InputMaybe<Array<ProfileIncomingRolesOrganizationDisconnectFieldInput>>;
  Profile?: InputMaybe<Array<ProfileIncomingRolesProfileDisconnectFieldInput>>;
  User?: InputMaybe<Array<ProfileIncomingRolesUserDisconnectFieldInput>>;
};

export type ProfileIncomingRolesGroupConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<GroupConnectWhere>;
};

export type ProfileIncomingRolesGroupConnectionWhere = {
  AND?: InputMaybe<Array<ProfileIncomingRolesGroupConnectionWhere>>;
  NOT?: InputMaybe<ProfileIncomingRolesGroupConnectionWhere>;
  OR?: InputMaybe<Array<ProfileIncomingRolesGroupConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type ProfileIncomingRolesGroupCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: GroupCreateInput;
};

export type ProfileIncomingRolesGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<ProfileIncomingRolesGroupConnectionWhere>;
};

export type ProfileIncomingRolesGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<ProfileIncomingRolesGroupConnectionWhere>;
};

export type ProfileIncomingRolesGroupFieldInput = {
  connect?: InputMaybe<Array<ProfileIncomingRolesGroupConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileIncomingRolesGroupCreateFieldInput>>;
};

export type ProfileIncomingRolesGroupUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<GroupUpdateInput>;
};

export type ProfileIncomingRolesGroupUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileIncomingRolesGroupConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileIncomingRolesGroupCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileIncomingRolesGroupDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileIncomingRolesGroupDisconnectFieldInput>>;
  update?: InputMaybe<ProfileIncomingRolesGroupUpdateConnectionInput>;
  where?: InputMaybe<ProfileIncomingRolesGroupConnectionWhere>;
};

export type ProfileIncomingRolesOrganizationConnectFieldInput = {
  connect?: InputMaybe<Array<OrganizationConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ProfileIncomingRolesOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ProfileIncomingRolesOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ProfileIncomingRolesOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ProfileIncomingRolesOrganizationConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ProfileIncomingRolesOrganizationCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: OrganizationCreateInput;
};

export type ProfileIncomingRolesOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ProfileIncomingRolesOrganizationConnectionWhere>;
};

export type ProfileIncomingRolesOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ProfileIncomingRolesOrganizationConnectionWhere>;
};

export type ProfileIncomingRolesOrganizationFieldInput = {
  connect?: InputMaybe<Array<ProfileIncomingRolesOrganizationConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileIncomingRolesOrganizationCreateFieldInput>>;
};

export type ProfileIncomingRolesOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ProfileIncomingRolesOrganizationUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileIncomingRolesOrganizationConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileIncomingRolesOrganizationCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileIncomingRolesOrganizationDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileIncomingRolesOrganizationDisconnectFieldInput>>;
  update?: InputMaybe<ProfileIncomingRolesOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ProfileIncomingRolesOrganizationConnectionWhere>;
};

export type ProfileIncomingRolesProfileConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<ProfileConnectWhere>;
};

export type ProfileIncomingRolesProfileConnectionWhere = {
  AND?: InputMaybe<Array<ProfileIncomingRolesProfileConnectionWhere>>;
  NOT?: InputMaybe<ProfileIncomingRolesProfileConnectionWhere>;
  OR?: InputMaybe<Array<ProfileIncomingRolesProfileConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type ProfileIncomingRolesProfileCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: ProfileCreateInput;
};

export type ProfileIncomingRolesProfileDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ProfileIncomingRolesProfileConnectionWhere>;
};

export type ProfileIncomingRolesProfileDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<ProfileIncomingRolesProfileConnectionWhere>;
};

export type ProfileIncomingRolesProfileFieldInput = {
  connect?: InputMaybe<Array<ProfileIncomingRolesProfileConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileIncomingRolesProfileCreateFieldInput>>;
};

export type ProfileIncomingRolesProfileUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type ProfileIncomingRolesProfileUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileIncomingRolesProfileConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileIncomingRolesProfileCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileIncomingRolesProfileDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileIncomingRolesProfileDisconnectFieldInput>>;
  update?: InputMaybe<ProfileIncomingRolesProfileUpdateConnectionInput>;
  where?: InputMaybe<ProfileIncomingRolesProfileConnectionWhere>;
};

export type ProfileIncomingRolesRelationship = {
  __typename?: "ProfileIncomingRolesRelationship";
  cursor: Scalars["String"]["output"];
  node: RoleTarget;
  properties: RoleNames;
};

export type ProfileIncomingRolesUpdateInput = {
  Group?: InputMaybe<Array<ProfileIncomingRolesGroupUpdateFieldInput>>;
  Organization?: InputMaybe<Array<ProfileIncomingRolesOrganizationUpdateFieldInput>>;
  Profile?: InputMaybe<Array<ProfileIncomingRolesProfileUpdateFieldInput>>;
  User?: InputMaybe<Array<ProfileIncomingRolesUserUpdateFieldInput>>;
};

export type ProfileIncomingRolesUserConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<UserConnectWhere>;
};

export type ProfileIncomingRolesUserConnectionWhere = {
  AND?: InputMaybe<Array<ProfileIncomingRolesUserConnectionWhere>>;
  NOT?: InputMaybe<ProfileIncomingRolesUserConnectionWhere>;
  OR?: InputMaybe<Array<ProfileIncomingRolesUserConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<UserWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<UserWhere>;
};

export type ProfileIncomingRolesUserCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: UserCreateInput;
};

export type ProfileIncomingRolesUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ProfileIncomingRolesUserConnectionWhere>;
};

export type ProfileIncomingRolesUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ProfileIncomingRolesUserConnectionWhere>;
};

export type ProfileIncomingRolesUserFieldInput = {
  connect?: InputMaybe<Array<ProfileIncomingRolesUserConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileIncomingRolesUserCreateFieldInput>>;
};

export type ProfileIncomingRolesUserUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type ProfileIncomingRolesUserUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileIncomingRolesUserConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileIncomingRolesUserCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileIncomingRolesUserDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileIncomingRolesUserDisconnectFieldInput>>;
  update?: InputMaybe<ProfileIncomingRolesUserUpdateConnectionInput>;
  where?: InputMaybe<ProfileIncomingRolesUserConnectionWhere>;
};

export type ProfileOptions = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Specify one or more ProfileSort objects to sort Profiles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ProfileSort>>;
};

export type ProfileOrganizationAggregateInput = {
  AND?: InputMaybe<Array<ProfileOrganizationAggregateInput>>;
  NOT?: InputMaybe<ProfileOrganizationAggregateInput>;
  OR?: InputMaybe<Array<ProfileOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<ProfileOrganizationNodeAggregationWhereInput>;
};

export type ProfileOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ProfileOrganizationConnection = {
  __typename?: "ProfileOrganizationConnection";
  edges: Array<ProfileOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ProfileOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type ProfileOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ProfileOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ProfileOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ProfileOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ProfileOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type ProfileOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ProfileOrganizationConnectionWhere>;
};

export type ProfileOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ProfileOrganizationConnectionWhere>;
};

export type ProfileOrganizationFieldInput = {
  connect?: InputMaybe<ProfileOrganizationConnectFieldInput>;
  create?: InputMaybe<ProfileOrganizationCreateFieldInput>;
};

export type ProfileOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileOrganizationNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ProfileOrganizationRelationship = {
  __typename?: "ProfileOrganizationRelationship";
  cursor: Scalars["String"]["output"];
  node: Organization;
};

export type ProfileOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ProfileOrganizationUpdateFieldInput = {
  connect?: InputMaybe<ProfileOrganizationConnectFieldInput>;
  create?: InputMaybe<ProfileOrganizationCreateFieldInput>;
  delete?: InputMaybe<ProfileOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<ProfileOrganizationDisconnectFieldInput>;
  update?: InputMaybe<ProfileOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ProfileOrganizationConnectionWhere>;
};

export type ProfilePropertiesAggregateInput = {
  AND?: InputMaybe<Array<ProfilePropertiesAggregateInput>>;
  NOT?: InputMaybe<ProfilePropertiesAggregateInput>;
  OR?: InputMaybe<Array<ProfilePropertiesAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  edge?: InputMaybe<PropertiesScopeAggregationWhereInput>;
  node?: InputMaybe<ProfilePropertiesNodeAggregationWhereInput>;
};

export type ProfilePropertiesConnectFieldInput = {
  connect?: InputMaybe<Array<PropertyConnectInput>>;
  edge: PropertiesScopeCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<PropertyConnectWhere>;
};

export type ProfilePropertiesConnection = {
  __typename?: "ProfilePropertiesConnection";
  edges: Array<ProfilePropertiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ProfilePropertiesConnectionSort = {
  edge?: InputMaybe<PropertiesScopeSort>;
  node?: InputMaybe<PropertySort>;
};

export type ProfilePropertiesConnectionWhere = {
  AND?: InputMaybe<Array<ProfilePropertiesConnectionWhere>>;
  NOT?: InputMaybe<ProfilePropertiesConnectionWhere>;
  OR?: InputMaybe<Array<ProfilePropertiesConnectionWhere>>;
  edge?: InputMaybe<PropertiesScopeWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PropertiesScopeWhere>;
  node?: InputMaybe<PropertyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PropertyWhere>;
};

export type ProfilePropertiesCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: PropertyCreateInput;
};

export type ProfilePropertiesDeleteFieldInput = {
  delete?: InputMaybe<PropertyDeleteInput>;
  where?: InputMaybe<ProfilePropertiesConnectionWhere>;
};

export type ProfilePropertiesDisconnectFieldInput = {
  disconnect?: InputMaybe<PropertyDisconnectInput>;
  where?: InputMaybe<ProfilePropertiesConnectionWhere>;
};

export type ProfilePropertiesFieldInput = {
  connect?: InputMaybe<Array<ProfilePropertiesConnectFieldInput>>;
  create?: InputMaybe<Array<ProfilePropertiesCreateFieldInput>>;
};

export type ProfilePropertiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfilePropertiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfilePropertiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfilePropertiesNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  value_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ProfilePropertiesRelationship = {
  __typename?: "ProfilePropertiesRelationship";
  cursor: Scalars["String"]["output"];
  node: Property;
  properties: PropertiesScope;
};

export type ProfilePropertiesUpdateConnectionInput = {
  edge?: InputMaybe<PropertiesScopeUpdateInput>;
  node?: InputMaybe<PropertyUpdateInput>;
};

export type ProfilePropertiesUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfilePropertiesConnectFieldInput>>;
  create?: InputMaybe<Array<ProfilePropertiesCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfilePropertiesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfilePropertiesDisconnectFieldInput>>;
  update?: InputMaybe<ProfilePropertiesUpdateConnectionInput>;
  where?: InputMaybe<ProfilePropertiesConnectionWhere>;
};

/**
 * The edge properties for the following fields:
 * * User.profiles
 * * Profile.user
 */
export type ProfileRelationProperties = {
  __typename?: "ProfileRelationProperties";
  primary?: Maybe<Scalars["Boolean"]["output"]>;
  shadow?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ProfileRelationPropertiesCreateInput = {
  primary?: InputMaybe<Scalars["Boolean"]["input"]>;
  shadow?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfileRelationPropertiesSort = {
  primary?: InputMaybe<SortDirection>;
  shadow?: InputMaybe<SortDirection>;
};

export type ProfileRelationPropertiesUpdateInput = {
  primary?: InputMaybe<Scalars["Boolean"]["input"]>;
  shadow?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfileRelationPropertiesWhere = {
  AND?: InputMaybe<Array<ProfileRelationPropertiesWhere>>;
  NOT?: InputMaybe<ProfileRelationPropertiesWhere>;
  OR?: InputMaybe<Array<ProfileRelationPropertiesWhere>>;
  primary?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  primary_NOT?: InputMaybe<Scalars["Boolean"]["input"]>;
  shadow?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shadow_NOT?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfileRolesConnectInput = {
  Group?: InputMaybe<Array<ProfileRolesGroupConnectFieldInput>>;
  Organization?: InputMaybe<Array<ProfileRolesOrganizationConnectFieldInput>>;
  Profile?: InputMaybe<Array<ProfileRolesProfileConnectFieldInput>>;
  User?: InputMaybe<Array<ProfileRolesUserConnectFieldInput>>;
};

export type ProfileRolesConnection = {
  __typename?: "ProfileRolesConnection";
  edges: Array<ProfileRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ProfileRolesConnectionSort = {
  edge?: InputMaybe<RoleNamesSort>;
};

export type ProfileRolesConnectionWhere = {
  Group?: InputMaybe<ProfileRolesGroupConnectionWhere>;
  Organization?: InputMaybe<ProfileRolesOrganizationConnectionWhere>;
  Profile?: InputMaybe<ProfileRolesProfileConnectionWhere>;
  User?: InputMaybe<ProfileRolesUserConnectionWhere>;
};

export type ProfileRolesCreateInput = {
  Group?: InputMaybe<ProfileRolesGroupFieldInput>;
  Organization?: InputMaybe<ProfileRolesOrganizationFieldInput>;
  Profile?: InputMaybe<ProfileRolesProfileFieldInput>;
  User?: InputMaybe<ProfileRolesUserFieldInput>;
};

export type ProfileRolesDeleteInput = {
  Group?: InputMaybe<Array<ProfileRolesGroupDeleteFieldInput>>;
  Organization?: InputMaybe<Array<ProfileRolesOrganizationDeleteFieldInput>>;
  Profile?: InputMaybe<Array<ProfileRolesProfileDeleteFieldInput>>;
  User?: InputMaybe<Array<ProfileRolesUserDeleteFieldInput>>;
};

export type ProfileRolesDisconnectInput = {
  Group?: InputMaybe<Array<ProfileRolesGroupDisconnectFieldInput>>;
  Organization?: InputMaybe<Array<ProfileRolesOrganizationDisconnectFieldInput>>;
  Profile?: InputMaybe<Array<ProfileRolesProfileDisconnectFieldInput>>;
  User?: InputMaybe<Array<ProfileRolesUserDisconnectFieldInput>>;
};

export type ProfileRolesGroupConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<GroupConnectWhere>;
};

export type ProfileRolesGroupConnectionWhere = {
  AND?: InputMaybe<Array<ProfileRolesGroupConnectionWhere>>;
  NOT?: InputMaybe<ProfileRolesGroupConnectionWhere>;
  OR?: InputMaybe<Array<ProfileRolesGroupConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type ProfileRolesGroupCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: GroupCreateInput;
};

export type ProfileRolesGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<ProfileRolesGroupConnectionWhere>;
};

export type ProfileRolesGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<ProfileRolesGroupConnectionWhere>;
};

export type ProfileRolesGroupFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesGroupConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesGroupCreateFieldInput>>;
};

export type ProfileRolesGroupUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<GroupUpdateInput>;
};

export type ProfileRolesGroupUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesGroupConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesGroupCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileRolesGroupDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileRolesGroupDisconnectFieldInput>>;
  update?: InputMaybe<ProfileRolesGroupUpdateConnectionInput>;
  where?: InputMaybe<ProfileRolesGroupConnectionWhere>;
};

export type ProfileRolesOrganizationConnectFieldInput = {
  connect?: InputMaybe<Array<OrganizationConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ProfileRolesOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ProfileRolesOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ProfileRolesOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ProfileRolesOrganizationConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ProfileRolesOrganizationCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: OrganizationCreateInput;
};

export type ProfileRolesOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ProfileRolesOrganizationConnectionWhere>;
};

export type ProfileRolesOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ProfileRolesOrganizationConnectionWhere>;
};

export type ProfileRolesOrganizationFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesOrganizationConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesOrganizationCreateFieldInput>>;
};

export type ProfileRolesOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ProfileRolesOrganizationUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesOrganizationConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesOrganizationCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileRolesOrganizationDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileRolesOrganizationDisconnectFieldInput>>;
  update?: InputMaybe<ProfileRolesOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ProfileRolesOrganizationConnectionWhere>;
};

export type ProfileRolesProfileConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<ProfileConnectWhere>;
};

export type ProfileRolesProfileConnectionWhere = {
  AND?: InputMaybe<Array<ProfileRolesProfileConnectionWhere>>;
  NOT?: InputMaybe<ProfileRolesProfileConnectionWhere>;
  OR?: InputMaybe<Array<ProfileRolesProfileConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type ProfileRolesProfileCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: ProfileCreateInput;
};

export type ProfileRolesProfileDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ProfileRolesProfileConnectionWhere>;
};

export type ProfileRolesProfileDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<ProfileRolesProfileConnectionWhere>;
};

export type ProfileRolesProfileFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesProfileConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesProfileCreateFieldInput>>;
};

export type ProfileRolesProfileUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type ProfileRolesProfileUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesProfileConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesProfileCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileRolesProfileDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileRolesProfileDisconnectFieldInput>>;
  update?: InputMaybe<ProfileRolesProfileUpdateConnectionInput>;
  where?: InputMaybe<ProfileRolesProfileConnectionWhere>;
};

export type ProfileRolesRelationship = {
  __typename?: "ProfileRolesRelationship";
  cursor: Scalars["String"]["output"];
  node: RoleTarget;
  properties: RoleNames;
};

export type ProfileRolesUpdateInput = {
  Group?: InputMaybe<Array<ProfileRolesGroupUpdateFieldInput>>;
  Organization?: InputMaybe<Array<ProfileRolesOrganizationUpdateFieldInput>>;
  Profile?: InputMaybe<Array<ProfileRolesProfileUpdateFieldInput>>;
  User?: InputMaybe<Array<ProfileRolesUserUpdateFieldInput>>;
};

export type ProfileRolesUserConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<UserConnectWhere>;
};

export type ProfileRolesUserConnectionWhere = {
  AND?: InputMaybe<Array<ProfileRolesUserConnectionWhere>>;
  NOT?: InputMaybe<ProfileRolesUserConnectionWhere>;
  OR?: InputMaybe<Array<ProfileRolesUserConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<UserWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<UserWhere>;
};

export type ProfileRolesUserCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: UserCreateInput;
};

export type ProfileRolesUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ProfileRolesUserConnectionWhere>;
};

export type ProfileRolesUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ProfileRolesUserConnectionWhere>;
};

export type ProfileRolesUserFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesUserConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesUserCreateFieldInput>>;
};

export type ProfileRolesUserUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type ProfileRolesUserUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesUserConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesUserCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileRolesUserDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileRolesUserDisconnectFieldInput>>;
  update?: InputMaybe<ProfileRolesUserUpdateConnectionInput>;
  where?: InputMaybe<ProfileRolesUserConnectionWhere>;
};

export type ProfileShare = {
  __typename?: "ProfileShare";
  organization: Organization;
  organizationConnection: ProfileShareOrganizationConnection;
  profile: Profile;
  profileConnection: ProfileShareProfileConnection;
  sharedWithOrganization: Organization;
  sharedWithOrganizationConnection: ProfileShareSharedWithOrganizationConnection;
  uuid: Scalars["ID"]["output"];
};

export type ProfileShareOrganizationArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ProfileShareOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<ProfileShareOrganizationConnectionSort>>;
  where?: InputMaybe<ProfileShareOrganizationConnectionWhere>;
};

export type ProfileShareProfileArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type ProfileShareProfileConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<ProfileShareProfileConnectionSort>>;
  where?: InputMaybe<ProfileShareProfileConnectionWhere>;
};

export type ProfileShareSharedWithOrganizationArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ProfileShareSharedWithOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<ProfileShareSharedWithOrganizationConnectionSort>>;
  where?: InputMaybe<ProfileShareSharedWithOrganizationConnectionWhere>;
};

export type ProfileShareCreateInput = {
  organization?: InputMaybe<ProfileShareOrganizationFieldInput>;
  profile?: InputMaybe<ProfileShareProfileFieldInput>;
  sharedWithOrganization?: InputMaybe<ProfileShareSharedWithOrganizationFieldInput>;
};

export type ProfileShareDeleteInput = {
  organization?: InputMaybe<ProfileShareOrganizationDeleteFieldInput>;
  profile?: InputMaybe<ProfileShareProfileDeleteFieldInput>;
  sharedWithOrganization?: InputMaybe<ProfileShareSharedWithOrganizationDeleteFieldInput>;
};

export type ProfileShareEdge = {
  __typename?: "ProfileShareEdge";
  cursor: Scalars["String"]["output"];
  node: ProfileShare;
};

export type ProfileShareOrganizationAggregateInput = {
  AND?: InputMaybe<Array<ProfileShareOrganizationAggregateInput>>;
  NOT?: InputMaybe<ProfileShareOrganizationAggregateInput>;
  OR?: InputMaybe<Array<ProfileShareOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<ProfileShareOrganizationNodeAggregationWhereInput>;
};

export type ProfileShareOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ProfileShareOrganizationConnection = {
  __typename?: "ProfileShareOrganizationConnection";
  edges: Array<ProfileShareOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ProfileShareOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type ProfileShareOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ProfileShareOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ProfileShareOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ProfileShareOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ProfileShareOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type ProfileShareOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ProfileShareOrganizationConnectionWhere>;
};

export type ProfileShareOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ProfileShareOrganizationConnectionWhere>;
};

export type ProfileShareOrganizationFieldInput = {
  connect?: InputMaybe<ProfileShareOrganizationConnectFieldInput>;
  create?: InputMaybe<ProfileShareOrganizationCreateFieldInput>;
};

export type ProfileShareOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileShareOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileShareOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileShareOrganizationNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ProfileShareOrganizationRelationship = {
  __typename?: "ProfileShareOrganizationRelationship";
  cursor: Scalars["String"]["output"];
  node: Organization;
};

export type ProfileShareOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ProfileShareOrganizationUpdateFieldInput = {
  connect?: InputMaybe<ProfileShareOrganizationConnectFieldInput>;
  create?: InputMaybe<ProfileShareOrganizationCreateFieldInput>;
  delete?: InputMaybe<ProfileShareOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<ProfileShareOrganizationDisconnectFieldInput>;
  update?: InputMaybe<ProfileShareOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ProfileShareOrganizationConnectionWhere>;
};

export type ProfileShareProfileAggregateInput = {
  AND?: InputMaybe<Array<ProfileShareProfileAggregateInput>>;
  NOT?: InputMaybe<ProfileShareProfileAggregateInput>;
  OR?: InputMaybe<Array<ProfileShareProfileAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<ProfileShareProfileNodeAggregationWhereInput>;
};

export type ProfileShareProfileConnectFieldInput = {
  connect?: InputMaybe<ProfileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type ProfileShareProfileConnection = {
  __typename?: "ProfileShareProfileConnection";
  edges: Array<ProfileShareProfileRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ProfileShareProfileConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type ProfileShareProfileConnectionWhere = {
  AND?: InputMaybe<Array<ProfileShareProfileConnectionWhere>>;
  NOT?: InputMaybe<ProfileShareProfileConnectionWhere>;
  OR?: InputMaybe<Array<ProfileShareProfileConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type ProfileShareProfileCreateFieldInput = {
  node: ProfileCreateInput;
};

export type ProfileShareProfileDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ProfileShareProfileConnectionWhere>;
};

export type ProfileShareProfileDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<ProfileShareProfileConnectionWhere>;
};

export type ProfileShareProfileFieldInput = {
  connect?: InputMaybe<ProfileShareProfileConnectFieldInput>;
  create?: InputMaybe<ProfileShareProfileCreateFieldInput>;
};

export type ProfileShareProfileNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileShareProfileNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileShareProfileNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileShareProfileNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosAccepted_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ProfileShareProfileRelationship = {
  __typename?: "ProfileShareProfileRelationship";
  cursor: Scalars["String"]["output"];
  node: Profile;
};

export type ProfileShareProfileUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type ProfileShareProfileUpdateFieldInput = {
  connect?: InputMaybe<ProfileShareProfileConnectFieldInput>;
  create?: InputMaybe<ProfileShareProfileCreateFieldInput>;
  delete?: InputMaybe<ProfileShareProfileDeleteFieldInput>;
  disconnect?: InputMaybe<ProfileShareProfileDisconnectFieldInput>;
  update?: InputMaybe<ProfileShareProfileUpdateConnectionInput>;
  where?: InputMaybe<ProfileShareProfileConnectionWhere>;
};

export type ProfileShareSharedWithOrganizationAggregateInput = {
  AND?: InputMaybe<Array<ProfileShareSharedWithOrganizationAggregateInput>>;
  NOT?: InputMaybe<ProfileShareSharedWithOrganizationAggregateInput>;
  OR?: InputMaybe<Array<ProfileShareSharedWithOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<ProfileShareSharedWithOrganizationNodeAggregationWhereInput>;
};

export type ProfileShareSharedWithOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ProfileShareSharedWithOrganizationConnection = {
  __typename?: "ProfileShareSharedWithOrganizationConnection";
  edges: Array<ProfileShareSharedWithOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ProfileShareSharedWithOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type ProfileShareSharedWithOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ProfileShareSharedWithOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ProfileShareSharedWithOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ProfileShareSharedWithOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ProfileShareSharedWithOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type ProfileShareSharedWithOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ProfileShareSharedWithOrganizationConnectionWhere>;
};

export type ProfileShareSharedWithOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ProfileShareSharedWithOrganizationConnectionWhere>;
};

export type ProfileShareSharedWithOrganizationFieldInput = {
  connect?: InputMaybe<ProfileShareSharedWithOrganizationConnectFieldInput>;
  create?: InputMaybe<ProfileShareSharedWithOrganizationCreateFieldInput>;
};

export type ProfileShareSharedWithOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileShareSharedWithOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileShareSharedWithOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileShareSharedWithOrganizationNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  city_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  city_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  city_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  country_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  country_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  country_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  imprintHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  imprintHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  privacyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  privacyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  region_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  region_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  region_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartContactId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartContactId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  zipCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  zipCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ProfileShareSharedWithOrganizationRelationship = {
  __typename?: "ProfileShareSharedWithOrganizationRelationship";
  cursor: Scalars["String"]["output"];
  node: Organization;
};

export type ProfileShareSharedWithOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ProfileShareSharedWithOrganizationUpdateFieldInput = {
  connect?: InputMaybe<ProfileShareSharedWithOrganizationConnectFieldInput>;
  create?: InputMaybe<ProfileShareSharedWithOrganizationCreateFieldInput>;
  delete?: InputMaybe<ProfileShareSharedWithOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<ProfileShareSharedWithOrganizationDisconnectFieldInput>;
  update?: InputMaybe<ProfileShareSharedWithOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ProfileShareSharedWithOrganizationConnectionWhere>;
};

/** Fields to sort ProfileShares by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProfileShareSort object. */
export type ProfileShareSort = {
  uuid?: InputMaybe<SortDirection>;
};

export type ProfileShareUpdateInput = {
  organization?: InputMaybe<ProfileShareOrganizationUpdateFieldInput>;
  profile?: InputMaybe<ProfileShareProfileUpdateFieldInput>;
  sharedWithOrganization?: InputMaybe<ProfileShareSharedWithOrganizationUpdateFieldInput>;
};

export type ProfileShareWhere = {
  AND?: InputMaybe<Array<ProfileShareWhere>>;
  NOT?: InputMaybe<ProfileShareWhere>;
  OR?: InputMaybe<Array<ProfileShareWhere>>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<ProfileShareOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<ProfileShareOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<ProfileShareOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  profile?: InputMaybe<ProfileWhere>;
  profileAggregate?: InputMaybe<ProfileShareProfileAggregateInput>;
  profileConnection?: InputMaybe<ProfileShareProfileConnectionWhere>;
  profileConnection_NOT?: InputMaybe<ProfileShareProfileConnectionWhere>;
  profile_NOT?: InputMaybe<ProfileWhere>;
  sharedWithOrganization?: InputMaybe<OrganizationWhere>;
  sharedWithOrganizationAggregate?: InputMaybe<ProfileShareSharedWithOrganizationAggregateInput>;
  sharedWithOrganizationConnection?: InputMaybe<ProfileShareSharedWithOrganizationConnectionWhere>;
  sharedWithOrganizationConnection_NOT?: InputMaybe<ProfileShareSharedWithOrganizationConnectionWhere>;
  sharedWithOrganization_NOT?: InputMaybe<OrganizationWhere>;
  uuid?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ProfileSharesConnection = {
  __typename?: "ProfileSharesConnection";
  edges: Array<ProfileShareEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** Fields to sort Profiles by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProfileSort object. */
export type ProfileSort = {
  birthday?: InputMaybe<SortDirection>;
  displayName?: InputMaybe<SortDirection>;
  displayNameShort?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  firstNames?: InputMaybe<SortDirection>;
  fullName?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  listName?: InputMaybe<SortDirection>;
  prefixName?: InputMaybe<SortDirection>;
  salutation?: InputMaybe<SortDirection>;
  selectName?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  tecartPersonId?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  tosAccepted?: InputMaybe<SortDirection>;
  tosVersion?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type ProfileUpdateInput = {
  birthday?: InputMaybe<Scalars["Date"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  firstNames?: InputMaybe<Scalars["String"]["input"]>;
  groups?: InputMaybe<Array<ProfileGroupsUpdateFieldInput>>;
  incomingRoles?: InputMaybe<ProfileIncomingRolesUpdateInput>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<ProfileOrganizationUpdateFieldInput>;
  prefixName?: InputMaybe<Scalars["String"]["input"]>;
  properties?: InputMaybe<Array<ProfilePropertiesUpdateFieldInput>>;
  roles?: InputMaybe<ProfileRolesUpdateInput>;
  salutation?: InputMaybe<Scalars["String"]["input"]>;
  shortName?: InputMaybe<Scalars["String"]["input"]>;
  tecartPersonId?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  tosAccepted?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosVersion?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<ProfileUserUpdateFieldInput>;
};

export type ProfileUserAggregateInput = {
  AND?: InputMaybe<Array<ProfileUserAggregateInput>>;
  NOT?: InputMaybe<ProfileUserAggregateInput>;
  OR?: InputMaybe<Array<ProfileUserAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<ProfileUserNodeAggregationWhereInput>;
};

export type ProfileUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  edge?: InputMaybe<ProfileRelationPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<UserConnectWhere>;
};

export type ProfileUserConnection = {
  __typename?: "ProfileUserConnection";
  edges: Array<ProfileUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ProfileUserConnectionSort = {
  edge?: InputMaybe<ProfileRelationPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type ProfileUserConnectionWhere = {
  AND?: InputMaybe<Array<ProfileUserConnectionWhere>>;
  NOT?: InputMaybe<ProfileUserConnectionWhere>;
  OR?: InputMaybe<Array<ProfileUserConnectionWhere>>;
  edge?: InputMaybe<ProfileRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<ProfileRelationPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<UserWhere>;
};

export type ProfileUserCreateFieldInput = {
  edge?: InputMaybe<ProfileRelationPropertiesCreateInput>;
  node: UserCreateInput;
};

export type ProfileUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ProfileUserConnectionWhere>;
};

export type ProfileUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ProfileUserConnectionWhere>;
};

export type ProfileUserFieldInput = {
  connect?: InputMaybe<ProfileUserConnectFieldInput>;
  create?: InputMaybe<ProfileUserCreateFieldInput>;
};

export type ProfileUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileUserNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  invitationFrontendUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  invitationFrontendUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  invitationFrontendUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  invitationFrontendUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  invitationFrontendUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  invitationOtpValidUntil_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  newEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  newEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  newEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  newEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  newEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  passwordChangedAt_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  preferredTheme_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  preferredTheme_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  preferredTheme_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  preferredTheme_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  preferredTheme_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  recoveryCodesGeneratedAt_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type ProfileUserRelationship = {
  __typename?: "ProfileUserRelationship";
  cursor: Scalars["String"]["output"];
  node: User;
  properties: ProfileRelationProperties;
};

export type ProfileUserUpdateConnectionInput = {
  edge?: InputMaybe<ProfileRelationPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type ProfileUserUpdateFieldInput = {
  connect?: InputMaybe<ProfileUserConnectFieldInput>;
  create?: InputMaybe<ProfileUserCreateFieldInput>;
  delete?: InputMaybe<ProfileUserDeleteFieldInput>;
  disconnect?: InputMaybe<ProfileUserDisconnectFieldInput>;
  update?: InputMaybe<ProfileUserUpdateConnectionInput>;
  where?: InputMaybe<ProfileUserConnectionWhere>;
};

export type ProfileWhere = {
  AND?: InputMaybe<Array<ProfileWhere>>;
  NOT?: InputMaybe<ProfileWhere>;
  OR?: InputMaybe<Array<ProfileWhere>>;
  birthday?: InputMaybe<Scalars["Date"]["input"]>;
  birthday_GT?: InputMaybe<Scalars["Date"]["input"]>;
  birthday_GTE?: InputMaybe<Scalars["Date"]["input"]>;
  birthday_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]["input"]>>>;
  birthday_LT?: InputMaybe<Scalars["Date"]["input"]>;
  birthday_LTE?: InputMaybe<Scalars["Date"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthday_NOT?: InputMaybe<Scalars["Date"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthday_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]["input"]>>>;
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  displayNameShort?: InputMaybe<Scalars["String"]["input"]>;
  displayNameShort_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  displayNameShort_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  displayNameShort_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  displayNameShort_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  displayName_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  displayName_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  displayName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  displayName_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  email_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  email_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  email_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  email_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  firstName_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  firstName_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  firstName_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  firstName_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  firstNames?: InputMaybe<Scalars["String"]["input"]>;
  firstNames_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  firstNames_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  firstNames_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  firstNames_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  fullName_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  fullName_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  fullName_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  fullName_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  grantedApplications?: InputMaybe<ApplicationWhere>;
  grantedApplications_ALL?: InputMaybe<ApplicationWhere>;
  grantedApplications_NONE?: InputMaybe<ApplicationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grantedApplications_NOT?: InputMaybe<ApplicationWhere>;
  grantedApplications_SINGLE?: InputMaybe<ApplicationWhere>;
  grantedApplications_SOME?: InputMaybe<ApplicationWhere>;
  /** @deprecated Use `groups_SOME` instead. */
  groups?: InputMaybe<GroupWhere>;
  groupsAggregate?: InputMaybe<ProfileGroupsAggregateInput>;
  /** @deprecated Use `groupsConnection_SOME` instead. */
  groupsConnection?: InputMaybe<ProfileGroupsConnectionWhere>;
  /** Return Profiles where all of the related ProfileGroupsConnections match this filter */
  groupsConnection_ALL?: InputMaybe<ProfileGroupsConnectionWhere>;
  /** Return Profiles where none of the related ProfileGroupsConnections match this filter */
  groupsConnection_NONE?: InputMaybe<ProfileGroupsConnectionWhere>;
  /** @deprecated Use `groupsConnection_NONE` instead. */
  groupsConnection_NOT?: InputMaybe<ProfileGroupsConnectionWhere>;
  /** Return Profiles where one of the related ProfileGroupsConnections match this filter */
  groupsConnection_SINGLE?: InputMaybe<ProfileGroupsConnectionWhere>;
  /** Return Profiles where some of the related ProfileGroupsConnections match this filter */
  groupsConnection_SOME?: InputMaybe<ProfileGroupsConnectionWhere>;
  /** Return Profiles where all of the related Groups match this filter */
  groups_ALL?: InputMaybe<GroupWhere>;
  /** Return Profiles where none of the related Groups match this filter */
  groups_NONE?: InputMaybe<GroupWhere>;
  /** @deprecated Use `groups_NONE` instead. */
  groups_NOT?: InputMaybe<GroupWhere>;
  /** Return Profiles where one of the related Groups match this filter */
  groups_SINGLE?: InputMaybe<GroupWhere>;
  /** Return Profiles where some of the related Groups match this filter */
  groups_SOME?: InputMaybe<GroupWhere>;
  /** @deprecated Use `incomingRoles_SOME` instead. */
  incomingRoles?: InputMaybe<RoleTargetWhere>;
  /** @deprecated Use `incomingRolesConnection_SOME` instead. */
  incomingRolesConnection?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  /** Return Profiles where all of the related ProfileIncomingRolesConnections match this filter */
  incomingRolesConnection_ALL?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  /** Return Profiles where none of the related ProfileIncomingRolesConnections match this filter */
  incomingRolesConnection_NONE?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  /** @deprecated Use `incomingRolesConnection_NONE` instead. */
  incomingRolesConnection_NOT?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  /** Return Profiles where one of the related ProfileIncomingRolesConnections match this filter */
  incomingRolesConnection_SINGLE?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  /** Return Profiles where some of the related ProfileIncomingRolesConnections match this filter */
  incomingRolesConnection_SOME?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  /** Return Profiles where all of the related RoleTargets match this filter */
  incomingRoles_ALL?: InputMaybe<RoleTargetWhere>;
  /** Return Profiles where none of the related RoleTargets match this filter */
  incomingRoles_NONE?: InputMaybe<RoleTargetWhere>;
  /** @deprecated Use `incomingRoles_NONE` instead. */
  incomingRoles_NOT?: InputMaybe<RoleTargetWhere>;
  /** Return Profiles where one of the related RoleTargets match this filter */
  incomingRoles_SINGLE?: InputMaybe<RoleTargetWhere>;
  /** Return Profiles where some of the related RoleTargets match this filter */
  incomingRoles_SOME?: InputMaybe<RoleTargetWhere>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  lastName_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  lastName_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  lastName_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  lastName_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  listName?: InputMaybe<Scalars["String"]["input"]>;
  listName_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  listName_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  listName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  listName_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<ProfileOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<ProfileOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<ProfileOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  prefixName?: InputMaybe<Scalars["String"]["input"]>;
  prefixName_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  prefixName_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  prefixName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  prefixName_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Use `properties_SOME` instead. */
  properties?: InputMaybe<PropertyWhere>;
  propertiesAggregate?: InputMaybe<ProfilePropertiesAggregateInput>;
  /** @deprecated Use `propertiesConnection_SOME` instead. */
  propertiesConnection?: InputMaybe<ProfilePropertiesConnectionWhere>;
  /** Return Profiles where all of the related ProfilePropertiesConnections match this filter */
  propertiesConnection_ALL?: InputMaybe<ProfilePropertiesConnectionWhere>;
  /** Return Profiles where none of the related ProfilePropertiesConnections match this filter */
  propertiesConnection_NONE?: InputMaybe<ProfilePropertiesConnectionWhere>;
  /** @deprecated Use `propertiesConnection_NONE` instead. */
  propertiesConnection_NOT?: InputMaybe<ProfilePropertiesConnectionWhere>;
  /** Return Profiles where one of the related ProfilePropertiesConnections match this filter */
  propertiesConnection_SINGLE?: InputMaybe<ProfilePropertiesConnectionWhere>;
  /** Return Profiles where some of the related ProfilePropertiesConnections match this filter */
  propertiesConnection_SOME?: InputMaybe<ProfilePropertiesConnectionWhere>;
  /** Return Profiles where all of the related Properties match this filter */
  properties_ALL?: InputMaybe<PropertyWhere>;
  /** Return Profiles where none of the related Properties match this filter */
  properties_NONE?: InputMaybe<PropertyWhere>;
  /** @deprecated Use `properties_NONE` instead. */
  properties_NOT?: InputMaybe<PropertyWhere>;
  /** Return Profiles where one of the related Properties match this filter */
  properties_SINGLE?: InputMaybe<PropertyWhere>;
  /** Return Profiles where some of the related Properties match this filter */
  properties_SOME?: InputMaybe<PropertyWhere>;
  /** @deprecated Use `roles_SOME` instead. */
  roles?: InputMaybe<RoleTargetWhere>;
  /** @deprecated Use `rolesConnection_SOME` instead. */
  rolesConnection?: InputMaybe<ProfileRolesConnectionWhere>;
  /** Return Profiles where all of the related ProfileRolesConnections match this filter */
  rolesConnection_ALL?: InputMaybe<ProfileRolesConnectionWhere>;
  /** Return Profiles where none of the related ProfileRolesConnections match this filter */
  rolesConnection_NONE?: InputMaybe<ProfileRolesConnectionWhere>;
  /** @deprecated Use `rolesConnection_NONE` instead. */
  rolesConnection_NOT?: InputMaybe<ProfileRolesConnectionWhere>;
  /** Return Profiles where one of the related ProfileRolesConnections match this filter */
  rolesConnection_SINGLE?: InputMaybe<ProfileRolesConnectionWhere>;
  /** Return Profiles where some of the related ProfileRolesConnections match this filter */
  rolesConnection_SOME?: InputMaybe<ProfileRolesConnectionWhere>;
  /** Return Profiles where all of the related RoleTargets match this filter */
  roles_ALL?: InputMaybe<RoleTargetWhere>;
  /** Return Profiles where none of the related RoleTargets match this filter */
  roles_NONE?: InputMaybe<RoleTargetWhere>;
  /** @deprecated Use `roles_NONE` instead. */
  roles_NOT?: InputMaybe<RoleTargetWhere>;
  /** Return Profiles where one of the related RoleTargets match this filter */
  roles_SINGLE?: InputMaybe<RoleTargetWhere>;
  /** Return Profiles where some of the related RoleTargets match this filter */
  roles_SOME?: InputMaybe<RoleTargetWhere>;
  salutation?: InputMaybe<Scalars["String"]["input"]>;
  salutation_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  salutation_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  salutation_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  salutation_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  selectName?: InputMaybe<Scalars["String"]["input"]>;
  selectName_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  selectName_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  selectName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  selectName_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  shortName?: InputMaybe<Scalars["String"]["input"]>;
  shortName_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  shortName_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  shortName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  shortName_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tecartPersonId?: InputMaybe<Scalars["String"]["input"]>;
  tecartPersonId_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  tecartPersonId_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tecartPersonId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartPersonId_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartPersonId_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartPersonId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartPersonId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartPersonId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tecartPersonId_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  title_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  title_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tosAccepted?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  tosAccepted_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosAccepted_NOT?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosAccepted_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  tosVersion?: InputMaybe<Scalars["String"]["input"]>;
  tosVersion_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  tosVersion_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tosVersion_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  tosVersion_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<ProfileUserAggregateInput>;
  userConnection?: InputMaybe<ProfileUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<ProfileUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
  uuid?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ProfilesConnection = {
  __typename?: "ProfilesConnection";
  edges: Array<ProfileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type PropertiesConnection = {
  __typename?: "PropertiesConnection";
  edges: Array<PropertyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/**
 * The edge properties for the following fields:
 * * Organization.properties
 * * Group.properties
 * * User.properties
 * * Profile.properties
 * * Property.subject
 */
export type PropertiesScope = {
  __typename?: "PropertiesScope";
  scope: Scalars["String"]["output"];
};

export type PropertiesScopeAggregationWhereInput = {
  AND?: InputMaybe<Array<PropertiesScopeAggregationWhereInput>>;
  NOT?: InputMaybe<PropertiesScopeAggregationWhereInput>;
  OR?: InputMaybe<Array<PropertiesScopeAggregationWhereInput>>;
  scope_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  scope_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  scope_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  scope_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  scope_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  scope_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  scope_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  scope_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  scope_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  scope_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  scope_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  scope_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  scope_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  scope_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  scope_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PropertiesScopeCreateInput = {
  scope: Scalars["String"]["input"];
};

export type PropertiesScopeSort = {
  scope?: InputMaybe<SortDirection>;
};

export type PropertiesScopeUpdateInput = {
  scope?: InputMaybe<Scalars["String"]["input"]>;
};

export type PropertiesScopeWhere = {
  AND?: InputMaybe<Array<PropertiesScopeWhere>>;
  NOT?: InputMaybe<PropertiesScopeWhere>;
  OR?: InputMaybe<Array<PropertiesScopeWhere>>;
  scope?: InputMaybe<Scalars["String"]["input"]>;
  scope_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  scope_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  scope_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  scope_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  scope_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  scope_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  scope_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  scope_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  scope_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
};

export type PropertiesSubject = Group | Organization | Profile | User;

export type PropertiesSubjectWhere = {
  Group?: InputMaybe<GroupWhere>;
  Organization?: InputMaybe<OrganizationWhere>;
  Profile?: InputMaybe<ProfileWhere>;
  User?: InputMaybe<UserWhere>;
};

export type Property = {
  __typename?: "Property";
  name: Scalars["String"]["output"];
  subject: PropertiesSubject;
  subjectConnection: PropertySubjectConnection;
  uuid: Scalars["ID"]["output"];
  value: Scalars["String"]["output"];
};

export type PropertySubjectArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<PropertiesSubjectWhere>;
};

export type PropertySubjectConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<PropertySubjectConnectionSort>>;
  where?: InputMaybe<PropertySubjectConnectionWhere>;
};

export type PropertyAggregateSelection = {
  __typename?: "PropertyAggregateSelection";
  count: Scalars["Int"]["output"];
  name: StringAggregateSelection;
  uuid: IdAggregateSelection;
  value: StringAggregateSelection;
};

export type PropertyConnectInput = {
  subject?: InputMaybe<PropertySubjectConnectInput>;
};

export type PropertyConnectWhere = {
  node: PropertyWhere;
};

export type PropertyCreateInput = {
  name: Scalars["String"]["input"];
  subject?: InputMaybe<PropertySubjectCreateInput>;
  value: Scalars["String"]["input"];
};

/** Custom mutations: */
export type PropertyDataCreateInput = {
  name: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type PropertyDeleteInput = {
  subject?: InputMaybe<PropertySubjectDeleteInput>;
};

export type PropertyDisconnectInput = {
  subject?: InputMaybe<PropertySubjectDisconnectInput>;
};

export type PropertyEdge = {
  __typename?: "PropertyEdge";
  cursor: Scalars["String"]["output"];
  node: Property;
};

export type PropertyMutationProperty = {
  __typename?: "PropertyMutationProperty";
  uuid: Scalars["ID"]["output"];
};

export type PropertyOptions = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Specify one or more PropertySort objects to sort Properties by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PropertySort>>;
};

/** Fields to sort Properties by. The order in which sorts are applied is not guaranteed when specifying many fields in one PropertySort object. */
export type PropertySort = {
  name?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type PropertySubjectConnectInput = {
  Group?: InputMaybe<PropertySubjectGroupConnectFieldInput>;
  Organization?: InputMaybe<PropertySubjectOrganizationConnectFieldInput>;
  Profile?: InputMaybe<PropertySubjectProfileConnectFieldInput>;
  User?: InputMaybe<PropertySubjectUserConnectFieldInput>;
};

export type PropertySubjectConnection = {
  __typename?: "PropertySubjectConnection";
  edges: Array<PropertySubjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type PropertySubjectConnectionSort = {
  edge?: InputMaybe<PropertiesScopeSort>;
};

export type PropertySubjectConnectionWhere = {
  Group?: InputMaybe<PropertySubjectGroupConnectionWhere>;
  Organization?: InputMaybe<PropertySubjectOrganizationConnectionWhere>;
  Profile?: InputMaybe<PropertySubjectProfileConnectionWhere>;
  User?: InputMaybe<PropertySubjectUserConnectionWhere>;
};

export type PropertySubjectCreateInput = {
  Group?: InputMaybe<PropertySubjectGroupFieldInput>;
  Organization?: InputMaybe<PropertySubjectOrganizationFieldInput>;
  Profile?: InputMaybe<PropertySubjectProfileFieldInput>;
  User?: InputMaybe<PropertySubjectUserFieldInput>;
};

export type PropertySubjectDeleteInput = {
  Group?: InputMaybe<PropertySubjectGroupDeleteFieldInput>;
  Organization?: InputMaybe<PropertySubjectOrganizationDeleteFieldInput>;
  Profile?: InputMaybe<PropertySubjectProfileDeleteFieldInput>;
  User?: InputMaybe<PropertySubjectUserDeleteFieldInput>;
};

export type PropertySubjectDisconnectInput = {
  Group?: InputMaybe<PropertySubjectGroupDisconnectFieldInput>;
  Organization?: InputMaybe<PropertySubjectOrganizationDisconnectFieldInput>;
  Profile?: InputMaybe<PropertySubjectProfileDisconnectFieldInput>;
  User?: InputMaybe<PropertySubjectUserDisconnectFieldInput>;
};

export type PropertySubjectGroupConnectFieldInput = {
  connect?: InputMaybe<GroupConnectInput>;
  edge: PropertiesScopeCreateInput;
  where?: InputMaybe<GroupConnectWhere>;
};

export type PropertySubjectGroupConnectionWhere = {
  AND?: InputMaybe<Array<PropertySubjectGroupConnectionWhere>>;
  NOT?: InputMaybe<PropertySubjectGroupConnectionWhere>;
  OR?: InputMaybe<Array<PropertySubjectGroupConnectionWhere>>;
  edge?: InputMaybe<PropertiesScopeWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PropertiesScopeWhere>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type PropertySubjectGroupCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: GroupCreateInput;
};

export type PropertySubjectGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<PropertySubjectGroupConnectionWhere>;
};

export type PropertySubjectGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<PropertySubjectGroupConnectionWhere>;
};

export type PropertySubjectGroupFieldInput = {
  connect?: InputMaybe<PropertySubjectGroupConnectFieldInput>;
  create?: InputMaybe<PropertySubjectGroupCreateFieldInput>;
};

export type PropertySubjectGroupUpdateConnectionInput = {
  edge?: InputMaybe<PropertiesScopeUpdateInput>;
  node?: InputMaybe<GroupUpdateInput>;
};

export type PropertySubjectGroupUpdateFieldInput = {
  connect?: InputMaybe<PropertySubjectGroupConnectFieldInput>;
  create?: InputMaybe<PropertySubjectGroupCreateFieldInput>;
  delete?: InputMaybe<PropertySubjectGroupDeleteFieldInput>;
  disconnect?: InputMaybe<PropertySubjectGroupDisconnectFieldInput>;
  update?: InputMaybe<PropertySubjectGroupUpdateConnectionInput>;
  where?: InputMaybe<PropertySubjectGroupConnectionWhere>;
};

export type PropertySubjectOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  edge: PropertiesScopeCreateInput;
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type PropertySubjectOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<PropertySubjectOrganizationConnectionWhere>>;
  NOT?: InputMaybe<PropertySubjectOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<PropertySubjectOrganizationConnectionWhere>>;
  edge?: InputMaybe<PropertiesScopeWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PropertiesScopeWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type PropertySubjectOrganizationCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: OrganizationCreateInput;
};

export type PropertySubjectOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<PropertySubjectOrganizationConnectionWhere>;
};

export type PropertySubjectOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<PropertySubjectOrganizationConnectionWhere>;
};

export type PropertySubjectOrganizationFieldInput = {
  connect?: InputMaybe<PropertySubjectOrganizationConnectFieldInput>;
  create?: InputMaybe<PropertySubjectOrganizationCreateFieldInput>;
};

export type PropertySubjectOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<PropertiesScopeUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type PropertySubjectOrganizationUpdateFieldInput = {
  connect?: InputMaybe<PropertySubjectOrganizationConnectFieldInput>;
  create?: InputMaybe<PropertySubjectOrganizationCreateFieldInput>;
  delete?: InputMaybe<PropertySubjectOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<PropertySubjectOrganizationDisconnectFieldInput>;
  update?: InputMaybe<PropertySubjectOrganizationUpdateConnectionInput>;
  where?: InputMaybe<PropertySubjectOrganizationConnectionWhere>;
};

export type PropertySubjectProfileConnectFieldInput = {
  connect?: InputMaybe<ProfileConnectInput>;
  edge: PropertiesScopeCreateInput;
  where?: InputMaybe<ProfileConnectWhere>;
};

export type PropertySubjectProfileConnectionWhere = {
  AND?: InputMaybe<Array<PropertySubjectProfileConnectionWhere>>;
  NOT?: InputMaybe<PropertySubjectProfileConnectionWhere>;
  OR?: InputMaybe<Array<PropertySubjectProfileConnectionWhere>>;
  edge?: InputMaybe<PropertiesScopeWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PropertiesScopeWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type PropertySubjectProfileCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: ProfileCreateInput;
};

export type PropertySubjectProfileDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<PropertySubjectProfileConnectionWhere>;
};

export type PropertySubjectProfileDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<PropertySubjectProfileConnectionWhere>;
};

export type PropertySubjectProfileFieldInput = {
  connect?: InputMaybe<PropertySubjectProfileConnectFieldInput>;
  create?: InputMaybe<PropertySubjectProfileCreateFieldInput>;
};

export type PropertySubjectProfileUpdateConnectionInput = {
  edge?: InputMaybe<PropertiesScopeUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type PropertySubjectProfileUpdateFieldInput = {
  connect?: InputMaybe<PropertySubjectProfileConnectFieldInput>;
  create?: InputMaybe<PropertySubjectProfileCreateFieldInput>;
  delete?: InputMaybe<PropertySubjectProfileDeleteFieldInput>;
  disconnect?: InputMaybe<PropertySubjectProfileDisconnectFieldInput>;
  update?: InputMaybe<PropertySubjectProfileUpdateConnectionInput>;
  where?: InputMaybe<PropertySubjectProfileConnectionWhere>;
};

export type PropertySubjectRelationship = {
  __typename?: "PropertySubjectRelationship";
  cursor: Scalars["String"]["output"];
  node: PropertiesSubject;
  properties: PropertiesScope;
};

export type PropertySubjectUpdateInput = {
  Group?: InputMaybe<PropertySubjectGroupUpdateFieldInput>;
  Organization?: InputMaybe<PropertySubjectOrganizationUpdateFieldInput>;
  Profile?: InputMaybe<PropertySubjectProfileUpdateFieldInput>;
  User?: InputMaybe<PropertySubjectUserUpdateFieldInput>;
};

export type PropertySubjectUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  edge: PropertiesScopeCreateInput;
  where?: InputMaybe<UserConnectWhere>;
};

export type PropertySubjectUserConnectionWhere = {
  AND?: InputMaybe<Array<PropertySubjectUserConnectionWhere>>;
  NOT?: InputMaybe<PropertySubjectUserConnectionWhere>;
  OR?: InputMaybe<Array<PropertySubjectUserConnectionWhere>>;
  edge?: InputMaybe<PropertiesScopeWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PropertiesScopeWhere>;
  node?: InputMaybe<UserWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<UserWhere>;
};

export type PropertySubjectUserCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: UserCreateInput;
};

export type PropertySubjectUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<PropertySubjectUserConnectionWhere>;
};

export type PropertySubjectUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<PropertySubjectUserConnectionWhere>;
};

export type PropertySubjectUserFieldInput = {
  connect?: InputMaybe<PropertySubjectUserConnectFieldInput>;
  create?: InputMaybe<PropertySubjectUserCreateFieldInput>;
};

export type PropertySubjectUserUpdateConnectionInput = {
  edge?: InputMaybe<PropertiesScopeUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type PropertySubjectUserUpdateFieldInput = {
  connect?: InputMaybe<PropertySubjectUserConnectFieldInput>;
  create?: InputMaybe<PropertySubjectUserCreateFieldInput>;
  delete?: InputMaybe<PropertySubjectUserDeleteFieldInput>;
  disconnect?: InputMaybe<PropertySubjectUserDisconnectFieldInput>;
  update?: InputMaybe<PropertySubjectUserUpdateConnectionInput>;
  where?: InputMaybe<PropertySubjectUserConnectionWhere>;
};

export type PropertyUpdateInput = {
  name?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<PropertySubjectUpdateInput>;
  value?: InputMaybe<Scalars["String"]["input"]>;
};

export type PropertyWhere = {
  AND?: InputMaybe<Array<PropertyWhere>>;
  NOT?: InputMaybe<PropertyWhere>;
  OR?: InputMaybe<Array<PropertyWhere>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  name_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  name_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<PropertiesSubjectWhere>;
  subjectConnection?: InputMaybe<PropertySubjectConnectionWhere>;
  subjectConnection_NOT?: InputMaybe<PropertySubjectConnectionWhere>;
  subject_NOT?: InputMaybe<PropertiesSubjectWhere>;
  uuid?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  value?: InputMaybe<Scalars["String"]["input"]>;
  value_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  value_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  value_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  value_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query = {
  __typename?: "Query";
  applications: Array<Application>;
  applicationsAggregate: ApplicationAggregateSelection;
  applicationsConnection: ApplicationsConnection;
  /**
   * Audit log, most recent first. Omni-admin only. Filter to one user via
   * userUuid; otherwise returns recent events across all users.
   */
  auditEvents: Array<AuditEvent>;
  authClients: Array<AuthClient>;
  collaboratingOrganizations: Array<OrganizationWithCollaboratingOrganizations>;
  federatedClients: Array<FederatedClient>;
  federatedClientsAggregate: FederatedClientAggregateSelection;
  federatedClientsConnection: FederatedClientsConnection;
  globalSubjects: Array<GlobalSubject>;
  groups: Array<Group>;
  groupsAggregate: GroupAggregateSelection;
  groupsConnection: GroupsConnection;
  minimalProfileShares: Array<MinimalProfileShare>;
  minimalProfileSharesConnection: MinimalProfileSharesConnection;
  organizations: Array<Organization>;
  organizationsAggregate: OrganizationAggregateSelection;
  organizationsConnection: OrganizationsConnection;
  profileShares: Array<MinimalProfileShare>;
  profileSharesConnection: ProfileSharesConnection;
  profiles: Array<Profile>;
  profilesAggregate: ProfileAggregateSelection;
  profilesConnection: ProfilesConnection;
  properties: Array<Property>;
  propertiesAggregate: PropertyAggregateSelection;
  propertiesConnection: PropertiesConnection;
  propertiesSubjects: Array<PropertiesSubject>;
  roleTargets: Array<RoleTarget>;
  users: Array<User>;
  usersAggregate: UserAggregateSelection;
  usersConnection: UsersConnection;
};

export type QueryApplicationsArgs = {
  options?: InputMaybe<ApplicationOptions>;
  where?: InputMaybe<ApplicationWhere>;
};

export type QueryApplicationsAggregateArgs = {
  where?: InputMaybe<ApplicationWhere>;
};

export type QueryApplicationsConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<ApplicationSort>>>;
  where?: InputMaybe<ApplicationWhere>;
};

export type QueryAuditEventsArgs = {
  days?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  userUuid?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryAuthClientsArgs = {
  where?: InputMaybe<AuthClientWhere>;
};

export type QueryCollaboratingOrganizationsArgs = {
  where?: InputMaybe<UniqueOrganizationWhere>;
};

export type QueryFederatedClientsArgs = {
  options?: InputMaybe<FederatedClientOptions>;
  where?: InputMaybe<FederatedClientWhere>;
};

export type QueryFederatedClientsAggregateArgs = {
  where?: InputMaybe<FederatedClientWhere>;
};

export type QueryFederatedClientsConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<FederatedClientSort>>>;
  where?: InputMaybe<FederatedClientWhere>;
};

export type QueryGlobalSubjectsArgs = {
  where?: InputMaybe<GlobalSubjectsWhere>;
};

export type QueryGroupsArgs = {
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type QueryGroupsAggregateArgs = {
  where?: InputMaybe<GroupWhere>;
};

export type QueryGroupsConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<GroupSort>>>;
  where?: InputMaybe<GroupWhere>;
};

export type QueryMinimalProfileSharesArgs = {
  options?: InputMaybe<MinimalProfileShareOptions>;
  where?: InputMaybe<MinimalProfileShareWhere>;
};

export type QueryMinimalProfileSharesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<MinimalProfileShareSort>>>;
  where?: InputMaybe<MinimalProfileShareWhere>;
};

export type QueryOrganizationsArgs = {
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type QueryOrganizationsAggregateArgs = {
  where?: InputMaybe<OrganizationWhere>;
};

export type QueryOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<OrganizationSort>>>;
  where?: InputMaybe<OrganizationWhere>;
};

export type QueryProfileSharesArgs = {
  where?: InputMaybe<ProfileShareWhere>;
};

export type QueryProfileSharesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<ProfileShareSort>>>;
  where?: InputMaybe<ProfileShareWhere>;
};

export type QueryProfilesArgs = {
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type QueryProfilesAggregateArgs = {
  where?: InputMaybe<ProfileWhere>;
};

export type QueryProfilesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<ProfileSort>>>;
  where?: InputMaybe<ProfileWhere>;
};

export type QueryPropertiesArgs = {
  options?: InputMaybe<PropertyOptions>;
  where?: InputMaybe<PropertyWhere>;
};

export type QueryPropertiesAggregateArgs = {
  where?: InputMaybe<PropertyWhere>;
};

export type QueryPropertiesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<PropertySort>>>;
  where?: InputMaybe<PropertyWhere>;
};

export type QueryPropertiesSubjectsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<PropertiesSubjectWhere>;
};

export type QueryRoleTargetsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<RoleTargetWhere>;
};

export type QueryUsersArgs = {
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};

export type QueryUsersAggregateArgs = {
  where?: InputMaybe<UserWhere>;
};

export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<UserSort>>>;
  where?: InputMaybe<UserWhere>;
};

/** Input type for options that can be specified on a query operation. */
export type QueryOptions = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ReplacePropertiesMutationResponse = {
  __typename?: "ReplacePropertiesMutationResponse";
  properties: Array<PropertyMutationProperty>;
};

/**
 * The edge properties for the following fields:
 * * Organization.incomingRoles
 * * Group.incomingRoles
 * * Profile.roles
 * * Profile.incomingRoles
 */
export type RoleNames = {
  __typename?: "RoleNames";
  names: Array<Scalars["String"]["output"]>;
};

export type RoleNamesCreateInput = {
  names: Array<Scalars["String"]["input"]>;
};

export type RoleNamesSort = {
  names?: InputMaybe<SortDirection>;
};

export type RoleNamesUpdateInput = {
  names?: InputMaybe<Array<Scalars["String"]["input"]>>;
  names_POP?: InputMaybe<Scalars["Int"]["input"]>;
  names_PUSH?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type RoleNamesWhere = {
  AND?: InputMaybe<Array<RoleNamesWhere>>;
  NOT?: InputMaybe<RoleNamesWhere>;
  OR?: InputMaybe<Array<RoleNamesWhere>>;
  names?: InputMaybe<Array<Scalars["String"]["input"]>>;
  names_INCLUDES?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  names_NOT?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  names_NOT_INCLUDES?: InputMaybe<Scalars["String"]["input"]>;
};

export type RoleTarget = Group | Organization | Profile | User;

export type RoleTargetWhere = {
  Group?: InputMaybe<GroupWhere>;
  Organization?: InputMaybe<OrganizationWhere>;
  Profile?: InputMaybe<ProfileWhere>;
  User?: InputMaybe<UserWhere>;
};

export type SetPropertyMutationResponse = {
  __typename?: "SetPropertyMutationResponse";
  property: PropertyMutationProperty;
};

/**
 * The edge properties for the following fields:
 * * Organization.shadowsProfilesTo
 * * Organization.shadowProfileGroups
 */
export type ShadowRelationProperties = {
  __typename?: "ShadowRelationProperties";
  conditions: Scalars["String"]["output"];
  optIn: Scalars["Boolean"]["output"];
};

export type ShadowRelationPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<ShadowRelationPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<ShadowRelationPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<ShadowRelationPropertiesAggregationWhereInput>>;
  conditions_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  conditions_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  conditions_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  conditions_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  conditions_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  conditions_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  conditions_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  conditions_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  conditions_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  conditions_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  conditions_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  conditions_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  conditions_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  conditions_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  conditions_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ShadowRelationPropertiesCreateInput = {
  conditions: Scalars["String"]["input"];
  optIn: Scalars["Boolean"]["input"];
};

export type ShadowRelationPropertiesSort = {
  conditions?: InputMaybe<SortDirection>;
  optIn?: InputMaybe<SortDirection>;
};

export type ShadowRelationPropertiesUpdateInput = {
  conditions?: InputMaybe<Scalars["String"]["input"]>;
  optIn?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ShadowRelationPropertiesWhere = {
  AND?: InputMaybe<Array<ShadowRelationPropertiesWhere>>;
  NOT?: InputMaybe<ShadowRelationPropertiesWhere>;
  OR?: InputMaybe<Array<ShadowRelationPropertiesWhere>>;
  conditions?: InputMaybe<Scalars["String"]["input"]>;
  conditions_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  conditions_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  conditions_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conditions_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conditions_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conditions_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conditions_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conditions_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  conditions_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  optIn?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  optIn_NOT?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** An enum for sorting in either ascending or descending order. */
export enum SortDirection {
  /** Sort by field values in ascending order. */
  Asc = "ASC",
  /** Sort by field values in descending order. */
  Desc = "DESC",
}

export type StringAggregateSelection = {
  __typename?: "StringAggregateSelection";
  longest?: Maybe<Scalars["String"]["output"]>;
  shortest?: Maybe<Scalars["String"]["output"]>;
};

export type TwoFactorMethod = {
  __typename?: "TwoFactorMethod";
  name: Scalars["String"]["output"];
  type: TwoFactorMethodType;
  user: User;
  userConnection: TwoFactorMethodUserConnection;
  uuid: Scalars["ID"]["output"];
};

export type TwoFactorMethodUserArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};

export type TwoFactorMethodUserConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<TwoFactorMethodUserConnectionSort>>;
  where?: InputMaybe<TwoFactorMethodUserConnectionWhere>;
};

export type TwoFactorMethodConnectInput = {
  user?: InputMaybe<TwoFactorMethodUserConnectFieldInput>;
};

export type TwoFactorMethodConnectWhere = {
  node: TwoFactorMethodWhere;
};

export type TwoFactorMethodCreateInput = {
  name: Scalars["String"]["input"];
  type: TwoFactorMethodType;
  user?: InputMaybe<TwoFactorMethodUserFieldInput>;
};

export type TwoFactorMethodDeleteInput = {
  user?: InputMaybe<TwoFactorMethodUserDeleteFieldInput>;
};

export type TwoFactorMethodDisconnectInput = {
  user?: InputMaybe<TwoFactorMethodUserDisconnectFieldInput>;
};

export type TwoFactorMethodOptions = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Specify one or more TwoFactorMethodSort objects to sort TwoFactorMethods by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TwoFactorMethodSort>>;
};

/** Fields to sort TwoFactorMethods by. The order in which sorts are applied is not guaranteed when specifying many fields in one TwoFactorMethodSort object. */
export type TwoFactorMethodSort = {
  name?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export enum TwoFactorMethodType {
  Totp = "TOTP",
}

export type TwoFactorMethodUpdateInput = {
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<TwoFactorMethodType>;
  user?: InputMaybe<TwoFactorMethodUserUpdateFieldInput>;
};

export type TwoFactorMethodUserAggregateInput = {
  AND?: InputMaybe<Array<TwoFactorMethodUserAggregateInput>>;
  NOT?: InputMaybe<TwoFactorMethodUserAggregateInput>;
  OR?: InputMaybe<Array<TwoFactorMethodUserAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<TwoFactorMethodUserNodeAggregationWhereInput>;
};

export type TwoFactorMethodUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<UserConnectWhere>;
};

export type TwoFactorMethodUserConnection = {
  __typename?: "TwoFactorMethodUserConnection";
  edges: Array<TwoFactorMethodUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type TwoFactorMethodUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type TwoFactorMethodUserConnectionWhere = {
  AND?: InputMaybe<Array<TwoFactorMethodUserConnectionWhere>>;
  NOT?: InputMaybe<TwoFactorMethodUserConnectionWhere>;
  OR?: InputMaybe<Array<TwoFactorMethodUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<UserWhere>;
};

export type TwoFactorMethodUserCreateFieldInput = {
  node: UserCreateInput;
};

export type TwoFactorMethodUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<TwoFactorMethodUserConnectionWhere>;
};

export type TwoFactorMethodUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<TwoFactorMethodUserConnectionWhere>;
};

export type TwoFactorMethodUserFieldInput = {
  connect?: InputMaybe<TwoFactorMethodUserConnectFieldInput>;
  create?: InputMaybe<TwoFactorMethodUserCreateFieldInput>;
};

export type TwoFactorMethodUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TwoFactorMethodUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TwoFactorMethodUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TwoFactorMethodUserNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  invitationFrontendUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  invitationFrontendUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  invitationFrontendUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  invitationFrontendUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  invitationFrontendUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  invitationFrontendUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  invitationOtpValidUntil_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  newEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  newEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  newEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  newEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  newEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  newEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  passwordChangedAt_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  preferredTheme_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  preferredTheme_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  preferredTheme_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  preferredTheme_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  preferredTheme_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  preferredTheme_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  recoveryCodesGeneratedAt_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type TwoFactorMethodUserRelationship = {
  __typename?: "TwoFactorMethodUserRelationship";
  cursor: Scalars["String"]["output"];
  node: User;
};

export type TwoFactorMethodUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type TwoFactorMethodUserUpdateFieldInput = {
  connect?: InputMaybe<TwoFactorMethodUserConnectFieldInput>;
  create?: InputMaybe<TwoFactorMethodUserCreateFieldInput>;
  delete?: InputMaybe<TwoFactorMethodUserDeleteFieldInput>;
  disconnect?: InputMaybe<TwoFactorMethodUserDisconnectFieldInput>;
  update?: InputMaybe<TwoFactorMethodUserUpdateConnectionInput>;
  where?: InputMaybe<TwoFactorMethodUserConnectionWhere>;
};

export type TwoFactorMethodWhere = {
  AND?: InputMaybe<Array<TwoFactorMethodWhere>>;
  NOT?: InputMaybe<TwoFactorMethodWhere>;
  OR?: InputMaybe<Array<TwoFactorMethodWhere>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  name_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  name_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  name_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<TwoFactorMethodType>;
  type_IN?: InputMaybe<Array<TwoFactorMethodType>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT?: InputMaybe<TwoFactorMethodType>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT_IN?: InputMaybe<Array<TwoFactorMethodType>>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<TwoFactorMethodUserAggregateInput>;
  userConnection?: InputMaybe<TwoFactorMethodUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<TwoFactorMethodUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
  uuid?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UniqueOrganizationWhere = {
  uuid: Scalars["String"]["input"];
};

export type UnsetPropertyMutationResponse = {
  __typename?: "UnsetPropertyMutationResponse";
  unset: Scalars["Boolean"]["output"];
};

export type UpdateApplicationsMutationResponse = {
  __typename?: "UpdateApplicationsMutationResponse";
  applications: Array<Application>;
  info: UpdateInfo;
};

export type UpdateAuthClientsMutationResponse = {
  __typename?: "UpdateAuthClientsMutationResponse";
  authClients: Array<AuthClient>;
};

export type UpdateFederatedClientsMutationResponse = {
  __typename?: "UpdateFederatedClientsMutationResponse";
  federatedClients: Array<FederatedClient>;
  info: UpdateInfo;
};

export type UpdateGroupsMutationResponse = {
  __typename?: "UpdateGroupsMutationResponse";
  groups: Array<Group>;
  info: UpdateInfo;
};

/** Information about the number of nodes and relationships created and deleted during an update mutation */
export type UpdateInfo = {
  __typename?: "UpdateInfo";
  nodesCreated: Scalars["Int"]["output"];
  nodesDeleted: Scalars["Int"]["output"];
  relationshipsCreated: Scalars["Int"]["output"];
  relationshipsDeleted: Scalars["Int"]["output"];
};

export type UpdateOrganizationsMutationResponse = {
  __typename?: "UpdateOrganizationsMutationResponse";
  info: UpdateInfo;
  organizations: Array<Organization>;
};

export type UpdatePasswordsMutationResponse = {
  __typename?: "UpdatePasswordsMutationResponse";
  users: Array<MinimalUser>;
};

export type UpdateProfileSharesMutationResponse = {
  __typename?: "UpdateProfileSharesMutationResponse";
  info: UpdateInfo;
  profileShares: Array<ProfileShare>;
};

export type UpdateProfilesMutationResponse = {
  __typename?: "UpdateProfilesMutationResponse";
  info: UpdateInfo;
  profiles: Array<Profile>;
};

export type UpdatePropertiesMutationResponse = {
  __typename?: "UpdatePropertiesMutationResponse";
  info: UpdateInfo;
  properties: Array<Property>;
};

export type UpdateUsersMutationResponse = {
  __typename?: "UpdateUsersMutationResponse";
  info: UpdateInfo;
  users: Array<User>;
};

export type User = {
  __typename?: "User";
  email: Scalars["String"]["output"];
  emailLower: Scalars["String"]["output"];
  emailVerified: Scalars["Boolean"]["output"];
  federatedClient: Array<FederatedClient>;
  federatedClientConnection: UserFederatedClientConnection;
  impersonateOnly?: Maybe<Scalars["Boolean"]["output"]>;
  invitationFrontendUrl?: Maybe<Scalars["String"]["output"]>;
  invitationOtpValidUntil?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Timestamp of the most recent successful login (derived from the LOGIN_SUCCEEDED
   * audit events emitted by pim-auth-server). Null if none within retention.
   */
  lastLogin?: Maybe<Scalars["DateTime"]["output"]>;
  newEmail?: Maybe<Scalars["String"]["output"]>;
  newEmailOtpValidUntil?: Maybe<Scalars["DateTime"]["output"]>;
  passwordChangedAt?: Maybe<Scalars["DateTime"]["output"]>;
  preferredLanguage?: Maybe<Scalars["String"]["output"]>;
  preferredTheme?: Maybe<Scalars["String"]["output"]>;
  profiles: Array<Profile>;
  profilesConnection: UserProfilesConnection;
  properties: Array<Property>;
  propertiesConnection: UserPropertiesConnection;
  recoveryCodesGeneratedAt?: Maybe<Scalars["DateTime"]["output"]>;
  resetPasswordOtpValidUntil?: Maybe<Scalars["DateTime"]["output"]>;
  twoFactorMethods: Array<TwoFactorMethod>;
  twoFactorMethodsConnection: UserTwoFactorMethodsConnection;
  uuid: Scalars["ID"]["output"];
};

export type UserFederatedClientArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<FederatedClientOptions>;
  where?: InputMaybe<FederatedClientWhere>;
};

export type UserFederatedClientConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<UserFederatedClientConnectionSort>>;
  where?: InputMaybe<UserFederatedClientConnectionWhere>;
};

export type UserProfilesArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type UserProfilesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<UserProfilesConnectionSort>>;
  where?: InputMaybe<UserProfilesConnectionWhere>;
};

export type UserPropertiesArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<PropertyOptions>;
  where?: InputMaybe<PropertyWhere>;
};

export type UserPropertiesConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<UserPropertiesConnectionSort>>;
  where?: InputMaybe<UserPropertiesConnectionWhere>;
};

export type UserTwoFactorMethodsArgs = {
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<TwoFactorMethodOptions>;
  where?: InputMaybe<TwoFactorMethodWhere>;
};

export type UserTwoFactorMethodsConnectionArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  directed?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<UserTwoFactorMethodsConnectionSort>>;
  where?: InputMaybe<UserTwoFactorMethodsConnectionWhere>;
};

export type UserAggregateSelection = {
  __typename?: "UserAggregateSelection";
  count: Scalars["Int"]["output"];
  email: StringAggregateSelection;
  invitationFrontendUrl: StringAggregateSelection;
  invitationOtpValidUntil: DateTimeAggregateSelection;
  newEmail: StringAggregateSelection;
  newEmailOtpValidUntil: DateTimeAggregateSelection;
  passwordChangedAt: DateTimeAggregateSelection;
  preferredLanguage: StringAggregateSelection;
  preferredTheme: StringAggregateSelection;
  recoveryCodesGeneratedAt: DateTimeAggregateSelection;
  resetPasswordOtpValidUntil: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type UserConnectInput = {
  federatedClient?: InputMaybe<Array<UserFederatedClientConnectFieldInput>>;
  profiles?: InputMaybe<Array<UserProfilesConnectFieldInput>>;
  properties?: InputMaybe<Array<UserPropertiesConnectFieldInput>>;
  twoFactorMethods?: InputMaybe<Array<UserTwoFactorMethodsConnectFieldInput>>;
};

export type UserConnectWhere = {
  node: UserWhere;
};

export type UserCreateInput = {
  email: Scalars["String"]["input"];
  emailVerified: Scalars["Boolean"]["input"];
  federatedClient?: InputMaybe<UserFederatedClientFieldInput>;
  impersonateOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  invitationFrontendUrl?: InputMaybe<Scalars["String"]["input"]>;
  invitationOtpValidUntil?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmail?: InputMaybe<Scalars["String"]["input"]>;
  newEmailOtpValidUntil?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  preferredLanguage?: InputMaybe<Scalars["String"]["input"]>;
  preferredTheme?: InputMaybe<Scalars["String"]["input"]>;
  profiles?: InputMaybe<UserProfilesFieldInput>;
  properties?: InputMaybe<UserPropertiesFieldInput>;
  recoveryCodesGeneratedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil?: InputMaybe<Scalars["DateTime"]["input"]>;
  twoFactorMethods?: InputMaybe<UserTwoFactorMethodsFieldInput>;
};

export type UserDeleteInput = {
  federatedClient?: InputMaybe<Array<UserFederatedClientDeleteFieldInput>>;
  profiles?: InputMaybe<Array<UserProfilesDeleteFieldInput>>;
  properties?: InputMaybe<Array<UserPropertiesDeleteFieldInput>>;
  twoFactorMethods?: InputMaybe<Array<UserTwoFactorMethodsDeleteFieldInput>>;
};

export type UserDisconnectInput = {
  federatedClient?: InputMaybe<Array<UserFederatedClientDisconnectFieldInput>>;
  profiles?: InputMaybe<Array<UserProfilesDisconnectFieldInput>>;
  properties?: InputMaybe<Array<UserPropertiesDisconnectFieldInput>>;
  twoFactorMethods?: InputMaybe<Array<UserTwoFactorMethodsDisconnectFieldInput>>;
};

export type UserEdge = {
  __typename?: "UserEdge";
  cursor: Scalars["String"]["output"];
  node: User;
};

export type UserFederatedClientAggregateInput = {
  AND?: InputMaybe<Array<UserFederatedClientAggregateInput>>;
  NOT?: InputMaybe<UserFederatedClientAggregateInput>;
  OR?: InputMaybe<Array<UserFederatedClientAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  edge?: InputMaybe<FederatedClientPropertiesAggregationWhereInput>;
  node?: InputMaybe<UserFederatedClientNodeAggregationWhereInput>;
};

export type UserFederatedClientConnectFieldInput = {
  edge: FederatedClientPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<FederatedClientConnectWhere>;
};

export type UserFederatedClientConnection = {
  __typename?: "UserFederatedClientConnection";
  edges: Array<UserFederatedClientRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type UserFederatedClientConnectionSort = {
  edge?: InputMaybe<FederatedClientPropertiesSort>;
  node?: InputMaybe<FederatedClientSort>;
};

export type UserFederatedClientConnectionWhere = {
  AND?: InputMaybe<Array<UserFederatedClientConnectionWhere>>;
  NOT?: InputMaybe<UserFederatedClientConnectionWhere>;
  OR?: InputMaybe<Array<UserFederatedClientConnectionWhere>>;
  edge?: InputMaybe<FederatedClientPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<FederatedClientPropertiesWhere>;
  node?: InputMaybe<FederatedClientWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<FederatedClientWhere>;
};

export type UserFederatedClientCreateFieldInput = {
  edge: FederatedClientPropertiesCreateInput;
  node: FederatedClientCreateInput;
};

export type UserFederatedClientDeleteFieldInput = {
  where?: InputMaybe<UserFederatedClientConnectionWhere>;
};

export type UserFederatedClientDisconnectFieldInput = {
  where?: InputMaybe<UserFederatedClientConnectionWhere>;
};

export type UserFederatedClientFieldInput = {
  connect?: InputMaybe<Array<UserFederatedClientConnectFieldInput>>;
  create?: InputMaybe<Array<UserFederatedClientCreateFieldInput>>;
};

export type UserFederatedClientNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserFederatedClientNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserFederatedClientNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserFederatedClientNodeAggregationWhereInput>>;
  clientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  clientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  clientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  clientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  clientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  clientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  clientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  clientSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  clientSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  clientSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  clientSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  clientSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  clientSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  issuer_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  issuer_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  issuer_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  issuer_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  issuer_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  issuer_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserFederatedClientRelationship = {
  __typename?: "UserFederatedClientRelationship";
  cursor: Scalars["String"]["output"];
  node: FederatedClient;
  properties: FederatedClientProperties;
};

export type UserFederatedClientUpdateConnectionInput = {
  edge?: InputMaybe<FederatedClientPropertiesUpdateInput>;
  node?: InputMaybe<FederatedClientUpdateInput>;
};

export type UserFederatedClientUpdateFieldInput = {
  connect?: InputMaybe<Array<UserFederatedClientConnectFieldInput>>;
  create?: InputMaybe<Array<UserFederatedClientCreateFieldInput>>;
  delete?: InputMaybe<Array<UserFederatedClientDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserFederatedClientDisconnectFieldInput>>;
  update?: InputMaybe<UserFederatedClientUpdateConnectionInput>;
  where?: InputMaybe<UserFederatedClientConnectionWhere>;
};

export type UserOptions = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Specify one or more UserSort objects to sort Users by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserSort>>;
};

export type UserProfilesAggregateInput = {
  AND?: InputMaybe<Array<UserProfilesAggregateInput>>;
  NOT?: InputMaybe<UserProfilesAggregateInput>;
  OR?: InputMaybe<Array<UserProfilesAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<UserProfilesNodeAggregationWhereInput>;
};

export type UserProfilesConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  edge?: InputMaybe<ProfileRelationPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type UserProfilesConnection = {
  __typename?: "UserProfilesConnection";
  edges: Array<UserProfilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type UserProfilesConnectionSort = {
  edge?: InputMaybe<ProfileRelationPropertiesSort>;
  node?: InputMaybe<ProfileSort>;
};

export type UserProfilesConnectionWhere = {
  AND?: InputMaybe<Array<UserProfilesConnectionWhere>>;
  NOT?: InputMaybe<UserProfilesConnectionWhere>;
  OR?: InputMaybe<Array<UserProfilesConnectionWhere>>;
  edge?: InputMaybe<ProfileRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<ProfileRelationPropertiesWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type UserProfilesCreateFieldInput = {
  edge?: InputMaybe<ProfileRelationPropertiesCreateInput>;
  node: ProfileCreateInput;
};

export type UserProfilesDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<UserProfilesConnectionWhere>;
};

export type UserProfilesDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<UserProfilesConnectionWhere>;
};

export type UserProfilesFieldInput = {
  connect?: InputMaybe<Array<UserProfilesConnectFieldInput>>;
  create?: InputMaybe<Array<UserProfilesCreateFieldInput>>;
};

export type UserProfilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserProfilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserProfilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserProfilesNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tecartPersonId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosAccepted_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MAX_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosAccepted_MIN_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  tosVersion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  tosVersion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  tosVersion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserProfilesRelationship = {
  __typename?: "UserProfilesRelationship";
  cursor: Scalars["String"]["output"];
  node: Profile;
  properties: ProfileRelationProperties;
};

export type UserProfilesUpdateConnectionInput = {
  edge?: InputMaybe<ProfileRelationPropertiesUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type UserProfilesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserProfilesConnectFieldInput>>;
  create?: InputMaybe<Array<UserProfilesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserProfilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserProfilesDisconnectFieldInput>>;
  update?: InputMaybe<UserProfilesUpdateConnectionInput>;
  where?: InputMaybe<UserProfilesConnectionWhere>;
};

export type UserPropertiesAggregateInput = {
  AND?: InputMaybe<Array<UserPropertiesAggregateInput>>;
  NOT?: InputMaybe<UserPropertiesAggregateInput>;
  OR?: InputMaybe<Array<UserPropertiesAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  edge?: InputMaybe<PropertiesScopeAggregationWhereInput>;
  node?: InputMaybe<UserPropertiesNodeAggregationWhereInput>;
};

export type UserPropertiesConnectFieldInput = {
  connect?: InputMaybe<Array<PropertyConnectInput>>;
  edge: PropertiesScopeCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<PropertyConnectWhere>;
};

export type UserPropertiesConnection = {
  __typename?: "UserPropertiesConnection";
  edges: Array<UserPropertiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type UserPropertiesConnectionSort = {
  edge?: InputMaybe<PropertiesScopeSort>;
  node?: InputMaybe<PropertySort>;
};

export type UserPropertiesConnectionWhere = {
  AND?: InputMaybe<Array<UserPropertiesConnectionWhere>>;
  NOT?: InputMaybe<UserPropertiesConnectionWhere>;
  OR?: InputMaybe<Array<UserPropertiesConnectionWhere>>;
  edge?: InputMaybe<PropertiesScopeWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PropertiesScopeWhere>;
  node?: InputMaybe<PropertyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PropertyWhere>;
};

export type UserPropertiesCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: PropertyCreateInput;
};

export type UserPropertiesDeleteFieldInput = {
  delete?: InputMaybe<PropertyDeleteInput>;
  where?: InputMaybe<UserPropertiesConnectionWhere>;
};

export type UserPropertiesDisconnectFieldInput = {
  disconnect?: InputMaybe<PropertyDisconnectInput>;
  where?: InputMaybe<UserPropertiesConnectionWhere>;
};

export type UserPropertiesFieldInput = {
  connect?: InputMaybe<Array<UserPropertiesConnectFieldInput>>;
  create?: InputMaybe<Array<UserPropertiesCreateFieldInput>>;
};

export type UserPropertiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserPropertiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserPropertiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserPropertiesNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  value_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  value_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  value_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  value_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserPropertiesRelationship = {
  __typename?: "UserPropertiesRelationship";
  cursor: Scalars["String"]["output"];
  node: Property;
  properties: PropertiesScope;
};

export type UserPropertiesUpdateConnectionInput = {
  edge?: InputMaybe<PropertiesScopeUpdateInput>;
  node?: InputMaybe<PropertyUpdateInput>;
};

export type UserPropertiesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserPropertiesConnectFieldInput>>;
  create?: InputMaybe<Array<UserPropertiesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserPropertiesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserPropertiesDisconnectFieldInput>>;
  update?: InputMaybe<UserPropertiesUpdateConnectionInput>;
  where?: InputMaybe<UserPropertiesConnectionWhere>;
};

/** Fields to sort Users by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserSort object. */
export type UserSort = {
  email?: InputMaybe<SortDirection>;
  emailLower?: InputMaybe<SortDirection>;
  emailVerified?: InputMaybe<SortDirection>;
  impersonateOnly?: InputMaybe<SortDirection>;
  invitationFrontendUrl?: InputMaybe<SortDirection>;
  invitationOtpValidUntil?: InputMaybe<SortDirection>;
  lastLogin?: InputMaybe<SortDirection>;
  newEmail?: InputMaybe<SortDirection>;
  newEmailOtpValidUntil?: InputMaybe<SortDirection>;
  passwordChangedAt?: InputMaybe<SortDirection>;
  preferredLanguage?: InputMaybe<SortDirection>;
  preferredTheme?: InputMaybe<SortDirection>;
  recoveryCodesGeneratedAt?: InputMaybe<SortDirection>;
  resetPasswordOtpValidUntil?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type UserTwoFactorMethodsAggregateInput = {
  AND?: InputMaybe<Array<UserTwoFactorMethodsAggregateInput>>;
  NOT?: InputMaybe<UserTwoFactorMethodsAggregateInput>;
  OR?: InputMaybe<Array<UserTwoFactorMethodsAggregateInput>>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  count_GT?: InputMaybe<Scalars["Int"]["input"]>;
  count_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  count_LT?: InputMaybe<Scalars["Int"]["input"]>;
  count_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  node?: InputMaybe<UserTwoFactorMethodsNodeAggregationWhereInput>;
};

export type UserTwoFactorMethodsConnectFieldInput = {
  connect?: InputMaybe<Array<TwoFactorMethodConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars["Boolean"]["input"];
  where?: InputMaybe<TwoFactorMethodConnectWhere>;
};

export type UserTwoFactorMethodsConnection = {
  __typename?: "UserTwoFactorMethodsConnection";
  edges: Array<UserTwoFactorMethodsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type UserTwoFactorMethodsConnectionSort = {
  node?: InputMaybe<TwoFactorMethodSort>;
};

export type UserTwoFactorMethodsConnectionWhere = {
  AND?: InputMaybe<Array<UserTwoFactorMethodsConnectionWhere>>;
  NOT?: InputMaybe<UserTwoFactorMethodsConnectionWhere>;
  OR?: InputMaybe<Array<UserTwoFactorMethodsConnectionWhere>>;
  node?: InputMaybe<TwoFactorMethodWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TwoFactorMethodWhere>;
};

export type UserTwoFactorMethodsCreateFieldInput = {
  node: TwoFactorMethodCreateInput;
};

export type UserTwoFactorMethodsDeleteFieldInput = {
  delete?: InputMaybe<TwoFactorMethodDeleteInput>;
  where?: InputMaybe<UserTwoFactorMethodsConnectionWhere>;
};

export type UserTwoFactorMethodsDisconnectFieldInput = {
  disconnect?: InputMaybe<TwoFactorMethodDisconnectInput>;
  where?: InputMaybe<UserTwoFactorMethodsConnectionWhere>;
};

export type UserTwoFactorMethodsFieldInput = {
  connect?: InputMaybe<Array<UserTwoFactorMethodsConnectFieldInput>>;
  create?: InputMaybe<Array<UserTwoFactorMethodsCreateFieldInput>>;
};

export type UserTwoFactorMethodsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserTwoFactorMethodsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserTwoFactorMethodsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserTwoFactorMethodsNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars["Float"]["input"]>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars["Float"]["input"]>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars["Int"]["input"]>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserTwoFactorMethodsRelationship = {
  __typename?: "UserTwoFactorMethodsRelationship";
  cursor: Scalars["String"]["output"];
  node: TwoFactorMethod;
};

export type UserTwoFactorMethodsUpdateConnectionInput = {
  node?: InputMaybe<TwoFactorMethodUpdateInput>;
};

export type UserTwoFactorMethodsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserTwoFactorMethodsConnectFieldInput>>;
  create?: InputMaybe<Array<UserTwoFactorMethodsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserTwoFactorMethodsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserTwoFactorMethodsDisconnectFieldInput>>;
  update?: InputMaybe<UserTwoFactorMethodsUpdateConnectionInput>;
  where?: InputMaybe<UserTwoFactorMethodsConnectionWhere>;
};

export type UserUpdateInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  federatedClient?: InputMaybe<Array<UserFederatedClientUpdateFieldInput>>;
  impersonateOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  invitationFrontendUrl?: InputMaybe<Scalars["String"]["input"]>;
  invitationOtpValidUntil?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmail?: InputMaybe<Scalars["String"]["input"]>;
  newEmailOtpValidUntil?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  preferredLanguage?: InputMaybe<Scalars["String"]["input"]>;
  preferredTheme?: InputMaybe<Scalars["String"]["input"]>;
  profiles?: InputMaybe<Array<UserProfilesUpdateFieldInput>>;
  properties?: InputMaybe<Array<UserPropertiesUpdateFieldInput>>;
  recoveryCodesGeneratedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil?: InputMaybe<Scalars["DateTime"]["input"]>;
  twoFactorMethods?: InputMaybe<Array<UserTwoFactorMethodsUpdateFieldInput>>;
};

export type UserWhere = {
  AND?: InputMaybe<Array<UserWhere>>;
  NOT?: InputMaybe<UserWhere>;
  OR?: InputMaybe<Array<UserWhere>>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  emailLower?: InputMaybe<Scalars["String"]["input"]>;
  emailLower_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  emailLower_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  emailLower_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailLower_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailLower_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailLower_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailLower_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailLower_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  emailLower_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  emailVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailVerified_NOT?: InputMaybe<Scalars["Boolean"]["input"]>;
  email_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  email_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  email_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_IN?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  email_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Use `federatedClient_SOME` instead. */
  federatedClient?: InputMaybe<FederatedClientWhere>;
  federatedClientAggregate?: InputMaybe<UserFederatedClientAggregateInput>;
  /** @deprecated Use `federatedClientConnection_SOME` instead. */
  federatedClientConnection?: InputMaybe<UserFederatedClientConnectionWhere>;
  /** Return Users where all of the related UserFederatedClientConnections match this filter */
  federatedClientConnection_ALL?: InputMaybe<UserFederatedClientConnectionWhere>;
  /** Return Users where none of the related UserFederatedClientConnections match this filter */
  federatedClientConnection_NONE?: InputMaybe<UserFederatedClientConnectionWhere>;
  /** @deprecated Use `federatedClientConnection_NONE` instead. */
  federatedClientConnection_NOT?: InputMaybe<UserFederatedClientConnectionWhere>;
  /** Return Users where one of the related UserFederatedClientConnections match this filter */
  federatedClientConnection_SINGLE?: InputMaybe<UserFederatedClientConnectionWhere>;
  /** Return Users where some of the related UserFederatedClientConnections match this filter */
  federatedClientConnection_SOME?: InputMaybe<UserFederatedClientConnectionWhere>;
  /** Return Users where all of the related FederatedClients match this filter */
  federatedClient_ALL?: InputMaybe<FederatedClientWhere>;
  /** Return Users where none of the related FederatedClients match this filter */
  federatedClient_NONE?: InputMaybe<FederatedClientWhere>;
  /** @deprecated Use `federatedClient_NONE` instead. */
  federatedClient_NOT?: InputMaybe<FederatedClientWhere>;
  /** Return Users where one of the related FederatedClients match this filter */
  federatedClient_SINGLE?: InputMaybe<FederatedClientWhere>;
  /** Return Users where some of the related FederatedClients match this filter */
  federatedClient_SOME?: InputMaybe<FederatedClientWhere>;
  impersonateOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  impersonateOnly_NOT?: InputMaybe<Scalars["Boolean"]["input"]>;
  invitationFrontendUrl?: InputMaybe<Scalars["String"]["input"]>;
  invitationFrontendUrl_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  invitationFrontendUrl_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  invitationFrontendUrl_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationFrontendUrl_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationFrontendUrl_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationFrontendUrl_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationFrontendUrl_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationFrontendUrl_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  invitationFrontendUrl_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  invitationOtpValidUntil?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  invitationOtpValidUntil_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  invitationOtpValidUntil_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationOtpValidUntil_NOT?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationOtpValidUntil_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  lastLogin?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastLogin_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastLogin_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastLogin_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  lastLogin_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastLogin_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastLogin_NOT?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastLogin_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  newEmail?: InputMaybe<Scalars["String"]["input"]>;
  newEmailOtpValidUntil?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  newEmailOtpValidUntil_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  newEmailOtpValidUntil_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmailOtpValidUntil_NOT?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmailOtpValidUntil_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  newEmail_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  newEmail_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  newEmail_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmail_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmail_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmail_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmail_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmail_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  newEmail_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  passwordChangedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  passwordChangedAt_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  passwordChangedAt_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  passwordChangedAt_NOT?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  passwordChangedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  preferredLanguage?: InputMaybe<Scalars["String"]["input"]>;
  preferredLanguage_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  preferredLanguage_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  preferredLanguage_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredLanguage_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredLanguage_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredLanguage_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredLanguage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredLanguage_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  preferredLanguage_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  preferredTheme?: InputMaybe<Scalars["String"]["input"]>;
  preferredTheme_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  preferredTheme_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  preferredTheme_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredTheme_NOT?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredTheme_NOT_CONTAINS?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredTheme_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredTheme_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredTheme_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  preferredTheme_STARTS_WITH?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Use `profiles_SOME` instead. */
  profiles?: InputMaybe<ProfileWhere>;
  profilesAggregate?: InputMaybe<UserProfilesAggregateInput>;
  /** @deprecated Use `profilesConnection_SOME` instead. */
  profilesConnection?: InputMaybe<UserProfilesConnectionWhere>;
  /** Return Users where all of the related UserProfilesConnections match this filter */
  profilesConnection_ALL?: InputMaybe<UserProfilesConnectionWhere>;
  /** Return Users where none of the related UserProfilesConnections match this filter */
  profilesConnection_NONE?: InputMaybe<UserProfilesConnectionWhere>;
  /** @deprecated Use `profilesConnection_NONE` instead. */
  profilesConnection_NOT?: InputMaybe<UserProfilesConnectionWhere>;
  /** Return Users where one of the related UserProfilesConnections match this filter */
  profilesConnection_SINGLE?: InputMaybe<UserProfilesConnectionWhere>;
  /** Return Users where some of the related UserProfilesConnections match this filter */
  profilesConnection_SOME?: InputMaybe<UserProfilesConnectionWhere>;
  /** Return Users where all of the related Profiles match this filter */
  profiles_ALL?: InputMaybe<ProfileWhere>;
  /** Return Users where none of the related Profiles match this filter */
  profiles_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `profiles_NONE` instead. */
  profiles_NOT?: InputMaybe<ProfileWhere>;
  /** Return Users where one of the related Profiles match this filter */
  profiles_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return Users where some of the related Profiles match this filter */
  profiles_SOME?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `properties_SOME` instead. */
  properties?: InputMaybe<PropertyWhere>;
  propertiesAggregate?: InputMaybe<UserPropertiesAggregateInput>;
  /** @deprecated Use `propertiesConnection_SOME` instead. */
  propertiesConnection?: InputMaybe<UserPropertiesConnectionWhere>;
  /** Return Users where all of the related UserPropertiesConnections match this filter */
  propertiesConnection_ALL?: InputMaybe<UserPropertiesConnectionWhere>;
  /** Return Users where none of the related UserPropertiesConnections match this filter */
  propertiesConnection_NONE?: InputMaybe<UserPropertiesConnectionWhere>;
  /** @deprecated Use `propertiesConnection_NONE` instead. */
  propertiesConnection_NOT?: InputMaybe<UserPropertiesConnectionWhere>;
  /** Return Users where one of the related UserPropertiesConnections match this filter */
  propertiesConnection_SINGLE?: InputMaybe<UserPropertiesConnectionWhere>;
  /** Return Users where some of the related UserPropertiesConnections match this filter */
  propertiesConnection_SOME?: InputMaybe<UserPropertiesConnectionWhere>;
  /** Return Users where all of the related Properties match this filter */
  properties_ALL?: InputMaybe<PropertyWhere>;
  /** Return Users where none of the related Properties match this filter */
  properties_NONE?: InputMaybe<PropertyWhere>;
  /** @deprecated Use `properties_NONE` instead. */
  properties_NOT?: InputMaybe<PropertyWhere>;
  /** Return Users where one of the related Properties match this filter */
  properties_SINGLE?: InputMaybe<PropertyWhere>;
  /** Return Users where some of the related Properties match this filter */
  properties_SOME?: InputMaybe<PropertyWhere>;
  recoveryCodesGeneratedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  recoveryCodesGeneratedAt_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  recoveryCodesGeneratedAt_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  recoveryCodesGeneratedAt_NOT?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  recoveryCodesGeneratedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  resetPasswordOtpValidUntil?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_GT?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_GTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  resetPasswordOtpValidUntil_LT?: InputMaybe<Scalars["DateTime"]["input"]>;
  resetPasswordOtpValidUntil_LTE?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  resetPasswordOtpValidUntil_NOT?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  resetPasswordOtpValidUntil_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  /** @deprecated Use `twoFactorMethods_SOME` instead. */
  twoFactorMethods?: InputMaybe<TwoFactorMethodWhere>;
  twoFactorMethodsAggregate?: InputMaybe<UserTwoFactorMethodsAggregateInput>;
  /** @deprecated Use `twoFactorMethodsConnection_SOME` instead. */
  twoFactorMethodsConnection?: InputMaybe<UserTwoFactorMethodsConnectionWhere>;
  /** Return Users where all of the related UserTwoFactorMethodsConnections match this filter */
  twoFactorMethodsConnection_ALL?: InputMaybe<UserTwoFactorMethodsConnectionWhere>;
  /** Return Users where none of the related UserTwoFactorMethodsConnections match this filter */
  twoFactorMethodsConnection_NONE?: InputMaybe<UserTwoFactorMethodsConnectionWhere>;
  /** @deprecated Use `twoFactorMethodsConnection_NONE` instead. */
  twoFactorMethodsConnection_NOT?: InputMaybe<UserTwoFactorMethodsConnectionWhere>;
  /** Return Users where one of the related UserTwoFactorMethodsConnections match this filter */
  twoFactorMethodsConnection_SINGLE?: InputMaybe<UserTwoFactorMethodsConnectionWhere>;
  /** Return Users where some of the related UserTwoFactorMethodsConnections match this filter */
  twoFactorMethodsConnection_SOME?: InputMaybe<UserTwoFactorMethodsConnectionWhere>;
  /** Return Users where all of the related TwoFactorMethods match this filter */
  twoFactorMethods_ALL?: InputMaybe<TwoFactorMethodWhere>;
  /** Return Users where none of the related TwoFactorMethods match this filter */
  twoFactorMethods_NONE?: InputMaybe<TwoFactorMethodWhere>;
  /** @deprecated Use `twoFactorMethods_NONE` instead. */
  twoFactorMethods_NOT?: InputMaybe<TwoFactorMethodWhere>;
  /** Return Users where one of the related TwoFactorMethods match this filter */
  twoFactorMethods_SINGLE?: InputMaybe<TwoFactorMethodWhere>;
  /** Return Users where some of the related TwoFactorMethods match this filter */
  twoFactorMethods_SOME?: InputMaybe<TwoFactorMethodWhere>;
  uuid?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
  uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UsersConnection = {
  __typename?: "UsersConnection";
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};
